import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `Long` scalar type represents 52-bit integers */
  Long: any;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
  /** A time string with format: HH:mm:ss.SSS */
  Time: any;
};


export type Query = {
  __typename?: 'Query';
  billingdetail?: Maybe<Billingdetail>;
  billingdetails?: Maybe<Array<Maybe<Billingdetail>>>;
  billingdetailsConnection?: Maybe<BillingdetailConnection>;
  brand?: Maybe<Brand>;
  brands?: Maybe<Array<Maybe<Brand>>>;
  brandsConnection?: Maybe<BrandConnection>;
  cart?: Maybe<Cart>;
  carts?: Maybe<Array<Maybe<Cart>>>;
  cartsConnection?: Maybe<CartConnection>;
  catTypeTag?: Maybe<CatTypeTag>;
  catTypeTags?: Maybe<Array<Maybe<CatTypeTag>>>;
  catTypeTagsConnection?: Maybe<CatTypeTagConnection>;
  category?: Maybe<Category>;
  categories?: Maybe<Array<Maybe<Category>>>;
  categoriesConnection?: Maybe<CategoryConnection>;
  city?: Maybe<City>;
  cities?: Maybe<Array<Maybe<City>>>;
  citiesConnection?: Maybe<CityConnection>;
  colorCat?: Maybe<ColorCat>;
  colorCats?: Maybe<Array<Maybe<ColorCat>>>;
  colorCatsConnection?: Maybe<ColorCatConnection>;
  colorImage?: Maybe<ColorImage>;
  colorImages?: Maybe<Array<Maybe<ColorImage>>>;
  colorImagesConnection?: Maybe<ColorImageConnection>;
  color?: Maybe<Color>;
  colors?: Maybe<Array<Maybe<Color>>>;
  colorsConnection?: Maybe<ColorConnection>;
  contact?: Maybe<Contact>;
  contacts?: Maybe<Array<Maybe<Contact>>>;
  contactsConnection?: Maybe<ContactConnection>;
  customer?: Maybe<Customer>;
  customers?: Maybe<Array<Maybe<Customer>>>;
  customersConnection?: Maybe<CustomerConnection>;
  district?: Maybe<District>;
  districts?: Maybe<Array<Maybe<District>>>;
  districtsConnection?: Maybe<DistrictConnection>;
  hitCount?: Maybe<HitCount>;
  hitCounts?: Maybe<Array<Maybe<HitCount>>>;
  hitCountsConnection?: Maybe<HitCountConnection>;
  log?: Maybe<Log>;
  logs?: Maybe<Array<Maybe<Log>>>;
  logsConnection?: Maybe<LogConnection>;
  material?: Maybe<Material>;
  materials?: Maybe<Array<Maybe<Material>>>;
  materialsConnection?: Maybe<MaterialConnection>;
  misc?: Maybe<Misc>;
  miscs?: Maybe<Array<Maybe<Misc>>>;
  miscsConnection?: Maybe<MiscConnection>;
  newsletter?: Maybe<Newsletter>;
  newsletters?: Maybe<Array<Maybe<Newsletter>>>;
  newslettersConnection?: Maybe<NewsletterConnection>;
  notifystock?: Maybe<Notifystock>;
  notifystocks?: Maybe<Array<Maybe<Notifystock>>>;
  notifystocksConnection?: Maybe<NotifystockConnection>;
  orderd?: Maybe<Orderd>;
  orderds?: Maybe<Array<Maybe<Orderd>>>;
  orderdsConnection?: Maybe<OrderdConnection>;
  orderh?: Maybe<Orderh>;
  orderhs?: Maybe<Array<Maybe<Orderh>>>;
  orderhsConnection?: Maybe<OrderhConnection>;
  orderhistory?: Maybe<Orderhistory>;
  orderhistories?: Maybe<Array<Maybe<Orderhistory>>>;
  orderhistoriesConnection?: Maybe<OrderhistoryConnection>;
  paymentselection?: Maybe<Paymentselection>;
  paymentselections?: Maybe<Array<Maybe<Paymentselection>>>;
  paymentselectionsConnection?: Maybe<PaymentselectionConnection>;
  /** Get product */
  product?: Maybe<Product>;
  products?: Maybe<Array<Maybe<Product>>>;
  productsConnection?: Maybe<ProductConnection>;
  productimage?: Maybe<Productimage>;
  productimages?: Maybe<Array<Maybe<Productimage>>>;
  productimagesConnection?: Maybe<ProductimageConnection>;
  province?: Maybe<Province>;
  provinces?: Maybe<Array<Maybe<Province>>>;
  provincesConnection?: Maybe<ProvinceConnection>;
  returnorderd?: Maybe<Returnorderd>;
  returnorderds?: Maybe<Array<Maybe<Returnorderd>>>;
  returnorderdsConnection?: Maybe<ReturnorderdConnection>;
  returnorderh?: Maybe<Returnorderh>;
  returnorderhs?: Maybe<Array<Maybe<Returnorderh>>>;
  returnorderhsConnection?: Maybe<ReturnorderhConnection>;
  review?: Maybe<Review>;
  reviews?: Maybe<Array<Maybe<Review>>>;
  reviewsConnection?: Maybe<ReviewConnection>;
  shippingdetail?: Maybe<Shippingdetail>;
  shippingdetails?: Maybe<Array<Maybe<Shippingdetail>>>;
  shippingdetailsConnection?: Maybe<ShippingdetailConnection>;
  status?: Maybe<Status>;
  statuses?: Maybe<Array<Maybe<Status>>>;
  statusesConnection?: Maybe<StatusConnection>;
  store?: Maybe<Store>;
  stores?: Maybe<Array<Maybe<Store>>>;
  storesConnection?: Maybe<StoreConnection>;
  voucher?: Maybe<Voucher>;
  vouchers?: Maybe<Array<Maybe<Voucher>>>;
  vouchersConnection?: Maybe<VoucherConnection>;
  voucherhistory?: Maybe<Voucherhistory>;
  voucherhistories?: Maybe<Array<Maybe<Voucherhistory>>>;
  voucherhistoriesConnection?: Maybe<VoucherhistoryConnection>;
  warranty?: Maybe<Warranty>;
  warranties?: Maybe<Array<Maybe<Warranty>>>;
  warrantiesConnection?: Maybe<WarrantyConnection>;
  webContent?: Maybe<WebContent>;
  webContents?: Maybe<Array<Maybe<WebContent>>>;
  webContentsConnection?: Maybe<WebContentConnection>;
  wishList?: Maybe<WishList>;
  wishLists?: Maybe<Array<Maybe<WishList>>>;
  wishListsConnection?: Maybe<WishListConnection>;
  files?: Maybe<Array<Maybe<UploadFile>>>;
  filesConnection?: Maybe<UploadFileConnection>;
  role?: Maybe<UsersPermissionsRole>;
  /** Retrieve all the existing roles. You can't apply filters on this query. */
  roles?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  rolesConnection?: Maybe<UsersPermissionsRoleConnection>;
  user?: Maybe<UsersPermissionsUser>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  usersConnection?: Maybe<UsersPermissionsUserConnection>;
  userBillingDetails?: Maybe<Billingdetail>;
  guestBillingDetails?: Maybe<Billingdetail>;
  checkAvailability: Availability;
  profile?: Maybe<Customer>;
  customerOrders: Array<Maybe<Orderh>>;
  orderStatus: Scalars['Int'];
  deliveryPersonOrders: Array<Maybe<DeliveryOrder>>;
  userPaymentSelection?: Maybe<Paymentselection>;
  guestPaymentSelection?: Maybe<Paymentselection>;
  filters?: Maybe<Filters>;
  getLastProductCode: Scalars['String'];
  randomProducts?: Maybe<Array<Maybe<Product>>>;
  userShippingDetails?: Maybe<Shippingdetail>;
  guestShippingDetails?: Maybe<Shippingdetail>;
  me?: Maybe<UsersPermissionsMe>;
};


export type QueryBillingdetailArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryBillingdetailsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryBillingdetailsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryBrandArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryBrandsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryBrandsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCartArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryCartsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCartsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCatTypeTagArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryCatTypeTagsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCatTypeTagsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCategoryArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryCategoriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCategoriesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCityArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryCitiesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCitiesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryColorCatArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryColorCatsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryColorCatsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryColorImageArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryColorImagesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryColorImagesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryColorArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryColorsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryColorsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryContactArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryContactsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryContactsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCustomerArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryCustomersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCustomersConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryDistrictArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryDistrictsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryDistrictsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryHitCountArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryHitCountsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryHitCountsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryLogArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryLogsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryLogsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryMaterialArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryMaterialsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryMaterialsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryMiscArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryMiscsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryMiscsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryNewsletterArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryNewslettersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryNewslettersConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryNotifystockArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryNotifystocksArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryNotifystocksConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryOrderdArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryOrderdsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryOrderdsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryOrderhArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryOrderhsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryOrderhsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryOrderhistoryArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryOrderhistoriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryOrderhistoriesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPaymentselectionArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryPaymentselectionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryPaymentselectionsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryProductArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryProductsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryProductsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryProductimageArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryProductimagesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryProductimagesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryProvinceArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryProvincesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryProvincesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryReturnorderdArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryReturnorderdsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryReturnorderdsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryReturnorderhArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryReturnorderhsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryReturnorderhsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryReviewArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryReviewsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryReviewsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryShippingdetailArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryShippingdetailsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryShippingdetailsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryStatusArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryStatusesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryStatusesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryStoreArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryStoresArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryStoresConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryVoucherArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryVouchersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryVouchersConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryVoucherhistoryArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryVoucherhistoriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryVoucherhistoriesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryWarrantyArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryWarrantiesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryWarrantiesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryWebContentArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryWebContentsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryWebContentsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryWishListArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryWishListsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryWishListsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFilesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryFilesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRoleArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryRolesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryRolesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryUsersConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryOrderStatusArgs = {
  code: Scalars['Int'];
};


export type QueryFiltersArgs = {
  categoryId?: Maybe<Scalars['ID']>;
};

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type Billingdetail = {
  __typename?: 'Billingdetail';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  address1: Scalars['String'];
  address2: Scalars['String'];
  email: Scalars['String'];
  tele1: Scalars['String'];
  tele2?: Maybe<Scalars['String']>;
  city?: Maybe<City>;
  orderh?: Maybe<Orderh>;
  user?: Maybe<UsersPermissionsUser>;
  status?: Maybe<Status>;
  guestid?: Maybe<Scalars['String']>;
};


export type City = {
  __typename?: 'City';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  cityName: Scalars['String'];
  district?: Maybe<District>;
  postalCode: Scalars['String'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  customers?: Maybe<Array<Maybe<Customer>>>;
  shippingdetails?: Maybe<Array<Maybe<Shippingdetail>>>;
  billingdetails?: Maybe<Array<Maybe<Billingdetail>>>;
};


export type CityCustomersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CityShippingdetailsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CityBillingdetailsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type District = {
  __typename?: 'District';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  districtName: Scalars['String'];
  province?: Maybe<Province>;
  deliveryCharge1?: Maybe<Scalars['Float']>;
  deliveryCharge2?: Maybe<Scalars['Float']>;
  deliveryCharge3?: Maybe<Scalars['Float']>;
  deliveryCharge4?: Maybe<Scalars['Float']>;
  cities?: Maybe<Array<Maybe<City>>>;
};


export type DistrictCitiesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type Province = {
  __typename?: 'Province';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  provinceName: Scalars['String'];
  districts?: Maybe<Array<Maybe<District>>>;
};


export type ProvinceDistrictsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type Customer = {
  __typename?: 'Customer';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  user?: Maybe<UsersPermissionsUser>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  city?: Maybe<City>;
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsRole>;
  tele?: Maybe<Scalars['String']>;
  customer?: Maybe<Customer>;
  initialDiscount?: Maybe<Scalars['Boolean']>;
  carts?: Maybe<Array<Maybe<Cart>>>;
  orderhs?: Maybe<Array<Maybe<Orderh>>>;
  shippingdetails?: Maybe<Array<Maybe<Shippingdetail>>>;
  billingdetails?: Maybe<Array<Maybe<Billingdetail>>>;
  paymentselections?: Maybe<Array<Maybe<Paymentselection>>>;
  wish_lists?: Maybe<Array<Maybe<WishList>>>;
  orderds?: Maybe<Array<Maybe<Orderd>>>;
};


export type UsersPermissionsUserCartsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserOrderhsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserShippingdetailsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserBillingdetailsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserPaymentselectionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserWish_ListsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserOrderdsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<UsersPermissionsPermission>>>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
};


export type UsersPermissionsRolePermissionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsRoleUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  id: Scalars['ID'];
  type: Scalars['String'];
  controller: Scalars['String'];
  action: Scalars['String'];
  enabled: Scalars['Boolean'];
  policy?: Maybe<Scalars['String']>;
  role?: Maybe<UsersPermissionsRole>;
};

export type Cart = {
  __typename?: 'Cart';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  qty: Scalars['Float'];
  price: Scalars['Float'];
  product?: Maybe<Product>;
  user?: Maybe<UsersPermissionsUser>;
  color?: Maybe<Color>;
  discount?: Maybe<Scalars['Float']>;
};

export type Product = {
  __typename?: 'Product';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  productCode: Scalars['String'];
  serialNo: Scalars['String'];
  productName: Scalars['String'];
  price?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  brand?: Maybe<Brand>;
  category?: Maybe<Category>;
  featuredItem?: Maybe<Scalars['Boolean']>;
  inactive?: Maybe<Scalars['Boolean']>;
  productDescription: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  spec?: Maybe<Scalars['String']>;
  warranty?: Maybe<Warranty>;
  stock?: Maybe<Scalars['Float']>;
  store?: Maybe<Store>;
  hitCount?: Maybe<Scalars['Long']>;
  isVoucher?: Maybe<Scalars['Boolean']>;
  material?: Maybe<Material>;
  carts?: Maybe<Array<Maybe<Cart>>>;
  productimages?: Maybe<Array<Maybe<Productimage>>>;
  orderds?: Maybe<Array<Maybe<Orderd>>>;
  colors?: Maybe<Array<Maybe<Color>>>;
  color_cats?: Maybe<Array<Maybe<ColorCat>>>;
  wish_lists?: Maybe<Array<Maybe<WishList>>>;
  hit_counts?: Maybe<Array<Maybe<HitCount>>>;
};


export type ProductCartsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProductProductimagesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProductOrderdsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProductColorsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProductColor_CatsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProductWish_ListsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProductHit_CountsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type Brand = {
  __typename?: 'Brand';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  brandName: Scalars['String'];
  inactive?: Maybe<Scalars['Boolean']>;
  products?: Maybe<Array<Maybe<Product>>>;
};


export type BrandProductsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type Category = {
  __typename?: 'Category';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  categoryName: Scalars['String'];
  inactive?: Maybe<Scalars['Boolean']>;
  icon?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  surcharge?: Maybe<Scalars['Float']>;
  products?: Maybe<Array<Maybe<Product>>>;
  cat_type_tags?: Maybe<Array<Maybe<CatTypeTag>>>;
};


export type CategoryProductsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CategoryCat_Type_TagsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type CatTypeTag = {
  __typename?: 'CatTypeTag';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  tagName?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<Category>>>;
};


export type CatTypeTagCategoriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type Warranty = {
  __typename?: 'Warranty';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  warranty?: Maybe<Scalars['String']>;
  inactive?: Maybe<Scalars['Boolean']>;
  products?: Maybe<Array<Maybe<Product>>>;
  color_cats?: Maybe<Array<Maybe<ColorCat>>>;
};


export type WarrantyProductsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type WarrantyColor_CatsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ColorCat = {
  __typename?: 'ColorCat';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  colorCode?: Maybe<Scalars['String']>;
  color?: Maybe<Color>;
  colorPrice?: Maybe<Scalars['Float']>;
  colorStock?: Maybe<Scalars['Int']>;
  product?: Maybe<Product>;
  img?: Maybe<Scalars['String']>;
  colorDiscount?: Maybe<Scalars['Float']>;
  material?: Maybe<Scalars['String']>;
  closure_type?: Maybe<Scalars['String']>;
  lockable?: Maybe<Scalars['String']>;
  laptop_com?: Maybe<Scalars['String']>;
  laptop_size?: Maybe<Scalars['String']>;
  warranty?: Maybe<Warranty>;
  p_length?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
  inActive?: Maybe<Scalars['Boolean']>;
  featured?: Maybe<Scalars['Boolean']>;
  included?: Maybe<Scalars['String']>;
  color_images?: Maybe<Array<Maybe<ColorImage>>>;
};


export type ColorCatColor_ImagesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type Color = {
  __typename?: 'Color';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  colorName?: Maybe<Scalars['String']>;
  colorHex?: Maybe<Scalars['String']>;
  isTwoTone?: Maybe<Scalars['Boolean']>;
  colorHex2?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Maybe<Product>>>;
  carts?: Maybe<Array<Maybe<Cart>>>;
  orderds?: Maybe<Array<Maybe<Orderd>>>;
};


export type ColorProductsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ColorCartsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ColorOrderdsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type OrderdPackageItem = {
  __typename?: 'OrderdPackageItem';
  id: Scalars['ID'];
  product?: Maybe<Product>;
  color?: Maybe<Color>;
  orderd?: Maybe<Orderd>;
};

export type Orderd = {
  __typename?: 'Orderd';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  qty: Scalars['Float'];
  price: Scalars['Float'];
  product?: Maybe<Product>;
  orderh?: Maybe<Orderh>;
  color?: Maybe<Color>;
  deliveryPerson?: Maybe<UsersPermissionsUser>;
  status?: Maybe<Enum_Orderd_Status>;
  discount?: Maybe<Scalars['Float']>;
  orderd_package_items?: Maybe<Array<Maybe<OrderdPackageItem>>>;
};

export type Orderh = {
  __typename?: 'Orderh';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  netAmt: Scalars['Float'];
  orderCode: Scalars['String'];
  user?: Maybe<UsersPermissionsUser>;
  status?: Maybe<Status>;
  paymentId?: Maybe<Scalars['String']>;
  paidAmount?: Maybe<Scalars['Float']>;
  cardName?: Maybe<Scalars['String']>;
  cardExp?: Maybe<Scalars['Int']>;
  cardNo?: Maybe<Scalars['String']>;
  deliveryCost?: Maybe<Scalars['Float']>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  returned?: Maybe<Scalars['Boolean']>;
  voucher?: Maybe<Voucher>;
  specialDiscount?: Maybe<Scalars['Float']>;
  guestid?: Maybe<Scalars['String']>;
  surcharge?: Maybe<Scalars['Float']>;
  orderds?: Maybe<Array<Maybe<Orderd>>>;
  billingdetails?: Maybe<Array<Maybe<Billingdetail>>>;
  shippingdetails?: Maybe<Array<Maybe<Shippingdetail>>>;
  paymentselections?: Maybe<Array<Maybe<Paymentselection>>>;
  orderhistories?: Maybe<Array<Maybe<Orderhistory>>>;
};


export type OrderhOrderdsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type OrderhBillingdetailsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type OrderhShippingdetailsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type OrderhPaymentselectionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type OrderhOrderhistoriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type Status = {
  __typename?: 'Status';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  type?: Maybe<Scalars['String']>;
  billingdetails?: Maybe<Array<Maybe<Billingdetail>>>;
  paymentselections?: Maybe<Array<Maybe<Paymentselection>>>;
  shippingdetails?: Maybe<Array<Maybe<Shippingdetail>>>;
  orderhs?: Maybe<Array<Maybe<Orderh>>>;
  orderhistories?: Maybe<Array<Maybe<Orderhistory>>>;
};


export type StatusBillingdetailsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type StatusPaymentselectionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type StatusShippingdetailsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type StatusOrderhsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type StatusOrderhistoriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type Paymentselection = {
  __typename?: 'Paymentselection';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  method?: Maybe<Enum_Paymentselection_Method>;
  user?: Maybe<UsersPermissionsUser>;
  orderh?: Maybe<Orderh>;
  status?: Maybe<Status>;
  deliveryMethod?: Maybe<Enum_Paymentselection_Deliverymethod>;
  senderName?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  guestid?: Maybe<Scalars['String']>;
  mintpayId?: Maybe<Scalars['String']>;
};

export enum Enum_Paymentselection_Method {
  Phd = 'PHD',
  Cod = 'COD',
  Pps = 'PPS',
  Mhd = 'MHD'
}

export enum Enum_Paymentselection_Deliverymethod {
  Po = 'PO',
  Pd = 'PD'
}

export type Shippingdetail = {
  __typename?: 'Shippingdetail';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  address1: Scalars['String'];
  address2: Scalars['String'];
  email: Scalars['String'];
  city?: Maybe<City>;
  tele1: Scalars['String'];
  tele2?: Maybe<Scalars['String']>;
  useForPayments?: Maybe<Scalars['Boolean']>;
  orderh?: Maybe<Orderh>;
  user?: Maybe<UsersPermissionsUser>;
  status?: Maybe<Status>;
  guestid?: Maybe<Scalars['String']>;
};

export type Orderhistory = {
  __typename?: 'Orderhistory';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  orderh?: Maybe<Orderh>;
  status?: Maybe<Status>;
};

export type Voucher = {
  __typename?: 'Voucher';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  code?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  orderh?: Maybe<Orderh>;
  returnorderh?: Maybe<Returnorderh>;
  price?: Maybe<Scalars['Float']>;
  orderd?: Maybe<Orderd>;
  email?: Maybe<Scalars['String']>;
  validMonth?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  isPercentage?: Maybe<Scalars['Boolean']>;
  voucherhistories?: Maybe<Array<Maybe<Voucherhistory>>>;
};


export type VoucherVoucherhistoriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type Returnorderh = {
  __typename?: 'Returnorderh';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  orderCode?: Maybe<Scalars['String']>;
  netAmt?: Maybe<Scalars['Float']>;
  user?: Maybe<UsersPermissionsUser>;
  status?: Maybe<Status>;
  orderh?: Maybe<Orderh>;
  reason?: Maybe<Enum_Returnorderh_Reason>;
  voucher?: Maybe<Voucher>;
  returnorderds?: Maybe<Array<Maybe<Returnorderd>>>;
};


export type ReturnorderhReturnorderdsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export enum Enum_Returnorderh_Reason {
  Damage = 'damage',
  Product = 'product',
  Color = 'color',
  Quality = 'quality'
}

export type Returnorderd = {
  __typename?: 'Returnorderd';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  qty?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  product?: Maybe<Product>;
  color?: Maybe<Color>;
  returnorderh?: Maybe<Returnorderh>;
  discount?: Maybe<Scalars['Float']>;
};

export type Voucherhistory = {
  __typename?: 'Voucherhistory';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  desp?: Maybe<Scalars['String']>;
  users_permissions_user?: Maybe<UsersPermissionsUser>;
  voucher?: Maybe<Voucher>;
  data?: Maybe<Scalars['JSON']>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export enum Enum_Orderd_Status {
  Delivered = 'DELIVERED',
  SmsReceived = 'SMS_RECEIVED',
  Picked = 'PICKED'
}

export type ColorImage = {
  __typename?: 'ColorImage';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  color_cat?: Maybe<ColorCat>;
  image?: Maybe<Scalars['String']>;
};

export type Store = {
  __typename?: 'Store';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  storeName: Scalars['String'];
  products?: Maybe<Array<Maybe<Product>>>;
};


export type StoreProductsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type Material = {
  __typename?: 'Material';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name: Scalars['String'];
  products?: Maybe<Array<Maybe<Product>>>;
};


export type MaterialProductsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type Productimage = {
  __typename?: 'Productimage';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  image: Scalars['String'];
  product?: Maybe<Product>;
};

export type WishList = {
  __typename?: 'WishList';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  user?: Maybe<UsersPermissionsUser>;
  product?: Maybe<Product>;
};

export type HitCount = {
  __typename?: 'HitCount';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  hit_date?: Maybe<Scalars['Date']>;
  h_count?: Maybe<Scalars['Int']>;
  product?: Maybe<Product>;
  published_at?: Maybe<Scalars['DateTime']>;
};


export type BillingdetailConnection = {
  __typename?: 'BillingdetailConnection';
  values?: Maybe<Array<Maybe<Billingdetail>>>;
  groupBy?: Maybe<BillingdetailGroupBy>;
  aggregate?: Maybe<BillingdetailAggregator>;
};

export type BillingdetailGroupBy = {
  __typename?: 'BillingdetailGroupBy';
  id?: Maybe<Array<Maybe<BillingdetailConnectionId>>>;
  created_at?: Maybe<Array<Maybe<BillingdetailConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<BillingdetailConnectionUpdated_At>>>;
  firstName?: Maybe<Array<Maybe<BillingdetailConnectionFirstName>>>;
  lastName?: Maybe<Array<Maybe<BillingdetailConnectionLastName>>>;
  address1?: Maybe<Array<Maybe<BillingdetailConnectionAddress1>>>;
  address2?: Maybe<Array<Maybe<BillingdetailConnectionAddress2>>>;
  email?: Maybe<Array<Maybe<BillingdetailConnectionEmail>>>;
  tele1?: Maybe<Array<Maybe<BillingdetailConnectionTele1>>>;
  tele2?: Maybe<Array<Maybe<BillingdetailConnectionTele2>>>;
  city?: Maybe<Array<Maybe<BillingdetailConnectionCity>>>;
  orderh?: Maybe<Array<Maybe<BillingdetailConnectionOrderh>>>;
  user?: Maybe<Array<Maybe<BillingdetailConnectionUser>>>;
  status?: Maybe<Array<Maybe<BillingdetailConnectionStatus>>>;
  guestid?: Maybe<Array<Maybe<BillingdetailConnectionGuestid>>>;
};

export type BillingdetailConnectionId = {
  __typename?: 'BillingdetailConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BillingdetailConnection>;
};

export type BillingdetailConnectionCreated_At = {
  __typename?: 'BillingdetailConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BillingdetailConnection>;
};

export type BillingdetailConnectionUpdated_At = {
  __typename?: 'BillingdetailConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BillingdetailConnection>;
};

export type BillingdetailConnectionFirstName = {
  __typename?: 'BillingdetailConnectionFirstName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BillingdetailConnection>;
};

export type BillingdetailConnectionLastName = {
  __typename?: 'BillingdetailConnectionLastName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BillingdetailConnection>;
};

export type BillingdetailConnectionAddress1 = {
  __typename?: 'BillingdetailConnectionAddress1';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BillingdetailConnection>;
};

export type BillingdetailConnectionAddress2 = {
  __typename?: 'BillingdetailConnectionAddress2';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BillingdetailConnection>;
};

export type BillingdetailConnectionEmail = {
  __typename?: 'BillingdetailConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BillingdetailConnection>;
};

export type BillingdetailConnectionTele1 = {
  __typename?: 'BillingdetailConnectionTele1';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BillingdetailConnection>;
};

export type BillingdetailConnectionTele2 = {
  __typename?: 'BillingdetailConnectionTele2';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BillingdetailConnection>;
};

export type BillingdetailConnectionCity = {
  __typename?: 'BillingdetailConnectionCity';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BillingdetailConnection>;
};

export type BillingdetailConnectionOrderh = {
  __typename?: 'BillingdetailConnectionOrderh';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BillingdetailConnection>;
};

export type BillingdetailConnectionUser = {
  __typename?: 'BillingdetailConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BillingdetailConnection>;
};

export type BillingdetailConnectionStatus = {
  __typename?: 'BillingdetailConnectionStatus';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BillingdetailConnection>;
};

export type BillingdetailConnectionGuestid = {
  __typename?: 'BillingdetailConnectionGuestid';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BillingdetailConnection>;
};

export type BillingdetailAggregator = {
  __typename?: 'BillingdetailAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type BrandConnection = {
  __typename?: 'BrandConnection';
  values?: Maybe<Array<Maybe<Brand>>>;
  groupBy?: Maybe<BrandGroupBy>;
  aggregate?: Maybe<BrandAggregator>;
};

export type BrandGroupBy = {
  __typename?: 'BrandGroupBy';
  id?: Maybe<Array<Maybe<BrandConnectionId>>>;
  created_at?: Maybe<Array<Maybe<BrandConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<BrandConnectionUpdated_At>>>;
  brandName?: Maybe<Array<Maybe<BrandConnectionBrandName>>>;
  inactive?: Maybe<Array<Maybe<BrandConnectionInactive>>>;
};

export type BrandConnectionId = {
  __typename?: 'BrandConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<BrandConnection>;
};

export type BrandConnectionCreated_At = {
  __typename?: 'BrandConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BrandConnection>;
};

export type BrandConnectionUpdated_At = {
  __typename?: 'BrandConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<BrandConnection>;
};

export type BrandConnectionBrandName = {
  __typename?: 'BrandConnectionBrandName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<BrandConnection>;
};

export type BrandConnectionInactive = {
  __typename?: 'BrandConnectionInactive';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<BrandConnection>;
};

export type BrandAggregator = {
  __typename?: 'BrandAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CartConnection = {
  __typename?: 'CartConnection';
  values?: Maybe<Array<Maybe<Cart>>>;
  groupBy?: Maybe<CartGroupBy>;
  aggregate?: Maybe<CartAggregator>;
};

export type CartGroupBy = {
  __typename?: 'CartGroupBy';
  id?: Maybe<Array<Maybe<CartConnectionId>>>;
  created_at?: Maybe<Array<Maybe<CartConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<CartConnectionUpdated_At>>>;
  qty?: Maybe<Array<Maybe<CartConnectionQty>>>;
  price?: Maybe<Array<Maybe<CartConnectionPrice>>>;
  product?: Maybe<Array<Maybe<CartConnectionProduct>>>;
  user?: Maybe<Array<Maybe<CartConnectionUser>>>;
  color?: Maybe<Array<Maybe<CartConnectionColor>>>;
  discount?: Maybe<Array<Maybe<CartConnectionDiscount>>>;
};

export type CartConnectionId = {
  __typename?: 'CartConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CartConnection>;
};

export type CartConnectionCreated_At = {
  __typename?: 'CartConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CartConnection>;
};

export type CartConnectionUpdated_At = {
  __typename?: 'CartConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CartConnection>;
};

export type CartConnectionQty = {
  __typename?: 'CartConnectionQty';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<CartConnection>;
};

export type CartConnectionPrice = {
  __typename?: 'CartConnectionPrice';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<CartConnection>;
};

export type CartConnectionProduct = {
  __typename?: 'CartConnectionProduct';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CartConnection>;
};

export type CartConnectionUser = {
  __typename?: 'CartConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CartConnection>;
};

export type CartConnectionColor = {
  __typename?: 'CartConnectionColor';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CartConnection>;
};

export type CartConnectionDiscount = {
  __typename?: 'CartConnectionDiscount';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<CartConnection>;
};

export type CartAggregator = {
  __typename?: 'CartAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<CartAggregatorSum>;
  avg?: Maybe<CartAggregatorAvg>;
  min?: Maybe<CartAggregatorMin>;
  max?: Maybe<CartAggregatorMax>;
};

export type CartAggregatorSum = {
  __typename?: 'CartAggregatorSum';
  qty?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
};

export type CartAggregatorAvg = {
  __typename?: 'CartAggregatorAvg';
  qty?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
};

export type CartAggregatorMin = {
  __typename?: 'CartAggregatorMin';
  qty?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
};

export type CartAggregatorMax = {
  __typename?: 'CartAggregatorMax';
  qty?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
};

export type CatTypeTagConnection = {
  __typename?: 'CatTypeTagConnection';
  values?: Maybe<Array<Maybe<CatTypeTag>>>;
  groupBy?: Maybe<CatTypeTagGroupBy>;
  aggregate?: Maybe<CatTypeTagAggregator>;
};

export type CatTypeTagGroupBy = {
  __typename?: 'CatTypeTagGroupBy';
  id?: Maybe<Array<Maybe<CatTypeTagConnectionId>>>;
  created_at?: Maybe<Array<Maybe<CatTypeTagConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<CatTypeTagConnectionUpdated_At>>>;
  tagName?: Maybe<Array<Maybe<CatTypeTagConnectionTagName>>>;
};

export type CatTypeTagConnectionId = {
  __typename?: 'CatTypeTagConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatTypeTagConnection>;
};

export type CatTypeTagConnectionCreated_At = {
  __typename?: 'CatTypeTagConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CatTypeTagConnection>;
};

export type CatTypeTagConnectionUpdated_At = {
  __typename?: 'CatTypeTagConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CatTypeTagConnection>;
};

export type CatTypeTagConnectionTagName = {
  __typename?: 'CatTypeTagConnectionTagName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CatTypeTagConnection>;
};

export type CatTypeTagAggregator = {
  __typename?: 'CatTypeTagAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CategoryConnection = {
  __typename?: 'CategoryConnection';
  values?: Maybe<Array<Maybe<Category>>>;
  groupBy?: Maybe<CategoryGroupBy>;
  aggregate?: Maybe<CategoryAggregator>;
};

export type CategoryGroupBy = {
  __typename?: 'CategoryGroupBy';
  id?: Maybe<Array<Maybe<CategoryConnectionId>>>;
  created_at?: Maybe<Array<Maybe<CategoryConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<CategoryConnectionUpdated_At>>>;
  categoryName?: Maybe<Array<Maybe<CategoryConnectionCategoryName>>>;
  inactive?: Maybe<Array<Maybe<CategoryConnectionInactive>>>;
  icon?: Maybe<Array<Maybe<CategoryConnectionIcon>>>;
  image?: Maybe<Array<Maybe<CategoryConnectionImage>>>;
  surcharge?: Maybe<Array<Maybe<CategoryConnectionSurcharge>>>;
};

export type CategoryConnectionId = {
  __typename?: 'CategoryConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CategoryConnection>;
};

export type CategoryConnectionCreated_At = {
  __typename?: 'CategoryConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CategoryConnection>;
};

export type CategoryConnectionUpdated_At = {
  __typename?: 'CategoryConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CategoryConnection>;
};

export type CategoryConnectionCategoryName = {
  __typename?: 'CategoryConnectionCategoryName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CategoryConnection>;
};

export type CategoryConnectionInactive = {
  __typename?: 'CategoryConnectionInactive';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CategoryConnection>;
};

export type CategoryConnectionIcon = {
  __typename?: 'CategoryConnectionIcon';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CategoryConnection>;
};

export type CategoryConnectionImage = {
  __typename?: 'CategoryConnectionImage';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CategoryConnection>;
};

export type CategoryConnectionSurcharge = {
  __typename?: 'CategoryConnectionSurcharge';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<CategoryConnection>;
};

export type CategoryAggregator = {
  __typename?: 'CategoryAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<CategoryAggregatorSum>;
  avg?: Maybe<CategoryAggregatorAvg>;
  min?: Maybe<CategoryAggregatorMin>;
  max?: Maybe<CategoryAggregatorMax>;
};

export type CategoryAggregatorSum = {
  __typename?: 'CategoryAggregatorSum';
  surcharge?: Maybe<Scalars['Float']>;
};

export type CategoryAggregatorAvg = {
  __typename?: 'CategoryAggregatorAvg';
  surcharge?: Maybe<Scalars['Float']>;
};

export type CategoryAggregatorMin = {
  __typename?: 'CategoryAggregatorMin';
  surcharge?: Maybe<Scalars['Float']>;
};

export type CategoryAggregatorMax = {
  __typename?: 'CategoryAggregatorMax';
  surcharge?: Maybe<Scalars['Float']>;
};

export type CityConnection = {
  __typename?: 'CityConnection';
  values?: Maybe<Array<Maybe<City>>>;
  groupBy?: Maybe<CityGroupBy>;
  aggregate?: Maybe<CityAggregator>;
};

export type CityGroupBy = {
  __typename?: 'CityGroupBy';
  id?: Maybe<Array<Maybe<CityConnectionId>>>;
  created_at?: Maybe<Array<Maybe<CityConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<CityConnectionUpdated_At>>>;
  cityName?: Maybe<Array<Maybe<CityConnectionCityName>>>;
  district?: Maybe<Array<Maybe<CityConnectionDistrict>>>;
  postalCode?: Maybe<Array<Maybe<CityConnectionPostalCode>>>;
  latitude?: Maybe<Array<Maybe<CityConnectionLatitude>>>;
  longitude?: Maybe<Array<Maybe<CityConnectionLongitude>>>;
};

export type CityConnectionId = {
  __typename?: 'CityConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CityConnection>;
};

export type CityConnectionCreated_At = {
  __typename?: 'CityConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CityConnection>;
};

export type CityConnectionUpdated_At = {
  __typename?: 'CityConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CityConnection>;
};

export type CityConnectionCityName = {
  __typename?: 'CityConnectionCityName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CityConnection>;
};

export type CityConnectionDistrict = {
  __typename?: 'CityConnectionDistrict';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CityConnection>;
};

export type CityConnectionPostalCode = {
  __typename?: 'CityConnectionPostalCode';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CityConnection>;
};

export type CityConnectionLatitude = {
  __typename?: 'CityConnectionLatitude';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<CityConnection>;
};

export type CityConnectionLongitude = {
  __typename?: 'CityConnectionLongitude';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<CityConnection>;
};

export type CityAggregator = {
  __typename?: 'CityAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<CityAggregatorSum>;
  avg?: Maybe<CityAggregatorAvg>;
  min?: Maybe<CityAggregatorMin>;
  max?: Maybe<CityAggregatorMax>;
};

export type CityAggregatorSum = {
  __typename?: 'CityAggregatorSum';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type CityAggregatorAvg = {
  __typename?: 'CityAggregatorAvg';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type CityAggregatorMin = {
  __typename?: 'CityAggregatorMin';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type CityAggregatorMax = {
  __typename?: 'CityAggregatorMax';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type ColorCatConnection = {
  __typename?: 'ColorCatConnection';
  values?: Maybe<Array<Maybe<ColorCat>>>;
  groupBy?: Maybe<ColorCatGroupBy>;
  aggregate?: Maybe<ColorCatAggregator>;
};

export type ColorCatGroupBy = {
  __typename?: 'ColorCatGroupBy';
  id?: Maybe<Array<Maybe<ColorCatConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ColorCatConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ColorCatConnectionUpdated_At>>>;
  colorCode?: Maybe<Array<Maybe<ColorCatConnectionColorCode>>>;
  color?: Maybe<Array<Maybe<ColorCatConnectionColor>>>;
  colorPrice?: Maybe<Array<Maybe<ColorCatConnectionColorPrice>>>;
  colorStock?: Maybe<Array<Maybe<ColorCatConnectionColorStock>>>;
  product?: Maybe<Array<Maybe<ColorCatConnectionProduct>>>;
  img?: Maybe<Array<Maybe<ColorCatConnectionImg>>>;
  colorDiscount?: Maybe<Array<Maybe<ColorCatConnectionColorDiscount>>>;
  material?: Maybe<Array<Maybe<ColorCatConnectionMaterial>>>;
  closure_type?: Maybe<Array<Maybe<ColorCatConnectionClosure_Type>>>;
  lockable?: Maybe<Array<Maybe<ColorCatConnectionLockable>>>;
  laptop_com?: Maybe<Array<Maybe<ColorCatConnectionLaptop_Com>>>;
  laptop_size?: Maybe<Array<Maybe<ColorCatConnectionLaptop_Size>>>;
  warranty?: Maybe<Array<Maybe<ColorCatConnectionWarranty>>>;
  p_length?: Maybe<Array<Maybe<ColorCatConnectionP_Length>>>;
  width?: Maybe<Array<Maybe<ColorCatConnectionWidth>>>;
  height?: Maybe<Array<Maybe<ColorCatConnectionHeight>>>;
  weight?: Maybe<Array<Maybe<ColorCatConnectionWeight>>>;
  inActive?: Maybe<Array<Maybe<ColorCatConnectionInActive>>>;
  featured?: Maybe<Array<Maybe<ColorCatConnectionFeatured>>>;
  included?: Maybe<Array<Maybe<ColorCatConnectionIncluded>>>;
};

export type ColorCatConnectionId = {
  __typename?: 'ColorCatConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ColorCatConnection>;
};

export type ColorCatConnectionCreated_At = {
  __typename?: 'ColorCatConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ColorCatConnection>;
};

export type ColorCatConnectionUpdated_At = {
  __typename?: 'ColorCatConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ColorCatConnection>;
};

export type ColorCatConnectionColorCode = {
  __typename?: 'ColorCatConnectionColorCode';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ColorCatConnection>;
};

export type ColorCatConnectionColor = {
  __typename?: 'ColorCatConnectionColor';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ColorCatConnection>;
};

export type ColorCatConnectionColorPrice = {
  __typename?: 'ColorCatConnectionColorPrice';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<ColorCatConnection>;
};

export type ColorCatConnectionColorStock = {
  __typename?: 'ColorCatConnectionColorStock';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<ColorCatConnection>;
};

export type ColorCatConnectionProduct = {
  __typename?: 'ColorCatConnectionProduct';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ColorCatConnection>;
};

export type ColorCatConnectionImg = {
  __typename?: 'ColorCatConnectionImg';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ColorCatConnection>;
};

export type ColorCatConnectionColorDiscount = {
  __typename?: 'ColorCatConnectionColorDiscount';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<ColorCatConnection>;
};

export type ColorCatConnectionMaterial = {
  __typename?: 'ColorCatConnectionMaterial';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ColorCatConnection>;
};

export type ColorCatConnectionClosure_Type = {
  __typename?: 'ColorCatConnectionClosure_type';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ColorCatConnection>;
};

export type ColorCatConnectionLockable = {
  __typename?: 'ColorCatConnectionLockable';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ColorCatConnection>;
};

export type ColorCatConnectionLaptop_Com = {
  __typename?: 'ColorCatConnectionLaptop_com';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ColorCatConnection>;
};

export type ColorCatConnectionLaptop_Size = {
  __typename?: 'ColorCatConnectionLaptop_size';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ColorCatConnection>;
};

export type ColorCatConnectionWarranty = {
  __typename?: 'ColorCatConnectionWarranty';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ColorCatConnection>;
};

export type ColorCatConnectionP_Length = {
  __typename?: 'ColorCatConnectionP_length';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<ColorCatConnection>;
};

export type ColorCatConnectionWidth = {
  __typename?: 'ColorCatConnectionWidth';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<ColorCatConnection>;
};

export type ColorCatConnectionHeight = {
  __typename?: 'ColorCatConnectionHeight';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<ColorCatConnection>;
};

export type ColorCatConnectionWeight = {
  __typename?: 'ColorCatConnectionWeight';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<ColorCatConnection>;
};

export type ColorCatConnectionInActive = {
  __typename?: 'ColorCatConnectionInActive';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ColorCatConnection>;
};

export type ColorCatConnectionFeatured = {
  __typename?: 'ColorCatConnectionFeatured';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ColorCatConnection>;
};

export type ColorCatConnectionIncluded = {
  __typename?: 'ColorCatConnectionIncluded';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ColorCatConnection>;
};

export type ColorCatAggregator = {
  __typename?: 'ColorCatAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<ColorCatAggregatorSum>;
  avg?: Maybe<ColorCatAggregatorAvg>;
  min?: Maybe<ColorCatAggregatorMin>;
  max?: Maybe<ColorCatAggregatorMax>;
};

export type ColorCatAggregatorSum = {
  __typename?: 'ColorCatAggregatorSum';
  colorPrice?: Maybe<Scalars['Float']>;
  colorStock?: Maybe<Scalars['Float']>;
  colorDiscount?: Maybe<Scalars['Float']>;
  p_length?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

export type ColorCatAggregatorAvg = {
  __typename?: 'ColorCatAggregatorAvg';
  colorPrice?: Maybe<Scalars['Float']>;
  colorStock?: Maybe<Scalars['Float']>;
  colorDiscount?: Maybe<Scalars['Float']>;
  p_length?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

export type ColorCatAggregatorMin = {
  __typename?: 'ColorCatAggregatorMin';
  colorPrice?: Maybe<Scalars['Float']>;
  colorStock?: Maybe<Scalars['Float']>;
  colorDiscount?: Maybe<Scalars['Float']>;
  p_length?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

export type ColorCatAggregatorMax = {
  __typename?: 'ColorCatAggregatorMax';
  colorPrice?: Maybe<Scalars['Float']>;
  colorStock?: Maybe<Scalars['Float']>;
  colorDiscount?: Maybe<Scalars['Float']>;
  p_length?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

export type ColorImageConnection = {
  __typename?: 'ColorImageConnection';
  values?: Maybe<Array<Maybe<ColorImage>>>;
  groupBy?: Maybe<ColorImageGroupBy>;
  aggregate?: Maybe<ColorImageAggregator>;
};

export type ColorImageGroupBy = {
  __typename?: 'ColorImageGroupBy';
  id?: Maybe<Array<Maybe<ColorImageConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ColorImageConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ColorImageConnectionUpdated_At>>>;
  color_cat?: Maybe<Array<Maybe<ColorImageConnectionColor_Cat>>>;
  image?: Maybe<Array<Maybe<ColorImageConnectionImage>>>;
};

export type ColorImageConnectionId = {
  __typename?: 'ColorImageConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ColorImageConnection>;
};

export type ColorImageConnectionCreated_At = {
  __typename?: 'ColorImageConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ColorImageConnection>;
};

export type ColorImageConnectionUpdated_At = {
  __typename?: 'ColorImageConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ColorImageConnection>;
};

export type ColorImageConnectionColor_Cat = {
  __typename?: 'ColorImageConnectionColor_cat';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ColorImageConnection>;
};

export type ColorImageConnectionImage = {
  __typename?: 'ColorImageConnectionImage';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ColorImageConnection>;
};

export type ColorImageAggregator = {
  __typename?: 'ColorImageAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ColorConnection = {
  __typename?: 'ColorConnection';
  values?: Maybe<Array<Maybe<Color>>>;
  groupBy?: Maybe<ColorGroupBy>;
  aggregate?: Maybe<ColorAggregator>;
};

export type ColorGroupBy = {
  __typename?: 'ColorGroupBy';
  id?: Maybe<Array<Maybe<ColorConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ColorConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ColorConnectionUpdated_At>>>;
  colorName?: Maybe<Array<Maybe<ColorConnectionColorName>>>;
  colorHex?: Maybe<Array<Maybe<ColorConnectionColorHex>>>;
  isTwoTone?: Maybe<Array<Maybe<ColorConnectionIsTwoTone>>>;
  colorHex2?: Maybe<Array<Maybe<ColorConnectionColorHex2>>>;
};

export type ColorConnectionId = {
  __typename?: 'ColorConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ColorConnection>;
};

export type ColorConnectionCreated_At = {
  __typename?: 'ColorConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ColorConnection>;
};

export type ColorConnectionUpdated_At = {
  __typename?: 'ColorConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ColorConnection>;
};

export type ColorConnectionColorName = {
  __typename?: 'ColorConnectionColorName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ColorConnection>;
};

export type ColorConnectionColorHex = {
  __typename?: 'ColorConnectionColorHex';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ColorConnection>;
};

export type ColorConnectionIsTwoTone = {
  __typename?: 'ColorConnectionIsTwoTone';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ColorConnection>;
};

export type ColorConnectionColorHex2 = {
  __typename?: 'ColorConnectionColorHex2';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ColorConnection>;
};

export type ColorAggregator = {
  __typename?: 'ColorAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Contact = {
  __typename?: 'Contact';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name: Scalars['String'];
  email: Scalars['String'];
  message: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

export type ContactConnection = {
  __typename?: 'ContactConnection';
  values?: Maybe<Array<Maybe<Contact>>>;
  groupBy?: Maybe<ContactGroupBy>;
  aggregate?: Maybe<ContactAggregator>;
};

export type ContactGroupBy = {
  __typename?: 'ContactGroupBy';
  id?: Maybe<Array<Maybe<ContactConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ContactConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ContactConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<ContactConnectionName>>>;
  email?: Maybe<Array<Maybe<ContactConnectionEmail>>>;
  message?: Maybe<Array<Maybe<ContactConnectionMessage>>>;
  phone?: Maybe<Array<Maybe<ContactConnectionPhone>>>;
};

export type ContactConnectionId = {
  __typename?: 'ContactConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ContactConnection>;
};

export type ContactConnectionCreated_At = {
  __typename?: 'ContactConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ContactConnection>;
};

export type ContactConnectionUpdated_At = {
  __typename?: 'ContactConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ContactConnection>;
};

export type ContactConnectionName = {
  __typename?: 'ContactConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ContactConnection>;
};

export type ContactConnectionEmail = {
  __typename?: 'ContactConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ContactConnection>;
};

export type ContactConnectionMessage = {
  __typename?: 'ContactConnectionMessage';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ContactConnection>;
};

export type ContactConnectionPhone = {
  __typename?: 'ContactConnectionPhone';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ContactConnection>;
};

export type ContactAggregator = {
  __typename?: 'ContactAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CustomerConnection = {
  __typename?: 'CustomerConnection';
  values?: Maybe<Array<Maybe<Customer>>>;
  groupBy?: Maybe<CustomerGroupBy>;
  aggregate?: Maybe<CustomerAggregator>;
};

export type CustomerGroupBy = {
  __typename?: 'CustomerGroupBy';
  id?: Maybe<Array<Maybe<CustomerConnectionId>>>;
  created_at?: Maybe<Array<Maybe<CustomerConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<CustomerConnectionUpdated_At>>>;
  address1?: Maybe<Array<Maybe<CustomerConnectionAddress1>>>;
  address2?: Maybe<Array<Maybe<CustomerConnectionAddress2>>>;
  phoneNumber?: Maybe<Array<Maybe<CustomerConnectionPhoneNumber>>>;
  country?: Maybe<Array<Maybe<CustomerConnectionCountry>>>;
  user?: Maybe<Array<Maybe<CustomerConnectionUser>>>;
  firstName?: Maybe<Array<Maybe<CustomerConnectionFirstName>>>;
  lastName?: Maybe<Array<Maybe<CustomerConnectionLastName>>>;
  city?: Maybe<Array<Maybe<CustomerConnectionCity>>>;
};

export type CustomerConnectionId = {
  __typename?: 'CustomerConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CustomerConnection>;
};

export type CustomerConnectionCreated_At = {
  __typename?: 'CustomerConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CustomerConnection>;
};

export type CustomerConnectionUpdated_At = {
  __typename?: 'CustomerConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CustomerConnection>;
};

export type CustomerConnectionAddress1 = {
  __typename?: 'CustomerConnectionAddress1';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CustomerConnection>;
};

export type CustomerConnectionAddress2 = {
  __typename?: 'CustomerConnectionAddress2';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CustomerConnection>;
};

export type CustomerConnectionPhoneNumber = {
  __typename?: 'CustomerConnectionPhoneNumber';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CustomerConnection>;
};

export type CustomerConnectionCountry = {
  __typename?: 'CustomerConnectionCountry';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CustomerConnection>;
};

export type CustomerConnectionUser = {
  __typename?: 'CustomerConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CustomerConnection>;
};

export type CustomerConnectionFirstName = {
  __typename?: 'CustomerConnectionFirstName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CustomerConnection>;
};

export type CustomerConnectionLastName = {
  __typename?: 'CustomerConnectionLastName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CustomerConnection>;
};

export type CustomerConnectionCity = {
  __typename?: 'CustomerConnectionCity';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CustomerConnection>;
};

export type CustomerAggregator = {
  __typename?: 'CustomerAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type DistrictConnection = {
  __typename?: 'DistrictConnection';
  values?: Maybe<Array<Maybe<District>>>;
  groupBy?: Maybe<DistrictGroupBy>;
  aggregate?: Maybe<DistrictAggregator>;
};

export type DistrictGroupBy = {
  __typename?: 'DistrictGroupBy';
  id?: Maybe<Array<Maybe<DistrictConnectionId>>>;
  created_at?: Maybe<Array<Maybe<DistrictConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<DistrictConnectionUpdated_At>>>;
  districtName?: Maybe<Array<Maybe<DistrictConnectionDistrictName>>>;
  province?: Maybe<Array<Maybe<DistrictConnectionProvince>>>;
  deliveryCharge1?: Maybe<Array<Maybe<DistrictConnectionDeliveryCharge1>>>;
  deliveryCharge2?: Maybe<Array<Maybe<DistrictConnectionDeliveryCharge2>>>;
  deliveryCharge3?: Maybe<Array<Maybe<DistrictConnectionDeliveryCharge3>>>;
  deliveryCharge4?: Maybe<Array<Maybe<DistrictConnectionDeliveryCharge4>>>;
};

export type DistrictConnectionId = {
  __typename?: 'DistrictConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<DistrictConnection>;
};

export type DistrictConnectionCreated_At = {
  __typename?: 'DistrictConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<DistrictConnection>;
};

export type DistrictConnectionUpdated_At = {
  __typename?: 'DistrictConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<DistrictConnection>;
};

export type DistrictConnectionDistrictName = {
  __typename?: 'DistrictConnectionDistrictName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<DistrictConnection>;
};

export type DistrictConnectionProvince = {
  __typename?: 'DistrictConnectionProvince';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<DistrictConnection>;
};

export type DistrictConnectionDeliveryCharge1 = {
  __typename?: 'DistrictConnectionDeliveryCharge1';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<DistrictConnection>;
};

export type DistrictConnectionDeliveryCharge2 = {
  __typename?: 'DistrictConnectionDeliveryCharge2';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<DistrictConnection>;
};

export type DistrictConnectionDeliveryCharge3 = {
  __typename?: 'DistrictConnectionDeliveryCharge3';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<DistrictConnection>;
};

export type DistrictConnectionDeliveryCharge4 = {
  __typename?: 'DistrictConnectionDeliveryCharge4';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<DistrictConnection>;
};

export type DistrictAggregator = {
  __typename?: 'DistrictAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<DistrictAggregatorSum>;
  avg?: Maybe<DistrictAggregatorAvg>;
  min?: Maybe<DistrictAggregatorMin>;
  max?: Maybe<DistrictAggregatorMax>;
};

export type DistrictAggregatorSum = {
  __typename?: 'DistrictAggregatorSum';
  deliveryCharge1?: Maybe<Scalars['Float']>;
  deliveryCharge2?: Maybe<Scalars['Float']>;
  deliveryCharge3?: Maybe<Scalars['Float']>;
  deliveryCharge4?: Maybe<Scalars['Float']>;
};

export type DistrictAggregatorAvg = {
  __typename?: 'DistrictAggregatorAvg';
  deliveryCharge1?: Maybe<Scalars['Float']>;
  deliveryCharge2?: Maybe<Scalars['Float']>;
  deliveryCharge3?: Maybe<Scalars['Float']>;
  deliveryCharge4?: Maybe<Scalars['Float']>;
};

export type DistrictAggregatorMin = {
  __typename?: 'DistrictAggregatorMin';
  deliveryCharge1?: Maybe<Scalars['Float']>;
  deliveryCharge2?: Maybe<Scalars['Float']>;
  deliveryCharge3?: Maybe<Scalars['Float']>;
  deliveryCharge4?: Maybe<Scalars['Float']>;
};

export type DistrictAggregatorMax = {
  __typename?: 'DistrictAggregatorMax';
  deliveryCharge1?: Maybe<Scalars['Float']>;
  deliveryCharge2?: Maybe<Scalars['Float']>;
  deliveryCharge3?: Maybe<Scalars['Float']>;
  deliveryCharge4?: Maybe<Scalars['Float']>;
};

export type HitCountConnection = {
  __typename?: 'HitCountConnection';
  values?: Maybe<Array<Maybe<HitCount>>>;
  groupBy?: Maybe<HitCountGroupBy>;
  aggregate?: Maybe<HitCountAggregator>;
};

export type HitCountGroupBy = {
  __typename?: 'HitCountGroupBy';
  id?: Maybe<Array<Maybe<HitCountConnectionId>>>;
  created_at?: Maybe<Array<Maybe<HitCountConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<HitCountConnectionUpdated_At>>>;
  hit_date?: Maybe<Array<Maybe<HitCountConnectionHit_Date>>>;
  h_count?: Maybe<Array<Maybe<HitCountConnectionH_Count>>>;
  product?: Maybe<Array<Maybe<HitCountConnectionProduct>>>;
  published_at?: Maybe<Array<Maybe<HitCountConnectionPublished_At>>>;
};

export type HitCountConnectionId = {
  __typename?: 'HitCountConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<HitCountConnection>;
};

export type HitCountConnectionCreated_At = {
  __typename?: 'HitCountConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<HitCountConnection>;
};

export type HitCountConnectionUpdated_At = {
  __typename?: 'HitCountConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<HitCountConnection>;
};

export type HitCountConnectionHit_Date = {
  __typename?: 'HitCountConnectionHit_date';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<HitCountConnection>;
};

export type HitCountConnectionH_Count = {
  __typename?: 'HitCountConnectionH_count';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<HitCountConnection>;
};

export type HitCountConnectionProduct = {
  __typename?: 'HitCountConnectionProduct';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<HitCountConnection>;
};

export type HitCountConnectionPublished_At = {
  __typename?: 'HitCountConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<HitCountConnection>;
};

export type HitCountAggregator = {
  __typename?: 'HitCountAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<HitCountAggregatorSum>;
  avg?: Maybe<HitCountAggregatorAvg>;
  min?: Maybe<HitCountAggregatorMin>;
  max?: Maybe<HitCountAggregatorMax>;
};

export type HitCountAggregatorSum = {
  __typename?: 'HitCountAggregatorSum';
  h_count?: Maybe<Scalars['Float']>;
};

export type HitCountAggregatorAvg = {
  __typename?: 'HitCountAggregatorAvg';
  h_count?: Maybe<Scalars['Float']>;
};

export type HitCountAggregatorMin = {
  __typename?: 'HitCountAggregatorMin';
  h_count?: Maybe<Scalars['Float']>;
};

export type HitCountAggregatorMax = {
  __typename?: 'HitCountAggregatorMax';
  h_count?: Maybe<Scalars['Float']>;
};

export type Log = {
  __typename?: 'Log';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  desp?: Maybe<Scalars['String']>;
  funcName?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
};

export type LogConnection = {
  __typename?: 'LogConnection';
  values?: Maybe<Array<Maybe<Log>>>;
  groupBy?: Maybe<LogGroupBy>;
  aggregate?: Maybe<LogAggregator>;
};

export type LogGroupBy = {
  __typename?: 'LogGroupBy';
  id?: Maybe<Array<Maybe<LogConnectionId>>>;
  created_at?: Maybe<Array<Maybe<LogConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<LogConnectionUpdated_At>>>;
  desp?: Maybe<Array<Maybe<LogConnectionDesp>>>;
  funcName?: Maybe<Array<Maybe<LogConnectionFuncName>>>;
  user?: Maybe<Array<Maybe<LogConnectionUser>>>;
};

export type LogConnectionId = {
  __typename?: 'LogConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<LogConnection>;
};

export type LogConnectionCreated_At = {
  __typename?: 'LogConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<LogConnection>;
};

export type LogConnectionUpdated_At = {
  __typename?: 'LogConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<LogConnection>;
};

export type LogConnectionDesp = {
  __typename?: 'LogConnectionDesp';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<LogConnection>;
};

export type LogConnectionFuncName = {
  __typename?: 'LogConnectionFuncName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<LogConnection>;
};

export type LogConnectionUser = {
  __typename?: 'LogConnectionUser';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<LogConnection>;
};

export type LogAggregator = {
  __typename?: 'LogAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type MaterialConnection = {
  __typename?: 'MaterialConnection';
  values?: Maybe<Array<Maybe<Material>>>;
  groupBy?: Maybe<MaterialGroupBy>;
  aggregate?: Maybe<MaterialAggregator>;
};

export type MaterialGroupBy = {
  __typename?: 'MaterialGroupBy';
  id?: Maybe<Array<Maybe<MaterialConnectionId>>>;
  created_at?: Maybe<Array<Maybe<MaterialConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<MaterialConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<MaterialConnectionName>>>;
};

export type MaterialConnectionId = {
  __typename?: 'MaterialConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<MaterialConnection>;
};

export type MaterialConnectionCreated_At = {
  __typename?: 'MaterialConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<MaterialConnection>;
};

export type MaterialConnectionUpdated_At = {
  __typename?: 'MaterialConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<MaterialConnection>;
};

export type MaterialConnectionName = {
  __typename?: 'MaterialConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<MaterialConnection>;
};

export type MaterialAggregator = {
  __typename?: 'MaterialAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Misc = {
  __typename?: 'Misc';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  shouldOpenBanner?: Maybe<Scalars['Boolean']>;
  launchCode?: Maybe<Scalars['String']>;
};

export type MiscConnection = {
  __typename?: 'MiscConnection';
  values?: Maybe<Array<Maybe<Misc>>>;
  groupBy?: Maybe<MiscGroupBy>;
  aggregate?: Maybe<MiscAggregator>;
};

export type MiscGroupBy = {
  __typename?: 'MiscGroupBy';
  id?: Maybe<Array<Maybe<MiscConnectionId>>>;
  created_at?: Maybe<Array<Maybe<MiscConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<MiscConnectionUpdated_At>>>;
  shouldOpenBanner?: Maybe<Array<Maybe<MiscConnectionShouldOpenBanner>>>;
  launchCode?: Maybe<Array<Maybe<MiscConnectionLaunchCode>>>;
};

export type MiscConnectionId = {
  __typename?: 'MiscConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<MiscConnection>;
};

export type MiscConnectionCreated_At = {
  __typename?: 'MiscConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<MiscConnection>;
};

export type MiscConnectionUpdated_At = {
  __typename?: 'MiscConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<MiscConnection>;
};

export type MiscConnectionShouldOpenBanner = {
  __typename?: 'MiscConnectionShouldOpenBanner';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<MiscConnection>;
};

export type MiscConnectionLaunchCode = {
  __typename?: 'MiscConnectionLaunchCode';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<MiscConnection>;
};

export type MiscAggregator = {
  __typename?: 'MiscAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Newsletter = {
  __typename?: 'Newsletter';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
};

export type NewsletterConnection = {
  __typename?: 'NewsletterConnection';
  values?: Maybe<Array<Maybe<Newsletter>>>;
  groupBy?: Maybe<NewsletterGroupBy>;
  aggregate?: Maybe<NewsletterAggregator>;
};

export type NewsletterGroupBy = {
  __typename?: 'NewsletterGroupBy';
  id?: Maybe<Array<Maybe<NewsletterConnectionId>>>;
  created_at?: Maybe<Array<Maybe<NewsletterConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<NewsletterConnectionUpdated_At>>>;
  email?: Maybe<Array<Maybe<NewsletterConnectionEmail>>>;
};

export type NewsletterConnectionId = {
  __typename?: 'NewsletterConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<NewsletterConnection>;
};

export type NewsletterConnectionCreated_At = {
  __typename?: 'NewsletterConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<NewsletterConnection>;
};

export type NewsletterConnectionUpdated_At = {
  __typename?: 'NewsletterConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<NewsletterConnection>;
};

export type NewsletterConnectionEmail = {
  __typename?: 'NewsletterConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<NewsletterConnection>;
};

export type NewsletterAggregator = {
  __typename?: 'NewsletterAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Notifystock = {
  __typename?: 'Notifystock';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  users_permissions_user?: Maybe<UsersPermissionsUser>;
  colorCode?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type NotifystockConnection = {
  __typename?: 'NotifystockConnection';
  values?: Maybe<Array<Maybe<Notifystock>>>;
  groupBy?: Maybe<NotifystockGroupBy>;
  aggregate?: Maybe<NotifystockAggregator>;
};

export type NotifystockGroupBy = {
  __typename?: 'NotifystockGroupBy';
  id?: Maybe<Array<Maybe<NotifystockConnectionId>>>;
  created_at?: Maybe<Array<Maybe<NotifystockConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<NotifystockConnectionUpdated_At>>>;
  users_permissions_user?: Maybe<Array<Maybe<NotifystockConnectionUsers_Permissions_User>>>;
  colorCode?: Maybe<Array<Maybe<NotifystockConnectionColorCode>>>;
  email?: Maybe<Array<Maybe<NotifystockConnectionEmail>>>;
  phone?: Maybe<Array<Maybe<NotifystockConnectionPhone>>>;
};

export type NotifystockConnectionId = {
  __typename?: 'NotifystockConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<NotifystockConnection>;
};

export type NotifystockConnectionCreated_At = {
  __typename?: 'NotifystockConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<NotifystockConnection>;
};

export type NotifystockConnectionUpdated_At = {
  __typename?: 'NotifystockConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<NotifystockConnection>;
};

export type NotifystockConnectionUsers_Permissions_User = {
  __typename?: 'NotifystockConnectionUsers_permissions_user';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<NotifystockConnection>;
};

export type NotifystockConnectionColorCode = {
  __typename?: 'NotifystockConnectionColorCode';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<NotifystockConnection>;
};

export type NotifystockConnectionEmail = {
  __typename?: 'NotifystockConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<NotifystockConnection>;
};

export type NotifystockConnectionPhone = {
  __typename?: 'NotifystockConnectionPhone';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<NotifystockConnection>;
};

export type NotifystockAggregator = {
  __typename?: 'NotifystockAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type OrderdConnection = {
  __typename?: 'OrderdConnection';
  values?: Maybe<Array<Maybe<Orderd>>>;
  groupBy?: Maybe<OrderdGroupBy>;
  aggregate?: Maybe<OrderdAggregator>;
};

export type OrderdGroupBy = {
  __typename?: 'OrderdGroupBy';
  id?: Maybe<Array<Maybe<OrderdConnectionId>>>;
  created_at?: Maybe<Array<Maybe<OrderdConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<OrderdConnectionUpdated_At>>>;
  qty?: Maybe<Array<Maybe<OrderdConnectionQty>>>;
  price?: Maybe<Array<Maybe<OrderdConnectionPrice>>>;
  product?: Maybe<Array<Maybe<OrderdConnectionProduct>>>;
  orderh?: Maybe<Array<Maybe<OrderdConnectionOrderh>>>;
  color?: Maybe<Array<Maybe<OrderdConnectionColor>>>;
  deliveryPerson?: Maybe<Array<Maybe<OrderdConnectionDeliveryPerson>>>;
  status?: Maybe<Array<Maybe<OrderdConnectionStatus>>>;
  discount?: Maybe<Array<Maybe<OrderdConnectionDiscount>>>;
};

export type OrderdConnectionId = {
  __typename?: 'OrderdConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OrderdConnection>;
};

export type OrderdConnectionCreated_At = {
  __typename?: 'OrderdConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<OrderdConnection>;
};

export type OrderdConnectionUpdated_At = {
  __typename?: 'OrderdConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<OrderdConnection>;
};

export type OrderdConnectionQty = {
  __typename?: 'OrderdConnectionQty';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<OrderdConnection>;
};

export type OrderdConnectionPrice = {
  __typename?: 'OrderdConnectionPrice';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<OrderdConnection>;
};

export type OrderdConnectionProduct = {
  __typename?: 'OrderdConnectionProduct';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OrderdConnection>;
};

export type OrderdConnectionOrderh = {
  __typename?: 'OrderdConnectionOrderh';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OrderdConnection>;
};

export type OrderdConnectionColor = {
  __typename?: 'OrderdConnectionColor';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OrderdConnection>;
};

export type OrderdConnectionDeliveryPerson = {
  __typename?: 'OrderdConnectionDeliveryPerson';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OrderdConnection>;
};

export type OrderdConnectionStatus = {
  __typename?: 'OrderdConnectionStatus';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<OrderdConnection>;
};

export type OrderdConnectionDiscount = {
  __typename?: 'OrderdConnectionDiscount';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<OrderdConnection>;
};

export type OrderdAggregator = {
  __typename?: 'OrderdAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<OrderdAggregatorSum>;
  avg?: Maybe<OrderdAggregatorAvg>;
  min?: Maybe<OrderdAggregatorMin>;
  max?: Maybe<OrderdAggregatorMax>;
};

export type OrderdAggregatorSum = {
  __typename?: 'OrderdAggregatorSum';
  qty?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
};

export type OrderdAggregatorAvg = {
  __typename?: 'OrderdAggregatorAvg';
  qty?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
};

export type OrderdAggregatorMin = {
  __typename?: 'OrderdAggregatorMin';
  qty?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
};

export type OrderdAggregatorMax = {
  __typename?: 'OrderdAggregatorMax';
  qty?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
};

export type OrderhConnection = {
  __typename?: 'OrderhConnection';
  values?: Maybe<Array<Maybe<Orderh>>>;
  groupBy?: Maybe<OrderhGroupBy>;
  aggregate?: Maybe<OrderhAggregator>;
};

export type OrderhGroupBy = {
  __typename?: 'OrderhGroupBy';
  id?: Maybe<Array<Maybe<OrderhConnectionId>>>;
  created_at?: Maybe<Array<Maybe<OrderhConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<OrderhConnectionUpdated_At>>>;
  netAmt?: Maybe<Array<Maybe<OrderhConnectionNetAmt>>>;
  orderCode?: Maybe<Array<Maybe<OrderhConnectionOrderCode>>>;
  user?: Maybe<Array<Maybe<OrderhConnectionUser>>>;
  status?: Maybe<Array<Maybe<OrderhConnectionStatus>>>;
  paymentId?: Maybe<Array<Maybe<OrderhConnectionPaymentId>>>;
  paidAmount?: Maybe<Array<Maybe<OrderhConnectionPaidAmount>>>;
  cardName?: Maybe<Array<Maybe<OrderhConnectionCardName>>>;
  cardExp?: Maybe<Array<Maybe<OrderhConnectionCardExp>>>;
  cardNo?: Maybe<Array<Maybe<OrderhConnectionCardNo>>>;
  deliveryCost?: Maybe<Array<Maybe<OrderhConnectionDeliveryCost>>>;
  invoiceDate?: Maybe<Array<Maybe<OrderhConnectionInvoiceDate>>>;
  returned?: Maybe<Array<Maybe<OrderhConnectionReturned>>>;
  voucher?: Maybe<Array<Maybe<OrderhConnectionVoucher>>>;
  specialDiscount?: Maybe<Array<Maybe<OrderhConnectionSpecialDiscount>>>;
  guestid?: Maybe<Array<Maybe<OrderhConnectionGuestid>>>;
  surcharge?: Maybe<Array<Maybe<OrderhConnectionSurcharge>>>;
};

export type OrderhConnectionId = {
  __typename?: 'OrderhConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OrderhConnection>;
};

export type OrderhConnectionCreated_At = {
  __typename?: 'OrderhConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<OrderhConnection>;
};

export type OrderhConnectionUpdated_At = {
  __typename?: 'OrderhConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<OrderhConnection>;
};

export type OrderhConnectionNetAmt = {
  __typename?: 'OrderhConnectionNetAmt';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<OrderhConnection>;
};

export type OrderhConnectionOrderCode = {
  __typename?: 'OrderhConnectionOrderCode';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<OrderhConnection>;
};

export type OrderhConnectionUser = {
  __typename?: 'OrderhConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OrderhConnection>;
};

export type OrderhConnectionStatus = {
  __typename?: 'OrderhConnectionStatus';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OrderhConnection>;
};

export type OrderhConnectionPaymentId = {
  __typename?: 'OrderhConnectionPaymentId';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<OrderhConnection>;
};

export type OrderhConnectionPaidAmount = {
  __typename?: 'OrderhConnectionPaidAmount';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<OrderhConnection>;
};

export type OrderhConnectionCardName = {
  __typename?: 'OrderhConnectionCardName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<OrderhConnection>;
};

export type OrderhConnectionCardExp = {
  __typename?: 'OrderhConnectionCardExp';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<OrderhConnection>;
};

export type OrderhConnectionCardNo = {
  __typename?: 'OrderhConnectionCardNo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<OrderhConnection>;
};

export type OrderhConnectionDeliveryCost = {
  __typename?: 'OrderhConnectionDeliveryCost';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<OrderhConnection>;
};

export type OrderhConnectionInvoiceDate = {
  __typename?: 'OrderhConnectionInvoiceDate';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<OrderhConnection>;
};

export type OrderhConnectionReturned = {
  __typename?: 'OrderhConnectionReturned';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<OrderhConnection>;
};

export type OrderhConnectionVoucher = {
  __typename?: 'OrderhConnectionVoucher';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OrderhConnection>;
};

export type OrderhConnectionSpecialDiscount = {
  __typename?: 'OrderhConnectionSpecialDiscount';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<OrderhConnection>;
};

export type OrderhConnectionGuestid = {
  __typename?: 'OrderhConnectionGuestid';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<OrderhConnection>;
};

export type OrderhConnectionSurcharge = {
  __typename?: 'OrderhConnectionSurcharge';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<OrderhConnection>;
};

export type OrderhAggregator = {
  __typename?: 'OrderhAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<OrderhAggregatorSum>;
  avg?: Maybe<OrderhAggregatorAvg>;
  min?: Maybe<OrderhAggregatorMin>;
  max?: Maybe<OrderhAggregatorMax>;
};

export type OrderhAggregatorSum = {
  __typename?: 'OrderhAggregatorSum';
  netAmt?: Maybe<Scalars['Float']>;
  paidAmount?: Maybe<Scalars['Float']>;
  cardExp?: Maybe<Scalars['Float']>;
  deliveryCost?: Maybe<Scalars['Float']>;
  specialDiscount?: Maybe<Scalars['Float']>;
  surcharge?: Maybe<Scalars['Float']>;
};

export type OrderhAggregatorAvg = {
  __typename?: 'OrderhAggregatorAvg';
  netAmt?: Maybe<Scalars['Float']>;
  paidAmount?: Maybe<Scalars['Float']>;
  cardExp?: Maybe<Scalars['Float']>;
  deliveryCost?: Maybe<Scalars['Float']>;
  specialDiscount?: Maybe<Scalars['Float']>;
  surcharge?: Maybe<Scalars['Float']>;
};

export type OrderhAggregatorMin = {
  __typename?: 'OrderhAggregatorMin';
  netAmt?: Maybe<Scalars['Float']>;
  paidAmount?: Maybe<Scalars['Float']>;
  cardExp?: Maybe<Scalars['Float']>;
  deliveryCost?: Maybe<Scalars['Float']>;
  specialDiscount?: Maybe<Scalars['Float']>;
  surcharge?: Maybe<Scalars['Float']>;
};

export type OrderhAggregatorMax = {
  __typename?: 'OrderhAggregatorMax';
  netAmt?: Maybe<Scalars['Float']>;
  paidAmount?: Maybe<Scalars['Float']>;
  cardExp?: Maybe<Scalars['Float']>;
  deliveryCost?: Maybe<Scalars['Float']>;
  specialDiscount?: Maybe<Scalars['Float']>;
  surcharge?: Maybe<Scalars['Float']>;
};

export type OrderhistoryConnection = {
  __typename?: 'OrderhistoryConnection';
  values?: Maybe<Array<Maybe<Orderhistory>>>;
  groupBy?: Maybe<OrderhistoryGroupBy>;
  aggregate?: Maybe<OrderhistoryAggregator>;
};

export type OrderhistoryGroupBy = {
  __typename?: 'OrderhistoryGroupBy';
  id?: Maybe<Array<Maybe<OrderhistoryConnectionId>>>;
  created_at?: Maybe<Array<Maybe<OrderhistoryConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<OrderhistoryConnectionUpdated_At>>>;
  orderh?: Maybe<Array<Maybe<OrderhistoryConnectionOrderh>>>;
  status?: Maybe<Array<Maybe<OrderhistoryConnectionStatus>>>;
};

export type OrderhistoryConnectionId = {
  __typename?: 'OrderhistoryConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OrderhistoryConnection>;
};

export type OrderhistoryConnectionCreated_At = {
  __typename?: 'OrderhistoryConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<OrderhistoryConnection>;
};

export type OrderhistoryConnectionUpdated_At = {
  __typename?: 'OrderhistoryConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<OrderhistoryConnection>;
};

export type OrderhistoryConnectionOrderh = {
  __typename?: 'OrderhistoryConnectionOrderh';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OrderhistoryConnection>;
};

export type OrderhistoryConnectionStatus = {
  __typename?: 'OrderhistoryConnectionStatus';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OrderhistoryConnection>;
};

export type OrderhistoryAggregator = {
  __typename?: 'OrderhistoryAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PaymentselectionConnection = {
  __typename?: 'PaymentselectionConnection';
  values?: Maybe<Array<Maybe<Paymentselection>>>;
  groupBy?: Maybe<PaymentselectionGroupBy>;
  aggregate?: Maybe<PaymentselectionAggregator>;
};

export type PaymentselectionGroupBy = {
  __typename?: 'PaymentselectionGroupBy';
  id?: Maybe<Array<Maybe<PaymentselectionConnectionId>>>;
  created_at?: Maybe<Array<Maybe<PaymentselectionConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<PaymentselectionConnectionUpdated_At>>>;
  method?: Maybe<Array<Maybe<PaymentselectionConnectionMethod>>>;
  user?: Maybe<Array<Maybe<PaymentselectionConnectionUser>>>;
  orderh?: Maybe<Array<Maybe<PaymentselectionConnectionOrderh>>>;
  status?: Maybe<Array<Maybe<PaymentselectionConnectionStatus>>>;
  deliveryMethod?: Maybe<Array<Maybe<PaymentselectionConnectionDeliveryMethod>>>;
  senderName?: Maybe<Array<Maybe<PaymentselectionConnectionSenderName>>>;
  note?: Maybe<Array<Maybe<PaymentselectionConnectionNote>>>;
  guestid?: Maybe<Array<Maybe<PaymentselectionConnectionGuestid>>>;
  mintpayId?: Maybe<Array<Maybe<PaymentselectionConnectionMintpayId>>>;
};

export type PaymentselectionConnectionId = {
  __typename?: 'PaymentselectionConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PaymentselectionConnection>;
};

export type PaymentselectionConnectionCreated_At = {
  __typename?: 'PaymentselectionConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PaymentselectionConnection>;
};

export type PaymentselectionConnectionUpdated_At = {
  __typename?: 'PaymentselectionConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PaymentselectionConnection>;
};

export type PaymentselectionConnectionMethod = {
  __typename?: 'PaymentselectionConnectionMethod';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaymentselectionConnection>;
};

export type PaymentselectionConnectionUser = {
  __typename?: 'PaymentselectionConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PaymentselectionConnection>;
};

export type PaymentselectionConnectionOrderh = {
  __typename?: 'PaymentselectionConnectionOrderh';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PaymentselectionConnection>;
};

export type PaymentselectionConnectionStatus = {
  __typename?: 'PaymentselectionConnectionStatus';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PaymentselectionConnection>;
};

export type PaymentselectionConnectionDeliveryMethod = {
  __typename?: 'PaymentselectionConnectionDeliveryMethod';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaymentselectionConnection>;
};

export type PaymentselectionConnectionSenderName = {
  __typename?: 'PaymentselectionConnectionSenderName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaymentselectionConnection>;
};

export type PaymentselectionConnectionNote = {
  __typename?: 'PaymentselectionConnectionNote';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaymentselectionConnection>;
};

export type PaymentselectionConnectionGuestid = {
  __typename?: 'PaymentselectionConnectionGuestid';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaymentselectionConnection>;
};

export type PaymentselectionConnectionMintpayId = {
  __typename?: 'PaymentselectionConnectionMintpayId';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaymentselectionConnection>;
};

export type PaymentselectionAggregator = {
  __typename?: 'PaymentselectionAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ProductConnection = {
  __typename?: 'ProductConnection';
  values?: Maybe<Array<Maybe<Product>>>;
  groupBy?: Maybe<ProductGroupBy>;
  aggregate?: Maybe<ProductAggregator>;
};

export type ProductGroupBy = {
  __typename?: 'ProductGroupBy';
  id?: Maybe<Array<Maybe<ProductConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ProductConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ProductConnectionUpdated_At>>>;
  productCode?: Maybe<Array<Maybe<ProductConnectionProductCode>>>;
  serialNo?: Maybe<Array<Maybe<ProductConnectionSerialNo>>>;
  productName?: Maybe<Array<Maybe<ProductConnectionProductName>>>;
  price?: Maybe<Array<Maybe<ProductConnectionPrice>>>;
  discount?: Maybe<Array<Maybe<ProductConnectionDiscount>>>;
  brand?: Maybe<Array<Maybe<ProductConnectionBrand>>>;
  category?: Maybe<Array<Maybe<ProductConnectionCategory>>>;
  featuredItem?: Maybe<Array<Maybe<ProductConnectionFeaturedItem>>>;
  inactive?: Maybe<Array<Maybe<ProductConnectionInactive>>>;
  productDescription?: Maybe<Array<Maybe<ProductConnectionProductDescription>>>;
  image?: Maybe<Array<Maybe<ProductConnectionImage>>>;
  spec?: Maybe<Array<Maybe<ProductConnectionSpec>>>;
  warranty?: Maybe<Array<Maybe<ProductConnectionWarranty>>>;
  stock?: Maybe<Array<Maybe<ProductConnectionStock>>>;
  store?: Maybe<Array<Maybe<ProductConnectionStore>>>;
  hitCount?: Maybe<Array<Maybe<ProductConnectionHitCount>>>;
  isVoucher?: Maybe<Array<Maybe<ProductConnectionIsVoucher>>>;
  material?: Maybe<Array<Maybe<ProductConnectionMaterial>>>;
};

export type ProductConnectionId = {
  __typename?: 'ProductConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProductConnection>;
};

export type ProductConnectionCreated_At = {
  __typename?: 'ProductConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProductConnection>;
};

export type ProductConnectionUpdated_At = {
  __typename?: 'ProductConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProductConnection>;
};

export type ProductConnectionProductCode = {
  __typename?: 'ProductConnectionProductCode';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProductConnection>;
};

export type ProductConnectionSerialNo = {
  __typename?: 'ProductConnectionSerialNo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProductConnection>;
};

export type ProductConnectionProductName = {
  __typename?: 'ProductConnectionProductName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProductConnection>;
};

export type ProductConnectionPrice = {
  __typename?: 'ProductConnectionPrice';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<ProductConnection>;
};

export type ProductConnectionDiscount = {
  __typename?: 'ProductConnectionDiscount';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<ProductConnection>;
};

export type ProductConnectionBrand = {
  __typename?: 'ProductConnectionBrand';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProductConnection>;
};

export type ProductConnectionCategory = {
  __typename?: 'ProductConnectionCategory';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProductConnection>;
};

export type ProductConnectionFeaturedItem = {
  __typename?: 'ProductConnectionFeaturedItem';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProductConnection>;
};

export type ProductConnectionInactive = {
  __typename?: 'ProductConnectionInactive';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProductConnection>;
};

export type ProductConnectionProductDescription = {
  __typename?: 'ProductConnectionProductDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProductConnection>;
};

export type ProductConnectionImage = {
  __typename?: 'ProductConnectionImage';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProductConnection>;
};

export type ProductConnectionSpec = {
  __typename?: 'ProductConnectionSpec';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProductConnection>;
};

export type ProductConnectionWarranty = {
  __typename?: 'ProductConnectionWarranty';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProductConnection>;
};

export type ProductConnectionStock = {
  __typename?: 'ProductConnectionStock';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<ProductConnection>;
};

export type ProductConnectionStore = {
  __typename?: 'ProductConnectionStore';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProductConnection>;
};

export type ProductConnectionHitCount = {
  __typename?: 'ProductConnectionHitCount';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProductConnection>;
};

export type ProductConnectionIsVoucher = {
  __typename?: 'ProductConnectionIsVoucher';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ProductConnection>;
};

export type ProductConnectionMaterial = {
  __typename?: 'ProductConnectionMaterial';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProductConnection>;
};

export type ProductAggregator = {
  __typename?: 'ProductAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<ProductAggregatorSum>;
  avg?: Maybe<ProductAggregatorAvg>;
  min?: Maybe<ProductAggregatorMin>;
  max?: Maybe<ProductAggregatorMax>;
};

export type ProductAggregatorSum = {
  __typename?: 'ProductAggregatorSum';
  price?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  stock?: Maybe<Scalars['Float']>;
};

export type ProductAggregatorAvg = {
  __typename?: 'ProductAggregatorAvg';
  price?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  stock?: Maybe<Scalars['Float']>;
};

export type ProductAggregatorMin = {
  __typename?: 'ProductAggregatorMin';
  price?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  stock?: Maybe<Scalars['Float']>;
};

export type ProductAggregatorMax = {
  __typename?: 'ProductAggregatorMax';
  price?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  stock?: Maybe<Scalars['Float']>;
};

export type ProductimageConnection = {
  __typename?: 'ProductimageConnection';
  values?: Maybe<Array<Maybe<Productimage>>>;
  groupBy?: Maybe<ProductimageGroupBy>;
  aggregate?: Maybe<ProductimageAggregator>;
};

export type ProductimageGroupBy = {
  __typename?: 'ProductimageGroupBy';
  id?: Maybe<Array<Maybe<ProductimageConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ProductimageConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ProductimageConnectionUpdated_At>>>;
  image?: Maybe<Array<Maybe<ProductimageConnectionImage>>>;
  product?: Maybe<Array<Maybe<ProductimageConnectionProduct>>>;
};

export type ProductimageConnectionId = {
  __typename?: 'ProductimageConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProductimageConnection>;
};

export type ProductimageConnectionCreated_At = {
  __typename?: 'ProductimageConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProductimageConnection>;
};

export type ProductimageConnectionUpdated_At = {
  __typename?: 'ProductimageConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProductimageConnection>;
};

export type ProductimageConnectionImage = {
  __typename?: 'ProductimageConnectionImage';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProductimageConnection>;
};

export type ProductimageConnectionProduct = {
  __typename?: 'ProductimageConnectionProduct';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProductimageConnection>;
};

export type ProductimageAggregator = {
  __typename?: 'ProductimageAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ProvinceConnection = {
  __typename?: 'ProvinceConnection';
  values?: Maybe<Array<Maybe<Province>>>;
  groupBy?: Maybe<ProvinceGroupBy>;
  aggregate?: Maybe<ProvinceAggregator>;
};

export type ProvinceGroupBy = {
  __typename?: 'ProvinceGroupBy';
  id?: Maybe<Array<Maybe<ProvinceConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ProvinceConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ProvinceConnectionUpdated_At>>>;
  provinceName?: Maybe<Array<Maybe<ProvinceConnectionProvinceName>>>;
};

export type ProvinceConnectionId = {
  __typename?: 'ProvinceConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ProvinceConnection>;
};

export type ProvinceConnectionCreated_At = {
  __typename?: 'ProvinceConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProvinceConnection>;
};

export type ProvinceConnectionUpdated_At = {
  __typename?: 'ProvinceConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ProvinceConnection>;
};

export type ProvinceConnectionProvinceName = {
  __typename?: 'ProvinceConnectionProvinceName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ProvinceConnection>;
};

export type ProvinceAggregator = {
  __typename?: 'ProvinceAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ReturnorderdConnection = {
  __typename?: 'ReturnorderdConnection';
  values?: Maybe<Array<Maybe<Returnorderd>>>;
  groupBy?: Maybe<ReturnorderdGroupBy>;
  aggregate?: Maybe<ReturnorderdAggregator>;
};

export type ReturnorderdGroupBy = {
  __typename?: 'ReturnorderdGroupBy';
  id?: Maybe<Array<Maybe<ReturnorderdConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ReturnorderdConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ReturnorderdConnectionUpdated_At>>>;
  qty?: Maybe<Array<Maybe<ReturnorderdConnectionQty>>>;
  price?: Maybe<Array<Maybe<ReturnorderdConnectionPrice>>>;
  product?: Maybe<Array<Maybe<ReturnorderdConnectionProduct>>>;
  color?: Maybe<Array<Maybe<ReturnorderdConnectionColor>>>;
  returnorderh?: Maybe<Array<Maybe<ReturnorderdConnectionReturnorderh>>>;
  discount?: Maybe<Array<Maybe<ReturnorderdConnectionDiscount>>>;
};

export type ReturnorderdConnectionId = {
  __typename?: 'ReturnorderdConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReturnorderdConnection>;
};

export type ReturnorderdConnectionCreated_At = {
  __typename?: 'ReturnorderdConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ReturnorderdConnection>;
};

export type ReturnorderdConnectionUpdated_At = {
  __typename?: 'ReturnorderdConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ReturnorderdConnection>;
};

export type ReturnorderdConnectionQty = {
  __typename?: 'ReturnorderdConnectionQty';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<ReturnorderdConnection>;
};

export type ReturnorderdConnectionPrice = {
  __typename?: 'ReturnorderdConnectionPrice';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<ReturnorderdConnection>;
};

export type ReturnorderdConnectionProduct = {
  __typename?: 'ReturnorderdConnectionProduct';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReturnorderdConnection>;
};

export type ReturnorderdConnectionColor = {
  __typename?: 'ReturnorderdConnectionColor';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReturnorderdConnection>;
};

export type ReturnorderdConnectionReturnorderh = {
  __typename?: 'ReturnorderdConnectionReturnorderh';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReturnorderdConnection>;
};

export type ReturnorderdConnectionDiscount = {
  __typename?: 'ReturnorderdConnectionDiscount';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<ReturnorderdConnection>;
};

export type ReturnorderdAggregator = {
  __typename?: 'ReturnorderdAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<ReturnorderdAggregatorSum>;
  avg?: Maybe<ReturnorderdAggregatorAvg>;
  min?: Maybe<ReturnorderdAggregatorMin>;
  max?: Maybe<ReturnorderdAggregatorMax>;
};

export type ReturnorderdAggregatorSum = {
  __typename?: 'ReturnorderdAggregatorSum';
  qty?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
};

export type ReturnorderdAggregatorAvg = {
  __typename?: 'ReturnorderdAggregatorAvg';
  qty?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
};

export type ReturnorderdAggregatorMin = {
  __typename?: 'ReturnorderdAggregatorMin';
  qty?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
};

export type ReturnorderdAggregatorMax = {
  __typename?: 'ReturnorderdAggregatorMax';
  qty?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
};

export type ReturnorderhConnection = {
  __typename?: 'ReturnorderhConnection';
  values?: Maybe<Array<Maybe<Returnorderh>>>;
  groupBy?: Maybe<ReturnorderhGroupBy>;
  aggregate?: Maybe<ReturnorderhAggregator>;
};

export type ReturnorderhGroupBy = {
  __typename?: 'ReturnorderhGroupBy';
  id?: Maybe<Array<Maybe<ReturnorderhConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ReturnorderhConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ReturnorderhConnectionUpdated_At>>>;
  orderCode?: Maybe<Array<Maybe<ReturnorderhConnectionOrderCode>>>;
  netAmt?: Maybe<Array<Maybe<ReturnorderhConnectionNetAmt>>>;
  user?: Maybe<Array<Maybe<ReturnorderhConnectionUser>>>;
  status?: Maybe<Array<Maybe<ReturnorderhConnectionStatus>>>;
  orderh?: Maybe<Array<Maybe<ReturnorderhConnectionOrderh>>>;
  reason?: Maybe<Array<Maybe<ReturnorderhConnectionReason>>>;
  voucher?: Maybe<Array<Maybe<ReturnorderhConnectionVoucher>>>;
};

export type ReturnorderhConnectionId = {
  __typename?: 'ReturnorderhConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReturnorderhConnection>;
};

export type ReturnorderhConnectionCreated_At = {
  __typename?: 'ReturnorderhConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ReturnorderhConnection>;
};

export type ReturnorderhConnectionUpdated_At = {
  __typename?: 'ReturnorderhConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ReturnorderhConnection>;
};

export type ReturnorderhConnectionOrderCode = {
  __typename?: 'ReturnorderhConnectionOrderCode';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ReturnorderhConnection>;
};

export type ReturnorderhConnectionNetAmt = {
  __typename?: 'ReturnorderhConnectionNetAmt';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<ReturnorderhConnection>;
};

export type ReturnorderhConnectionUser = {
  __typename?: 'ReturnorderhConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReturnorderhConnection>;
};

export type ReturnorderhConnectionStatus = {
  __typename?: 'ReturnorderhConnectionStatus';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReturnorderhConnection>;
};

export type ReturnorderhConnectionOrderh = {
  __typename?: 'ReturnorderhConnectionOrderh';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReturnorderhConnection>;
};

export type ReturnorderhConnectionReason = {
  __typename?: 'ReturnorderhConnectionReason';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ReturnorderhConnection>;
};

export type ReturnorderhConnectionVoucher = {
  __typename?: 'ReturnorderhConnectionVoucher';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReturnorderhConnection>;
};

export type ReturnorderhAggregator = {
  __typename?: 'ReturnorderhAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<ReturnorderhAggregatorSum>;
  avg?: Maybe<ReturnorderhAggregatorAvg>;
  min?: Maybe<ReturnorderhAggregatorMin>;
  max?: Maybe<ReturnorderhAggregatorMax>;
};

export type ReturnorderhAggregatorSum = {
  __typename?: 'ReturnorderhAggregatorSum';
  netAmt?: Maybe<Scalars['Float']>;
};

export type ReturnorderhAggregatorAvg = {
  __typename?: 'ReturnorderhAggregatorAvg';
  netAmt?: Maybe<Scalars['Float']>;
};

export type ReturnorderhAggregatorMin = {
  __typename?: 'ReturnorderhAggregatorMin';
  netAmt?: Maybe<Scalars['Float']>;
};

export type ReturnorderhAggregatorMax = {
  __typename?: 'ReturnorderhAggregatorMax';
  netAmt?: Maybe<Scalars['Float']>;
};

export type Review = {
  __typename?: 'Review';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  review?: Maybe<Scalars['String']>;
  users_permissions_user?: Maybe<UsersPermissionsUser>;
  product?: Maybe<Product>;
  rating?: Maybe<Scalars['Int']>;
  orderh?: Maybe<Orderh>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type ReviewConnection = {
  __typename?: 'ReviewConnection';
  values?: Maybe<Array<Maybe<Review>>>;
  groupBy?: Maybe<ReviewGroupBy>;
  aggregate?: Maybe<ReviewAggregator>;
};

export type ReviewGroupBy = {
  __typename?: 'ReviewGroupBy';
  id?: Maybe<Array<Maybe<ReviewConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ReviewConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ReviewConnectionUpdated_At>>>;
  review?: Maybe<Array<Maybe<ReviewConnectionReview>>>;
  users_permissions_user?: Maybe<Array<Maybe<ReviewConnectionUsers_Permissions_User>>>;
  product?: Maybe<Array<Maybe<ReviewConnectionProduct>>>;
  rating?: Maybe<Array<Maybe<ReviewConnectionRating>>>;
  orderh?: Maybe<Array<Maybe<ReviewConnectionOrderh>>>;
  published_at?: Maybe<Array<Maybe<ReviewConnectionPublished_At>>>;
};

export type ReviewConnectionId = {
  __typename?: 'ReviewConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReviewConnection>;
};

export type ReviewConnectionCreated_At = {
  __typename?: 'ReviewConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ReviewConnection>;
};

export type ReviewConnectionUpdated_At = {
  __typename?: 'ReviewConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ReviewConnection>;
};

export type ReviewConnectionReview = {
  __typename?: 'ReviewConnectionReview';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ReviewConnection>;
};

export type ReviewConnectionUsers_Permissions_User = {
  __typename?: 'ReviewConnectionUsers_permissions_user';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReviewConnection>;
};

export type ReviewConnectionProduct = {
  __typename?: 'ReviewConnectionProduct';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReviewConnection>;
};

export type ReviewConnectionRating = {
  __typename?: 'ReviewConnectionRating';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<ReviewConnection>;
};

export type ReviewConnectionOrderh = {
  __typename?: 'ReviewConnectionOrderh';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ReviewConnection>;
};

export type ReviewConnectionPublished_At = {
  __typename?: 'ReviewConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ReviewConnection>;
};

export type ReviewAggregator = {
  __typename?: 'ReviewAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<ReviewAggregatorSum>;
  avg?: Maybe<ReviewAggregatorAvg>;
  min?: Maybe<ReviewAggregatorMin>;
  max?: Maybe<ReviewAggregatorMax>;
};

export type ReviewAggregatorSum = {
  __typename?: 'ReviewAggregatorSum';
  rating?: Maybe<Scalars['Float']>;
};

export type ReviewAggregatorAvg = {
  __typename?: 'ReviewAggregatorAvg';
  rating?: Maybe<Scalars['Float']>;
};

export type ReviewAggregatorMin = {
  __typename?: 'ReviewAggregatorMin';
  rating?: Maybe<Scalars['Float']>;
};

export type ReviewAggregatorMax = {
  __typename?: 'ReviewAggregatorMax';
  rating?: Maybe<Scalars['Float']>;
};

export type ShippingdetailConnection = {
  __typename?: 'ShippingdetailConnection';
  values?: Maybe<Array<Maybe<Shippingdetail>>>;
  groupBy?: Maybe<ShippingdetailGroupBy>;
  aggregate?: Maybe<ShippingdetailAggregator>;
};

export type ShippingdetailGroupBy = {
  __typename?: 'ShippingdetailGroupBy';
  id?: Maybe<Array<Maybe<ShippingdetailConnectionId>>>;
  created_at?: Maybe<Array<Maybe<ShippingdetailConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<ShippingdetailConnectionUpdated_At>>>;
  firstName?: Maybe<Array<Maybe<ShippingdetailConnectionFirstName>>>;
  lastName?: Maybe<Array<Maybe<ShippingdetailConnectionLastName>>>;
  address1?: Maybe<Array<Maybe<ShippingdetailConnectionAddress1>>>;
  address2?: Maybe<Array<Maybe<ShippingdetailConnectionAddress2>>>;
  email?: Maybe<Array<Maybe<ShippingdetailConnectionEmail>>>;
  city?: Maybe<Array<Maybe<ShippingdetailConnectionCity>>>;
  tele1?: Maybe<Array<Maybe<ShippingdetailConnectionTele1>>>;
  tele2?: Maybe<Array<Maybe<ShippingdetailConnectionTele2>>>;
  useForPayments?: Maybe<Array<Maybe<ShippingdetailConnectionUseForPayments>>>;
  orderh?: Maybe<Array<Maybe<ShippingdetailConnectionOrderh>>>;
  user?: Maybe<Array<Maybe<ShippingdetailConnectionUser>>>;
  status?: Maybe<Array<Maybe<ShippingdetailConnectionStatus>>>;
  guestid?: Maybe<Array<Maybe<ShippingdetailConnectionGuestid>>>;
};

export type ShippingdetailConnectionId = {
  __typename?: 'ShippingdetailConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ShippingdetailConnection>;
};

export type ShippingdetailConnectionCreated_At = {
  __typename?: 'ShippingdetailConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ShippingdetailConnection>;
};

export type ShippingdetailConnectionUpdated_At = {
  __typename?: 'ShippingdetailConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<ShippingdetailConnection>;
};

export type ShippingdetailConnectionFirstName = {
  __typename?: 'ShippingdetailConnectionFirstName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ShippingdetailConnection>;
};

export type ShippingdetailConnectionLastName = {
  __typename?: 'ShippingdetailConnectionLastName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ShippingdetailConnection>;
};

export type ShippingdetailConnectionAddress1 = {
  __typename?: 'ShippingdetailConnectionAddress1';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ShippingdetailConnection>;
};

export type ShippingdetailConnectionAddress2 = {
  __typename?: 'ShippingdetailConnectionAddress2';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ShippingdetailConnection>;
};

export type ShippingdetailConnectionEmail = {
  __typename?: 'ShippingdetailConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ShippingdetailConnection>;
};

export type ShippingdetailConnectionCity = {
  __typename?: 'ShippingdetailConnectionCity';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ShippingdetailConnection>;
};

export type ShippingdetailConnectionTele1 = {
  __typename?: 'ShippingdetailConnectionTele1';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ShippingdetailConnection>;
};

export type ShippingdetailConnectionTele2 = {
  __typename?: 'ShippingdetailConnectionTele2';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ShippingdetailConnection>;
};

export type ShippingdetailConnectionUseForPayments = {
  __typename?: 'ShippingdetailConnectionUseForPayments';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<ShippingdetailConnection>;
};

export type ShippingdetailConnectionOrderh = {
  __typename?: 'ShippingdetailConnectionOrderh';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ShippingdetailConnection>;
};

export type ShippingdetailConnectionUser = {
  __typename?: 'ShippingdetailConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ShippingdetailConnection>;
};

export type ShippingdetailConnectionStatus = {
  __typename?: 'ShippingdetailConnectionStatus';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<ShippingdetailConnection>;
};

export type ShippingdetailConnectionGuestid = {
  __typename?: 'ShippingdetailConnectionGuestid';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<ShippingdetailConnection>;
};

export type ShippingdetailAggregator = {
  __typename?: 'ShippingdetailAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type StatusConnection = {
  __typename?: 'StatusConnection';
  values?: Maybe<Array<Maybe<Status>>>;
  groupBy?: Maybe<StatusGroupBy>;
  aggregate?: Maybe<StatusAggregator>;
};

export type StatusGroupBy = {
  __typename?: 'StatusGroupBy';
  id?: Maybe<Array<Maybe<StatusConnectionId>>>;
  created_at?: Maybe<Array<Maybe<StatusConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<StatusConnectionUpdated_At>>>;
  type?: Maybe<Array<Maybe<StatusConnectionType>>>;
};

export type StatusConnectionId = {
  __typename?: 'StatusConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<StatusConnection>;
};

export type StatusConnectionCreated_At = {
  __typename?: 'StatusConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<StatusConnection>;
};

export type StatusConnectionUpdated_At = {
  __typename?: 'StatusConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<StatusConnection>;
};

export type StatusConnectionType = {
  __typename?: 'StatusConnectionType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<StatusConnection>;
};

export type StatusAggregator = {
  __typename?: 'StatusAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type StoreConnection = {
  __typename?: 'StoreConnection';
  values?: Maybe<Array<Maybe<Store>>>;
  groupBy?: Maybe<StoreGroupBy>;
  aggregate?: Maybe<StoreAggregator>;
};

export type StoreGroupBy = {
  __typename?: 'StoreGroupBy';
  id?: Maybe<Array<Maybe<StoreConnectionId>>>;
  created_at?: Maybe<Array<Maybe<StoreConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<StoreConnectionUpdated_At>>>;
  storeName?: Maybe<Array<Maybe<StoreConnectionStoreName>>>;
};

export type StoreConnectionId = {
  __typename?: 'StoreConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<StoreConnection>;
};

export type StoreConnectionCreated_At = {
  __typename?: 'StoreConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<StoreConnection>;
};

export type StoreConnectionUpdated_At = {
  __typename?: 'StoreConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<StoreConnection>;
};

export type StoreConnectionStoreName = {
  __typename?: 'StoreConnectionStoreName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<StoreConnection>;
};

export type StoreAggregator = {
  __typename?: 'StoreAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type VoucherConnection = {
  __typename?: 'VoucherConnection';
  values?: Maybe<Array<Maybe<Voucher>>>;
  groupBy?: Maybe<VoucherGroupBy>;
  aggregate?: Maybe<VoucherAggregator>;
};

export type VoucherGroupBy = {
  __typename?: 'VoucherGroupBy';
  id?: Maybe<Array<Maybe<VoucherConnectionId>>>;
  created_at?: Maybe<Array<Maybe<VoucherConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<VoucherConnectionUpdated_At>>>;
  code?: Maybe<Array<Maybe<VoucherConnectionCode>>>;
  active?: Maybe<Array<Maybe<VoucherConnectionActive>>>;
  orderh?: Maybe<Array<Maybe<VoucherConnectionOrderh>>>;
  returnorderh?: Maybe<Array<Maybe<VoucherConnectionReturnorderh>>>;
  price?: Maybe<Array<Maybe<VoucherConnectionPrice>>>;
  orderd?: Maybe<Array<Maybe<VoucherConnectionOrderd>>>;
  email?: Maybe<Array<Maybe<VoucherConnectionEmail>>>;
  validMonth?: Maybe<Array<Maybe<VoucherConnectionValidMonth>>>;
  percentage?: Maybe<Array<Maybe<VoucherConnectionPercentage>>>;
  isPercentage?: Maybe<Array<Maybe<VoucherConnectionIsPercentage>>>;
};

export type VoucherConnectionId = {
  __typename?: 'VoucherConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VoucherConnection>;
};

export type VoucherConnectionCreated_At = {
  __typename?: 'VoucherConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<VoucherConnection>;
};

export type VoucherConnectionUpdated_At = {
  __typename?: 'VoucherConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<VoucherConnection>;
};

export type VoucherConnectionCode = {
  __typename?: 'VoucherConnectionCode';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VoucherConnection>;
};

export type VoucherConnectionActive = {
  __typename?: 'VoucherConnectionActive';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<VoucherConnection>;
};

export type VoucherConnectionOrderh = {
  __typename?: 'VoucherConnectionOrderh';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VoucherConnection>;
};

export type VoucherConnectionReturnorderh = {
  __typename?: 'VoucherConnectionReturnorderh';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VoucherConnection>;
};

export type VoucherConnectionPrice = {
  __typename?: 'VoucherConnectionPrice';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<VoucherConnection>;
};

export type VoucherConnectionOrderd = {
  __typename?: 'VoucherConnectionOrderd';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VoucherConnection>;
};

export type VoucherConnectionEmail = {
  __typename?: 'VoucherConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VoucherConnection>;
};

export type VoucherConnectionValidMonth = {
  __typename?: 'VoucherConnectionValidMonth';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<VoucherConnection>;
};

export type VoucherConnectionPercentage = {
  __typename?: 'VoucherConnectionPercentage';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<VoucherConnection>;
};

export type VoucherConnectionIsPercentage = {
  __typename?: 'VoucherConnectionIsPercentage';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<VoucherConnection>;
};

export type VoucherAggregator = {
  __typename?: 'VoucherAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<VoucherAggregatorSum>;
  avg?: Maybe<VoucherAggregatorAvg>;
  min?: Maybe<VoucherAggregatorMin>;
  max?: Maybe<VoucherAggregatorMax>;
};

export type VoucherAggregatorSum = {
  __typename?: 'VoucherAggregatorSum';
  price?: Maybe<Scalars['Float']>;
  validMonth?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
};

export type VoucherAggregatorAvg = {
  __typename?: 'VoucherAggregatorAvg';
  price?: Maybe<Scalars['Float']>;
  validMonth?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
};

export type VoucherAggregatorMin = {
  __typename?: 'VoucherAggregatorMin';
  price?: Maybe<Scalars['Float']>;
  validMonth?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
};

export type VoucherAggregatorMax = {
  __typename?: 'VoucherAggregatorMax';
  price?: Maybe<Scalars['Float']>;
  validMonth?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
};

export type VoucherhistoryConnection = {
  __typename?: 'VoucherhistoryConnection';
  values?: Maybe<Array<Maybe<Voucherhistory>>>;
  groupBy?: Maybe<VoucherhistoryGroupBy>;
  aggregate?: Maybe<VoucherhistoryAggregator>;
};

export type VoucherhistoryGroupBy = {
  __typename?: 'VoucherhistoryGroupBy';
  id?: Maybe<Array<Maybe<VoucherhistoryConnectionId>>>;
  created_at?: Maybe<Array<Maybe<VoucherhistoryConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<VoucherhistoryConnectionUpdated_At>>>;
  desp?: Maybe<Array<Maybe<VoucherhistoryConnectionDesp>>>;
  users_permissions_user?: Maybe<Array<Maybe<VoucherhistoryConnectionUsers_Permissions_User>>>;
  voucher?: Maybe<Array<Maybe<VoucherhistoryConnectionVoucher>>>;
  data?: Maybe<Array<Maybe<VoucherhistoryConnectionData>>>;
  published_at?: Maybe<Array<Maybe<VoucherhistoryConnectionPublished_At>>>;
};

export type VoucherhistoryConnectionId = {
  __typename?: 'VoucherhistoryConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VoucherhistoryConnection>;
};

export type VoucherhistoryConnectionCreated_At = {
  __typename?: 'VoucherhistoryConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<VoucherhistoryConnection>;
};

export type VoucherhistoryConnectionUpdated_At = {
  __typename?: 'VoucherhistoryConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<VoucherhistoryConnection>;
};

export type VoucherhistoryConnectionDesp = {
  __typename?: 'VoucherhistoryConnectionDesp';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<VoucherhistoryConnection>;
};

export type VoucherhistoryConnectionUsers_Permissions_User = {
  __typename?: 'VoucherhistoryConnectionUsers_permissions_user';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VoucherhistoryConnection>;
};

export type VoucherhistoryConnectionVoucher = {
  __typename?: 'VoucherhistoryConnectionVoucher';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<VoucherhistoryConnection>;
};

export type VoucherhistoryConnectionData = {
  __typename?: 'VoucherhistoryConnectionData';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<VoucherhistoryConnection>;
};

export type VoucherhistoryConnectionPublished_At = {
  __typename?: 'VoucherhistoryConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<VoucherhistoryConnection>;
};

export type VoucherhistoryAggregator = {
  __typename?: 'VoucherhistoryAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type WarrantyConnection = {
  __typename?: 'WarrantyConnection';
  values?: Maybe<Array<Maybe<Warranty>>>;
  groupBy?: Maybe<WarrantyGroupBy>;
  aggregate?: Maybe<WarrantyAggregator>;
};

export type WarrantyGroupBy = {
  __typename?: 'WarrantyGroupBy';
  id?: Maybe<Array<Maybe<WarrantyConnectionId>>>;
  created_at?: Maybe<Array<Maybe<WarrantyConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<WarrantyConnectionUpdated_At>>>;
  warranty?: Maybe<Array<Maybe<WarrantyConnectionWarranty>>>;
  inactive?: Maybe<Array<Maybe<WarrantyConnectionInactive>>>;
};

export type WarrantyConnectionId = {
  __typename?: 'WarrantyConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<WarrantyConnection>;
};

export type WarrantyConnectionCreated_At = {
  __typename?: 'WarrantyConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<WarrantyConnection>;
};

export type WarrantyConnectionUpdated_At = {
  __typename?: 'WarrantyConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<WarrantyConnection>;
};

export type WarrantyConnectionWarranty = {
  __typename?: 'WarrantyConnectionWarranty';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<WarrantyConnection>;
};

export type WarrantyConnectionInactive = {
  __typename?: 'WarrantyConnectionInactive';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<WarrantyConnection>;
};

export type WarrantyAggregator = {
  __typename?: 'WarrantyAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type WebContent = {
  __typename?: 'WebContent';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  title?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  desp?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
  isLeft?: Maybe<Scalars['Boolean']>;
  mobileImage?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  mobileColor?: Maybe<Scalars['String']>;
  imageOnly?: Maybe<Scalars['Boolean']>;
};

export type WebContentConnection = {
  __typename?: 'WebContentConnection';
  values?: Maybe<Array<Maybe<WebContent>>>;
  groupBy?: Maybe<WebContentGroupBy>;
  aggregate?: Maybe<WebContentAggregator>;
};

export type WebContentGroupBy = {
  __typename?: 'WebContentGroupBy';
  id?: Maybe<Array<Maybe<WebContentConnectionId>>>;
  created_at?: Maybe<Array<Maybe<WebContentConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<WebContentConnectionUpdated_At>>>;
  title?: Maybe<Array<Maybe<WebContentConnectionTitle>>>;
  image?: Maybe<Array<Maybe<WebContentConnectionImage>>>;
  link?: Maybe<Array<Maybe<WebContentConnectionLink>>>;
  type?: Maybe<Array<Maybe<WebContentConnectionType>>>;
  desp?: Maybe<Array<Maybe<WebContentConnectionDesp>>>;
  linkText?: Maybe<Array<Maybe<WebContentConnectionLinkText>>>;
  isLeft?: Maybe<Array<Maybe<WebContentConnectionIsLeft>>>;
  mobileImage?: Maybe<Array<Maybe<WebContentConnectionMobileImage>>>;
  color?: Maybe<Array<Maybe<WebContentConnectionColor>>>;
  mobileColor?: Maybe<Array<Maybe<WebContentConnectionMobileColor>>>;
  imageOnly?: Maybe<Array<Maybe<WebContentConnectionImageOnly>>>;
};

export type WebContentConnectionId = {
  __typename?: 'WebContentConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<WebContentConnection>;
};

export type WebContentConnectionCreated_At = {
  __typename?: 'WebContentConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<WebContentConnection>;
};

export type WebContentConnectionUpdated_At = {
  __typename?: 'WebContentConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<WebContentConnection>;
};

export type WebContentConnectionTitle = {
  __typename?: 'WebContentConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<WebContentConnection>;
};

export type WebContentConnectionImage = {
  __typename?: 'WebContentConnectionImage';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<WebContentConnection>;
};

export type WebContentConnectionLink = {
  __typename?: 'WebContentConnectionLink';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<WebContentConnection>;
};

export type WebContentConnectionType = {
  __typename?: 'WebContentConnectionType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<WebContentConnection>;
};

export type WebContentConnectionDesp = {
  __typename?: 'WebContentConnectionDesp';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<WebContentConnection>;
};

export type WebContentConnectionLinkText = {
  __typename?: 'WebContentConnectionLinkText';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<WebContentConnection>;
};

export type WebContentConnectionIsLeft = {
  __typename?: 'WebContentConnectionIsLeft';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<WebContentConnection>;
};

export type WebContentConnectionMobileImage = {
  __typename?: 'WebContentConnectionMobileImage';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<WebContentConnection>;
};

export type WebContentConnectionColor = {
  __typename?: 'WebContentConnectionColor';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<WebContentConnection>;
};

export type WebContentConnectionMobileColor = {
  __typename?: 'WebContentConnectionMobileColor';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<WebContentConnection>;
};

export type WebContentConnectionImageOnly = {
  __typename?: 'WebContentConnectionImageOnly';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<WebContentConnection>;
};

export type WebContentAggregator = {
  __typename?: 'WebContentAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type WishListConnection = {
  __typename?: 'WishListConnection';
  values?: Maybe<Array<Maybe<WishList>>>;
  groupBy?: Maybe<WishListGroupBy>;
  aggregate?: Maybe<WishListAggregator>;
};

export type WishListGroupBy = {
  __typename?: 'WishListGroupBy';
  id?: Maybe<Array<Maybe<WishListConnectionId>>>;
  created_at?: Maybe<Array<Maybe<WishListConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<WishListConnectionUpdated_At>>>;
  user?: Maybe<Array<Maybe<WishListConnectionUser>>>;
  product?: Maybe<Array<Maybe<WishListConnectionProduct>>>;
};

export type WishListConnectionId = {
  __typename?: 'WishListConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<WishListConnection>;
};

export type WishListConnectionCreated_At = {
  __typename?: 'WishListConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<WishListConnection>;
};

export type WishListConnectionUpdated_At = {
  __typename?: 'WishListConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<WishListConnection>;
};

export type WishListConnectionUser = {
  __typename?: 'WishListConnectionUser';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<WishListConnection>;
};

export type WishListConnectionProduct = {
  __typename?: 'WishListConnectionProduct';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<WishListConnection>;
};

export type WishListAggregator = {
  __typename?: 'WishListAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Morph>>>;
};


export type UploadFileRelatedArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type Morph = DeletedItem | Order | TempCheckoutPayload | CheckoutResponse | Availability | DeliveryOrder | Filters | UsersPermissionsMe | UsersPermissionsMeRole | UsersPermissionsLoginPayload | UserPermissionsPasswordPayload | Billingdetail | BillingdetailConnection | BillingdetailAggregator | BillingdetailGroupBy | BillingdetailConnectionId | BillingdetailConnectionCreated_At | BillingdetailConnectionUpdated_At | BillingdetailConnectionFirstName | BillingdetailConnectionLastName | BillingdetailConnectionAddress1 | BillingdetailConnectionAddress2 | BillingdetailConnectionEmail | BillingdetailConnectionTele1 | BillingdetailConnectionTele2 | BillingdetailConnectionCity | BillingdetailConnectionOrderh | BillingdetailConnectionUser | BillingdetailConnectionStatus | BillingdetailConnectionGuestid | CreateBillingdetailPayload | UpdateBillingdetailPayload | DeleteBillingdetailPayload | Brand | BrandConnection | BrandAggregator | BrandGroupBy | BrandConnectionId | BrandConnectionCreated_At | BrandConnectionUpdated_At | BrandConnectionBrandName | BrandConnectionInactive | CreateBrandPayload | UpdateBrandPayload | DeleteBrandPayload | Cart | CartConnection | CartAggregator | CartAggregatorSum | CartAggregatorAvg | CartAggregatorMin | CartAggregatorMax | CartGroupBy | CartConnectionId | CartConnectionCreated_At | CartConnectionUpdated_At | CartConnectionQty | CartConnectionPrice | CartConnectionProduct | CartConnectionUser | CartConnectionColor | CartConnectionDiscount | CreateCartPayload | UpdateCartPayload | DeleteCartPayload | CatTypeTag | CatTypeTagConnection | CatTypeTagAggregator | CatTypeTagGroupBy | CatTypeTagConnectionId | CatTypeTagConnectionCreated_At | CatTypeTagConnectionUpdated_At | CatTypeTagConnectionTagName | CreateCatTypeTagPayload | UpdateCatTypeTagPayload | DeleteCatTypeTagPayload | Category | CategoryConnection | CategoryAggregator | CategoryAggregatorSum | CategoryAggregatorAvg | CategoryAggregatorMin | CategoryAggregatorMax | CategoryGroupBy | CategoryConnectionId | CategoryConnectionCreated_At | CategoryConnectionUpdated_At | CategoryConnectionCategoryName | CategoryConnectionInactive | CategoryConnectionIcon | CategoryConnectionImage | CategoryConnectionSurcharge | CreateCategoryPayload | UpdateCategoryPayload | DeleteCategoryPayload | City | CityConnection | CityAggregator | CityAggregatorSum | CityAggregatorAvg | CityAggregatorMin | CityAggregatorMax | CityGroupBy | CityConnectionId | CityConnectionCreated_At | CityConnectionUpdated_At | CityConnectionCityName | CityConnectionDistrict | CityConnectionPostalCode | CityConnectionLatitude | CityConnectionLongitude | CreateCityPayload | UpdateCityPayload | DeleteCityPayload | ColorCat | ColorCatConnection | ColorCatAggregator | ColorCatAggregatorSum | ColorCatAggregatorAvg | ColorCatAggregatorMin | ColorCatAggregatorMax | ColorCatGroupBy | ColorCatConnectionId | ColorCatConnectionCreated_At | ColorCatConnectionUpdated_At | ColorCatConnectionColorCode | ColorCatConnectionColor | ColorCatConnectionColorPrice | ColorCatConnectionColorStock | ColorCatConnectionProduct | ColorCatConnectionImg | ColorCatConnectionColorDiscount | ColorCatConnectionMaterial | ColorCatConnectionClosure_Type | ColorCatConnectionLockable | ColorCatConnectionLaptop_Com | ColorCatConnectionLaptop_Size | ColorCatConnectionWarranty | ColorCatConnectionP_Length | ColorCatConnectionWidth | ColorCatConnectionHeight | ColorCatConnectionWeight | ColorCatConnectionInActive | ColorCatConnectionFeatured | ColorCatConnectionIncluded | CreateColorCatPayload | UpdateColorCatPayload | DeleteColorCatPayload | ColorImage | ColorImageConnection | ColorImageAggregator | ColorImageGroupBy | ColorImageConnectionId | ColorImageConnectionCreated_At | ColorImageConnectionUpdated_At | ColorImageConnectionColor_Cat | ColorImageConnectionImage | CreateColorImagePayload | UpdateColorImagePayload | DeleteColorImagePayload | Color | ColorConnection | ColorAggregator | ColorGroupBy | ColorConnectionId | ColorConnectionCreated_At | ColorConnectionUpdated_At | ColorConnectionColorName | ColorConnectionColorHex | ColorConnectionIsTwoTone | ColorConnectionColorHex2 | CreateColorPayload | UpdateColorPayload | DeleteColorPayload | Contact | ContactConnection | ContactAggregator | ContactGroupBy | ContactConnectionId | ContactConnectionCreated_At | ContactConnectionUpdated_At | ContactConnectionName | ContactConnectionEmail | ContactConnectionMessage | ContactConnectionPhone | CreateContactPayload | UpdateContactPayload | DeleteContactPayload | Customer | CustomerConnection | CustomerAggregator | CustomerGroupBy | CustomerConnectionId | CustomerConnectionCreated_At | CustomerConnectionUpdated_At | CustomerConnectionAddress1 | CustomerConnectionAddress2 | CustomerConnectionPhoneNumber | CustomerConnectionCountry | CustomerConnectionUser | CustomerConnectionFirstName | CustomerConnectionLastName | CustomerConnectionCity | CreateCustomerPayload | UpdateCustomerPayload | DeleteCustomerPayload | District | DistrictConnection | DistrictAggregator | DistrictAggregatorSum | DistrictAggregatorAvg | DistrictAggregatorMin | DistrictAggregatorMax | DistrictGroupBy | DistrictConnectionId | DistrictConnectionCreated_At | DistrictConnectionUpdated_At | DistrictConnectionDistrictName | DistrictConnectionProvince | DistrictConnectionDeliveryCharge1 | DistrictConnectionDeliveryCharge2 | DistrictConnectionDeliveryCharge3 | DistrictConnectionDeliveryCharge4 | CreateDistrictPayload | UpdateDistrictPayload | DeleteDistrictPayload | HitCount | HitCountConnection | HitCountAggregator | HitCountAggregatorSum | HitCountAggregatorAvg | HitCountAggregatorMin | HitCountAggregatorMax | HitCountGroupBy | HitCountConnectionId | HitCountConnectionCreated_At | HitCountConnectionUpdated_At | HitCountConnectionHit_Date | HitCountConnectionH_Count | HitCountConnectionProduct | HitCountConnectionPublished_At | CreateHitCountPayload | UpdateHitCountPayload | DeleteHitCountPayload | Log | LogConnection | LogAggregator | LogGroupBy | LogConnectionId | LogConnectionCreated_At | LogConnectionUpdated_At | LogConnectionDesp | LogConnectionFuncName | LogConnectionUser | CreateLogPayload | UpdateLogPayload | DeleteLogPayload | Material | MaterialConnection | MaterialAggregator | MaterialGroupBy | MaterialConnectionId | MaterialConnectionCreated_At | MaterialConnectionUpdated_At | MaterialConnectionName | CreateMaterialPayload | UpdateMaterialPayload | DeleteMaterialPayload | Misc | MiscConnection | MiscAggregator | MiscGroupBy | MiscConnectionId | MiscConnectionCreated_At | MiscConnectionUpdated_At | MiscConnectionShouldOpenBanner | MiscConnectionLaunchCode | CreateMiscPayload | UpdateMiscPayload | DeleteMiscPayload | Newsletter | NewsletterConnection | NewsletterAggregator | NewsletterGroupBy | NewsletterConnectionId | NewsletterConnectionCreated_At | NewsletterConnectionUpdated_At | NewsletterConnectionEmail | CreateNewsletterPayload | UpdateNewsletterPayload | DeleteNewsletterPayload | Notifystock | NotifystockConnection | NotifystockAggregator | NotifystockGroupBy | NotifystockConnectionId | NotifystockConnectionCreated_At | NotifystockConnectionUpdated_At | NotifystockConnectionUsers_Permissions_User | NotifystockConnectionColorCode | NotifystockConnectionEmail | NotifystockConnectionPhone | CreateNotifystockPayload | UpdateNotifystockPayload | DeleteNotifystockPayload | Orderd | OrderdConnection | OrderdAggregator | OrderdAggregatorSum | OrderdAggregatorAvg | OrderdAggregatorMin | OrderdAggregatorMax | OrderdGroupBy | OrderdConnectionId | OrderdConnectionCreated_At | OrderdConnectionUpdated_At | OrderdConnectionQty | OrderdConnectionPrice | OrderdConnectionProduct | OrderdConnectionOrderh | OrderdConnectionColor | OrderdConnectionDeliveryPerson | OrderdConnectionStatus | OrderdConnectionDiscount | CreateOrderdPayload | UpdateOrderdPayload | DeleteOrderdPayload | Orderh | OrderhConnection | OrderhAggregator | OrderhAggregatorSum | OrderhAggregatorAvg | OrderhAggregatorMin | OrderhAggregatorMax | OrderhGroupBy | OrderhConnectionId | OrderhConnectionCreated_At | OrderhConnectionUpdated_At | OrderhConnectionNetAmt | OrderhConnectionOrderCode | OrderhConnectionUser | OrderhConnectionStatus | OrderhConnectionPaymentId | OrderhConnectionPaidAmount | OrderhConnectionCardName | OrderhConnectionCardExp | OrderhConnectionCardNo | OrderhConnectionDeliveryCost | OrderhConnectionInvoiceDate | OrderhConnectionReturned | OrderhConnectionVoucher | OrderhConnectionSpecialDiscount | OrderhConnectionGuestid | OrderhConnectionSurcharge | CreateOrderhPayload | UpdateOrderhPayload | DeleteOrderhPayload | Orderhistory | OrderhistoryConnection | OrderhistoryAggregator | OrderhistoryGroupBy | OrderhistoryConnectionId | OrderhistoryConnectionCreated_At | OrderhistoryConnectionUpdated_At | OrderhistoryConnectionOrderh | OrderhistoryConnectionStatus | CreateOrderhistoryPayload | UpdateOrderhistoryPayload | DeleteOrderhistoryPayload | Paymentselection | PaymentselectionConnection | PaymentselectionAggregator | PaymentselectionGroupBy | PaymentselectionConnectionId | PaymentselectionConnectionCreated_At | PaymentselectionConnectionUpdated_At | PaymentselectionConnectionMethod | PaymentselectionConnectionUser | PaymentselectionConnectionOrderh | PaymentselectionConnectionStatus | PaymentselectionConnectionDeliveryMethod | PaymentselectionConnectionSenderName | PaymentselectionConnectionNote | PaymentselectionConnectionGuestid | PaymentselectionConnectionMintpayId | CreatePaymentselectionPayload | UpdatePaymentselectionPayload | DeletePaymentselectionPayload | Product | ProductConnection | ProductAggregator | ProductAggregatorSum | ProductAggregatorAvg | ProductAggregatorMin | ProductAggregatorMax | ProductGroupBy | ProductConnectionId | ProductConnectionCreated_At | ProductConnectionUpdated_At | ProductConnectionProductCode | ProductConnectionSerialNo | ProductConnectionProductName | ProductConnectionPrice | ProductConnectionDiscount | ProductConnectionBrand | ProductConnectionCategory | ProductConnectionFeaturedItem | ProductConnectionInactive | ProductConnectionProductDescription | ProductConnectionImage | ProductConnectionSpec | ProductConnectionWarranty | ProductConnectionStock | ProductConnectionStore | ProductConnectionHitCount | ProductConnectionIsVoucher | ProductConnectionMaterial | CreateProductPayload | UpdateProductPayload | DeleteProductPayload | Productimage | ProductimageConnection | ProductimageAggregator | ProductimageGroupBy | ProductimageConnectionId | ProductimageConnectionCreated_At | ProductimageConnectionUpdated_At | ProductimageConnectionImage | ProductimageConnectionProduct | CreateProductimagePayload | UpdateProductimagePayload | DeleteProductimagePayload | Province | ProvinceConnection | ProvinceAggregator | ProvinceGroupBy | ProvinceConnectionId | ProvinceConnectionCreated_At | ProvinceConnectionUpdated_At | ProvinceConnectionProvinceName | CreateProvincePayload | UpdateProvincePayload | DeleteProvincePayload | Returnorderd | ReturnorderdConnection | ReturnorderdAggregator | ReturnorderdAggregatorSum | ReturnorderdAggregatorAvg | ReturnorderdAggregatorMin | ReturnorderdAggregatorMax | ReturnorderdGroupBy | ReturnorderdConnectionId | ReturnorderdConnectionCreated_At | ReturnorderdConnectionUpdated_At | ReturnorderdConnectionQty | ReturnorderdConnectionPrice | ReturnorderdConnectionProduct | ReturnorderdConnectionColor | ReturnorderdConnectionReturnorderh | ReturnorderdConnectionDiscount | CreateReturnorderdPayload | UpdateReturnorderdPayload | DeleteReturnorderdPayload | Returnorderh | ReturnorderhConnection | ReturnorderhAggregator | ReturnorderhAggregatorSum | ReturnorderhAggregatorAvg | ReturnorderhAggregatorMin | ReturnorderhAggregatorMax | ReturnorderhGroupBy | ReturnorderhConnectionId | ReturnorderhConnectionCreated_At | ReturnorderhConnectionUpdated_At | ReturnorderhConnectionOrderCode | ReturnorderhConnectionNetAmt | ReturnorderhConnectionUser | ReturnorderhConnectionStatus | ReturnorderhConnectionOrderh | ReturnorderhConnectionReason | ReturnorderhConnectionVoucher | CreateReturnorderhPayload | UpdateReturnorderhPayload | DeleteReturnorderhPayload | Review | ReviewConnection | ReviewAggregator | ReviewAggregatorSum | ReviewAggregatorAvg | ReviewAggregatorMin | ReviewAggregatorMax | ReviewGroupBy | ReviewConnectionId | ReviewConnectionCreated_At | ReviewConnectionUpdated_At | ReviewConnectionReview | ReviewConnectionUsers_Permissions_User | ReviewConnectionProduct | ReviewConnectionRating | ReviewConnectionOrderh | ReviewConnectionPublished_At | CreateReviewPayload | UpdateReviewPayload | DeleteReviewPayload | Shippingdetail | ShippingdetailConnection | ShippingdetailAggregator | ShippingdetailGroupBy | ShippingdetailConnectionId | ShippingdetailConnectionCreated_At | ShippingdetailConnectionUpdated_At | ShippingdetailConnectionFirstName | ShippingdetailConnectionLastName | ShippingdetailConnectionAddress1 | ShippingdetailConnectionAddress2 | ShippingdetailConnectionEmail | ShippingdetailConnectionCity | ShippingdetailConnectionTele1 | ShippingdetailConnectionTele2 | ShippingdetailConnectionUseForPayments | ShippingdetailConnectionOrderh | ShippingdetailConnectionUser | ShippingdetailConnectionStatus | ShippingdetailConnectionGuestid | CreateShippingdetailPayload | UpdateShippingdetailPayload | DeleteShippingdetailPayload | Status | StatusConnection | StatusAggregator | StatusGroupBy | StatusConnectionId | StatusConnectionCreated_At | StatusConnectionUpdated_At | StatusConnectionType | CreateStatusPayload | UpdateStatusPayload | DeleteStatusPayload | Store | StoreConnection | StoreAggregator | StoreGroupBy | StoreConnectionId | StoreConnectionCreated_At | StoreConnectionUpdated_At | StoreConnectionStoreName | CreateStorePayload | UpdateStorePayload | DeleteStorePayload | Voucher | VoucherConnection | VoucherAggregator | VoucherAggregatorSum | VoucherAggregatorAvg | VoucherAggregatorMin | VoucherAggregatorMax | VoucherGroupBy | VoucherConnectionId | VoucherConnectionCreated_At | VoucherConnectionUpdated_At | VoucherConnectionCode | VoucherConnectionActive | VoucherConnectionOrderh | VoucherConnectionReturnorderh | VoucherConnectionPrice | VoucherConnectionOrderd | VoucherConnectionEmail | VoucherConnectionValidMonth | VoucherConnectionPercentage | VoucherConnectionIsPercentage | CreateVoucherPayload | UpdateVoucherPayload | DeleteVoucherPayload | Voucherhistory | VoucherhistoryConnection | VoucherhistoryAggregator | VoucherhistoryGroupBy | VoucherhistoryConnectionId | VoucherhistoryConnectionCreated_At | VoucherhistoryConnectionUpdated_At | VoucherhistoryConnectionDesp | VoucherhistoryConnectionUsers_Permissions_User | VoucherhistoryConnectionVoucher | VoucherhistoryConnectionData | VoucherhistoryConnectionPublished_At | CreateVoucherhistoryPayload | UpdateVoucherhistoryPayload | DeleteVoucherhistoryPayload | Warranty | WarrantyConnection | WarrantyAggregator | WarrantyGroupBy | WarrantyConnectionId | WarrantyConnectionCreated_At | WarrantyConnectionUpdated_At | WarrantyConnectionWarranty | WarrantyConnectionInactive | CreateWarrantyPayload | UpdateWarrantyPayload | DeleteWarrantyPayload | WebContent | WebContentConnection | WebContentAggregator | WebContentGroupBy | WebContentConnectionId | WebContentConnectionCreated_At | WebContentConnectionUpdated_At | WebContentConnectionTitle | WebContentConnectionImage | WebContentConnectionLink | WebContentConnectionType | WebContentConnectionDesp | WebContentConnectionLinkText | WebContentConnectionIsLeft | WebContentConnectionMobileImage | WebContentConnectionColor | WebContentConnectionMobileColor | WebContentConnectionImageOnly | CreateWebContentPayload | UpdateWebContentPayload | DeleteWebContentPayload | WishList | WishListConnection | WishListAggregator | WishListGroupBy | WishListConnectionId | WishListConnectionCreated_At | WishListConnectionUpdated_At | WishListConnectionUser | WishListConnectionProduct | CreateWishListPayload | UpdateWishListPayload | DeleteWishListPayload | UploadFile | UploadFileConnection | UploadFileAggregator | UploadFileAggregatorSum | UploadFileAggregatorAvg | UploadFileAggregatorMin | UploadFileAggregatorMax | UploadFileGroupBy | UploadFileConnectionId | UploadFileConnectionCreated_At | UploadFileConnectionUpdated_At | UploadFileConnectionName | UploadFileConnectionAlternativeText | UploadFileConnectionCaption | UploadFileConnectionWidth | UploadFileConnectionHeight | UploadFileConnectionFormats | UploadFileConnectionHash | UploadFileConnectionExt | UploadFileConnectionMime | UploadFileConnectionSize | UploadFileConnectionUrl | UploadFileConnectionPreviewUrl | UploadFileConnectionProvider | UploadFileConnectionProvider_Metadata | DeleteFilePayload | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsRoleConnection | UsersPermissionsRoleAggregator | UsersPermissionsRoleGroupBy | UsersPermissionsRoleConnectionId | UsersPermissionsRoleConnectionName | UsersPermissionsRoleConnectionDescription | UsersPermissionsRoleConnectionType | CreateRolePayload | UpdateRolePayload | DeleteRolePayload | UsersPermissionsUser | UsersPermissionsUserConnection | UsersPermissionsUserAggregator | UsersPermissionsUserGroupBy | UsersPermissionsUserConnectionId | UsersPermissionsUserConnectionCreated_At | UsersPermissionsUserConnectionUpdated_At | UsersPermissionsUserConnectionUsername | UsersPermissionsUserConnectionEmail | UsersPermissionsUserConnectionProvider | UsersPermissionsUserConnectionConfirmed | UsersPermissionsUserConnectionBlocked | UsersPermissionsUserConnectionRole | UsersPermissionsUserConnectionTele | UsersPermissionsUserConnectionCustomer | UsersPermissionsUserConnectionInitialDiscount | CreateUserPayload | UpdateUserPayload | DeleteUserPayload;

export type DeletedItem = {
  __typename?: 'DeletedItem';
  id: Scalars['Int'];
};

export type Order = {
  __typename?: 'Order';
  id: Scalars['Int'];
  netAmt: Scalars['Float'];
  email: Scalars['String'];
  tele1: Scalars['String'];
  orderCode: Scalars['String'];
  specialDiscount: Scalars['Float'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  address1: Scalars['String'];
  address2: Scalars['String'];
  city: Scalars['String'];
  cityName: Scalars['String'];
};

export type TempCheckoutPayload = {
  __typename?: 'TempCheckoutPayload';
  order: Order;
  ak: Scalars['String'];
  mi: Scalars['String'];
  mintpayId?: Maybe<Scalars['Int']>;
};

export type CheckoutResponse = {
  __typename?: 'CheckoutResponse';
  success: Scalars['Boolean'];
  err?: Maybe<Scalars['String']>;
};

export type Availability = {
  __typename?: 'Availability';
  isAvailable: Scalars['Boolean'];
  msg?: Maybe<Scalars['String']>;
};

export type DeliveryOrder = {
  __typename?: 'DeliveryOrder';
  id: Scalars['ID'];
  orderCode: Scalars['String'];
  status: Scalars['String'];
  statusId: Scalars['Int'];
};

export type Filters = {
  __typename?: 'Filters';
  categories: Array<Maybe<Category>>;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  id: Scalars['ID'];
  username: Scalars['String'];
  email: Scalars['String'];
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsMeRole>;
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']>;
  user: UsersPermissionsMe;
};

export type UserPermissionsPasswordPayload = {
  __typename?: 'UserPermissionsPasswordPayload';
  ok: Scalars['Boolean'];
};

export type CreateBillingdetailPayload = {
  __typename?: 'createBillingdetailPayload';
  billingdetail?: Maybe<Billingdetail>;
};

export type UpdateBillingdetailPayload = {
  __typename?: 'updateBillingdetailPayload';
  billingdetail?: Maybe<Billingdetail>;
};

export type DeleteBillingdetailPayload = {
  __typename?: 'deleteBillingdetailPayload';
  billingdetail?: Maybe<Billingdetail>;
};

export type CreateBrandPayload = {
  __typename?: 'createBrandPayload';
  brand?: Maybe<Brand>;
};

export type UpdateBrandPayload = {
  __typename?: 'updateBrandPayload';
  brand?: Maybe<Brand>;
};

export type DeleteBrandPayload = {
  __typename?: 'deleteBrandPayload';
  brand?: Maybe<Brand>;
};

export type CreateCartPayload = {
  __typename?: 'createCartPayload';
  cart?: Maybe<Cart>;
};

export type UpdateCartPayload = {
  __typename?: 'updateCartPayload';
  cart?: Maybe<Cart>;
};

export type DeleteCartPayload = {
  __typename?: 'deleteCartPayload';
  cart?: Maybe<Cart>;
};

export type CreateCatTypeTagPayload = {
  __typename?: 'createCatTypeTagPayload';
  catTypeTag?: Maybe<CatTypeTag>;
};

export type UpdateCatTypeTagPayload = {
  __typename?: 'updateCatTypeTagPayload';
  catTypeTag?: Maybe<CatTypeTag>;
};

export type DeleteCatTypeTagPayload = {
  __typename?: 'deleteCatTypeTagPayload';
  catTypeTag?: Maybe<CatTypeTag>;
};

export type CreateCategoryPayload = {
  __typename?: 'createCategoryPayload';
  category?: Maybe<Category>;
};

export type UpdateCategoryPayload = {
  __typename?: 'updateCategoryPayload';
  category?: Maybe<Category>;
};

export type DeleteCategoryPayload = {
  __typename?: 'deleteCategoryPayload';
  category?: Maybe<Category>;
};

export type CreateCityPayload = {
  __typename?: 'createCityPayload';
  city?: Maybe<City>;
};

export type UpdateCityPayload = {
  __typename?: 'updateCityPayload';
  city?: Maybe<City>;
};

export type DeleteCityPayload = {
  __typename?: 'deleteCityPayload';
  city?: Maybe<City>;
};

export type CreateColorCatPayload = {
  __typename?: 'createColorCatPayload';
  colorCat?: Maybe<ColorCat>;
};

export type UpdateColorCatPayload = {
  __typename?: 'updateColorCatPayload';
  colorCat?: Maybe<ColorCat>;
};

export type DeleteColorCatPayload = {
  __typename?: 'deleteColorCatPayload';
  colorCat?: Maybe<ColorCat>;
};

export type CreateColorImagePayload = {
  __typename?: 'createColorImagePayload';
  colorImage?: Maybe<ColorImage>;
};

export type UpdateColorImagePayload = {
  __typename?: 'updateColorImagePayload';
  colorImage?: Maybe<ColorImage>;
};

export type DeleteColorImagePayload = {
  __typename?: 'deleteColorImagePayload';
  colorImage?: Maybe<ColorImage>;
};

export type CreateColorPayload = {
  __typename?: 'createColorPayload';
  color?: Maybe<Color>;
};

export type UpdateColorPayload = {
  __typename?: 'updateColorPayload';
  color?: Maybe<Color>;
};

export type DeleteColorPayload = {
  __typename?: 'deleteColorPayload';
  color?: Maybe<Color>;
};

export type CreateContactPayload = {
  __typename?: 'createContactPayload';
  contact?: Maybe<Contact>;
};

export type UpdateContactPayload = {
  __typename?: 'updateContactPayload';
  contact?: Maybe<Contact>;
};

export type DeleteContactPayload = {
  __typename?: 'deleteContactPayload';
  contact?: Maybe<Contact>;
};

export type CreateCustomerPayload = {
  __typename?: 'createCustomerPayload';
  customer?: Maybe<Customer>;
};

export type UpdateCustomerPayload = {
  __typename?: 'updateCustomerPayload';
  customer?: Maybe<Customer>;
};

export type DeleteCustomerPayload = {
  __typename?: 'deleteCustomerPayload';
  customer?: Maybe<Customer>;
};

export type CreateDistrictPayload = {
  __typename?: 'createDistrictPayload';
  district?: Maybe<District>;
};

export type UpdateDistrictPayload = {
  __typename?: 'updateDistrictPayload';
  district?: Maybe<District>;
};

export type DeleteDistrictPayload = {
  __typename?: 'deleteDistrictPayload';
  district?: Maybe<District>;
};

export type CreateHitCountPayload = {
  __typename?: 'createHitCountPayload';
  hitCount?: Maybe<HitCount>;
};

export type UpdateHitCountPayload = {
  __typename?: 'updateHitCountPayload';
  hitCount?: Maybe<HitCount>;
};

export type DeleteHitCountPayload = {
  __typename?: 'deleteHitCountPayload';
  hitCount?: Maybe<HitCount>;
};

export type CreateLogPayload = {
  __typename?: 'createLogPayload';
  log?: Maybe<Log>;
};

export type UpdateLogPayload = {
  __typename?: 'updateLogPayload';
  log?: Maybe<Log>;
};

export type DeleteLogPayload = {
  __typename?: 'deleteLogPayload';
  log?: Maybe<Log>;
};

export type CreateMaterialPayload = {
  __typename?: 'createMaterialPayload';
  material?: Maybe<Material>;
};

export type UpdateMaterialPayload = {
  __typename?: 'updateMaterialPayload';
  material?: Maybe<Material>;
};

export type DeleteMaterialPayload = {
  __typename?: 'deleteMaterialPayload';
  material?: Maybe<Material>;
};

export type CreateMiscPayload = {
  __typename?: 'createMiscPayload';
  misc?: Maybe<Misc>;
};

export type UpdateMiscPayload = {
  __typename?: 'updateMiscPayload';
  misc?: Maybe<Misc>;
};

export type DeleteMiscPayload = {
  __typename?: 'deleteMiscPayload';
  misc?: Maybe<Misc>;
};

export type CreateNewsletterPayload = {
  __typename?: 'createNewsletterPayload';
  newsletter?: Maybe<Newsletter>;
};

export type UpdateNewsletterPayload = {
  __typename?: 'updateNewsletterPayload';
  newsletter?: Maybe<Newsletter>;
};

export type DeleteNewsletterPayload = {
  __typename?: 'deleteNewsletterPayload';
  newsletter?: Maybe<Newsletter>;
};

export type CreateNotifystockPayload = {
  __typename?: 'createNotifystockPayload';
  notifystock?: Maybe<Notifystock>;
};

export type UpdateNotifystockPayload = {
  __typename?: 'updateNotifystockPayload';
  notifystock?: Maybe<Notifystock>;
};

export type DeleteNotifystockPayload = {
  __typename?: 'deleteNotifystockPayload';
  notifystock?: Maybe<Notifystock>;
};

export type CreateOrderdPayload = {
  __typename?: 'createOrderdPayload';
  orderd?: Maybe<Orderd>;
};

export type UpdateOrderdPayload = {
  __typename?: 'updateOrderdPayload';
  orderd?: Maybe<Orderd>;
};

export type DeleteOrderdPayload = {
  __typename?: 'deleteOrderdPayload';
  orderd?: Maybe<Orderd>;
};

export type CreateOrderhPayload = {
  __typename?: 'createOrderhPayload';
  orderh?: Maybe<Orderh>;
};

export type UpdateOrderhPayload = {
  __typename?: 'updateOrderhPayload';
  orderh?: Maybe<Orderh>;
};

export type DeleteOrderhPayload = {
  __typename?: 'deleteOrderhPayload';
  orderh?: Maybe<Orderh>;
};

export type CreateOrderhistoryPayload = {
  __typename?: 'createOrderhistoryPayload';
  orderhistory?: Maybe<Orderhistory>;
};

export type UpdateOrderhistoryPayload = {
  __typename?: 'updateOrderhistoryPayload';
  orderhistory?: Maybe<Orderhistory>;
};

export type DeleteOrderhistoryPayload = {
  __typename?: 'deleteOrderhistoryPayload';
  orderhistory?: Maybe<Orderhistory>;
};

export type CreatePaymentselectionPayload = {
  __typename?: 'createPaymentselectionPayload';
  paymentselection?: Maybe<Paymentselection>;
};

export type UpdatePaymentselectionPayload = {
  __typename?: 'updatePaymentselectionPayload';
  paymentselection?: Maybe<Paymentselection>;
};

export type DeletePaymentselectionPayload = {
  __typename?: 'deletePaymentselectionPayload';
  paymentselection?: Maybe<Paymentselection>;
};

export type CreateProductPayload = {
  __typename?: 'createProductPayload';
  product?: Maybe<Product>;
};

export type UpdateProductPayload = {
  __typename?: 'updateProductPayload';
  product?: Maybe<Product>;
};

export type DeleteProductPayload = {
  __typename?: 'deleteProductPayload';
  product?: Maybe<Product>;
};

export type CreateProductimagePayload = {
  __typename?: 'createProductimagePayload';
  productimage?: Maybe<Productimage>;
};

export type UpdateProductimagePayload = {
  __typename?: 'updateProductimagePayload';
  productimage?: Maybe<Productimage>;
};

export type DeleteProductimagePayload = {
  __typename?: 'deleteProductimagePayload';
  productimage?: Maybe<Productimage>;
};

export type CreateProvincePayload = {
  __typename?: 'createProvincePayload';
  province?: Maybe<Province>;
};

export type UpdateProvincePayload = {
  __typename?: 'updateProvincePayload';
  province?: Maybe<Province>;
};

export type DeleteProvincePayload = {
  __typename?: 'deleteProvincePayload';
  province?: Maybe<Province>;
};

export type CreateReturnorderdPayload = {
  __typename?: 'createReturnorderdPayload';
  returnorderd?: Maybe<Returnorderd>;
};

export type UpdateReturnorderdPayload = {
  __typename?: 'updateReturnorderdPayload';
  returnorderd?: Maybe<Returnorderd>;
};

export type DeleteReturnorderdPayload = {
  __typename?: 'deleteReturnorderdPayload';
  returnorderd?: Maybe<Returnorderd>;
};

export type CreateReturnorderhPayload = {
  __typename?: 'createReturnorderhPayload';
  returnorderh?: Maybe<Returnorderh>;
};

export type UpdateReturnorderhPayload = {
  __typename?: 'updateReturnorderhPayload';
  returnorderh?: Maybe<Returnorderh>;
};

export type DeleteReturnorderhPayload = {
  __typename?: 'deleteReturnorderhPayload';
  returnorderh?: Maybe<Returnorderh>;
};

export type CreateReviewPayload = {
  __typename?: 'createReviewPayload';
  review?: Maybe<Review>;
};

export type UpdateReviewPayload = {
  __typename?: 'updateReviewPayload';
  review?: Maybe<Review>;
};

export type DeleteReviewPayload = {
  __typename?: 'deleteReviewPayload';
  review?: Maybe<Review>;
};

export type CreateShippingdetailPayload = {
  __typename?: 'createShippingdetailPayload';
  shippingdetail?: Maybe<Shippingdetail>;
};

export type UpdateShippingdetailPayload = {
  __typename?: 'updateShippingdetailPayload';
  shippingdetail?: Maybe<Shippingdetail>;
};

export type DeleteShippingdetailPayload = {
  __typename?: 'deleteShippingdetailPayload';
  shippingdetail?: Maybe<Shippingdetail>;
};

export type CreateStatusPayload = {
  __typename?: 'createStatusPayload';
  status?: Maybe<Status>;
};

export type UpdateStatusPayload = {
  __typename?: 'updateStatusPayload';
  status?: Maybe<Status>;
};

export type DeleteStatusPayload = {
  __typename?: 'deleteStatusPayload';
  status?: Maybe<Status>;
};

export type CreateStorePayload = {
  __typename?: 'createStorePayload';
  store?: Maybe<Store>;
};

export type UpdateStorePayload = {
  __typename?: 'updateStorePayload';
  store?: Maybe<Store>;
};

export type DeleteStorePayload = {
  __typename?: 'deleteStorePayload';
  store?: Maybe<Store>;
};

export type CreateVoucherPayload = {
  __typename?: 'createVoucherPayload';
  voucher?: Maybe<Voucher>;
};

export type UpdateVoucherPayload = {
  __typename?: 'updateVoucherPayload';
  voucher?: Maybe<Voucher>;
};

export type DeleteVoucherPayload = {
  __typename?: 'deleteVoucherPayload';
  voucher?: Maybe<Voucher>;
};

export type CreateVoucherhistoryPayload = {
  __typename?: 'createVoucherhistoryPayload';
  voucherhistory?: Maybe<Voucherhistory>;
};

export type UpdateVoucherhistoryPayload = {
  __typename?: 'updateVoucherhistoryPayload';
  voucherhistory?: Maybe<Voucherhistory>;
};

export type DeleteVoucherhistoryPayload = {
  __typename?: 'deleteVoucherhistoryPayload';
  voucherhistory?: Maybe<Voucherhistory>;
};

export type CreateWarrantyPayload = {
  __typename?: 'createWarrantyPayload';
  warranty?: Maybe<Warranty>;
};

export type UpdateWarrantyPayload = {
  __typename?: 'updateWarrantyPayload';
  warranty?: Maybe<Warranty>;
};

export type DeleteWarrantyPayload = {
  __typename?: 'deleteWarrantyPayload';
  warranty?: Maybe<Warranty>;
};

export type CreateWebContentPayload = {
  __typename?: 'createWebContentPayload';
  webContent?: Maybe<WebContent>;
};

export type UpdateWebContentPayload = {
  __typename?: 'updateWebContentPayload';
  webContent?: Maybe<WebContent>;
};

export type DeleteWebContentPayload = {
  __typename?: 'deleteWebContentPayload';
  webContent?: Maybe<WebContent>;
};

export type CreateWishListPayload = {
  __typename?: 'createWishListPayload';
  wishList?: Maybe<WishList>;
};

export type UpdateWishListPayload = {
  __typename?: 'updateWishListPayload';
  wishList?: Maybe<WishList>;
};

export type DeleteWishListPayload = {
  __typename?: 'deleteWishListPayload';
  wishList?: Maybe<WishList>;
};

export type UploadFileConnection = {
  __typename?: 'UploadFileConnection';
  values?: Maybe<Array<Maybe<UploadFile>>>;
  groupBy?: Maybe<UploadFileGroupBy>;
  aggregate?: Maybe<UploadFileAggregator>;
};

export type UploadFileGroupBy = {
  __typename?: 'UploadFileGroupBy';
  id?: Maybe<Array<Maybe<UploadFileConnectionId>>>;
  created_at?: Maybe<Array<Maybe<UploadFileConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<UploadFileConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<UploadFileConnectionName>>>;
  alternativeText?: Maybe<Array<Maybe<UploadFileConnectionAlternativeText>>>;
  caption?: Maybe<Array<Maybe<UploadFileConnectionCaption>>>;
  width?: Maybe<Array<Maybe<UploadFileConnectionWidth>>>;
  height?: Maybe<Array<Maybe<UploadFileConnectionHeight>>>;
  formats?: Maybe<Array<Maybe<UploadFileConnectionFormats>>>;
  hash?: Maybe<Array<Maybe<UploadFileConnectionHash>>>;
  ext?: Maybe<Array<Maybe<UploadFileConnectionExt>>>;
  mime?: Maybe<Array<Maybe<UploadFileConnectionMime>>>;
  size?: Maybe<Array<Maybe<UploadFileConnectionSize>>>;
  url?: Maybe<Array<Maybe<UploadFileConnectionUrl>>>;
  previewUrl?: Maybe<Array<Maybe<UploadFileConnectionPreviewUrl>>>;
  provider?: Maybe<Array<Maybe<UploadFileConnectionProvider>>>;
  provider_metadata?: Maybe<Array<Maybe<UploadFileConnectionProvider_Metadata>>>;
};

export type UploadFileConnectionId = {
  __typename?: 'UploadFileConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCreated_At = {
  __typename?: 'UploadFileConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUpdated_At = {
  __typename?: 'UploadFileConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionName = {
  __typename?: 'UploadFileConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionAlternativeText = {
  __typename?: 'UploadFileConnectionAlternativeText';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCaption = {
  __typename?: 'UploadFileConnectionCaption';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionWidth = {
  __typename?: 'UploadFileConnectionWidth';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionHeight = {
  __typename?: 'UploadFileConnectionHeight';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionFormats = {
  __typename?: 'UploadFileConnectionFormats';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionHash = {
  __typename?: 'UploadFileConnectionHash';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionExt = {
  __typename?: 'UploadFileConnectionExt';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionMime = {
  __typename?: 'UploadFileConnectionMime';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionSize = {
  __typename?: 'UploadFileConnectionSize';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUrl = {
  __typename?: 'UploadFileConnectionUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionPreviewUrl = {
  __typename?: 'UploadFileConnectionPreviewUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionProvider = {
  __typename?: 'UploadFileConnectionProvider';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionProvider_Metadata = {
  __typename?: 'UploadFileConnectionProvider_metadata';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileAggregator = {
  __typename?: 'UploadFileAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<UploadFileAggregatorSum>;
  avg?: Maybe<UploadFileAggregatorAvg>;
  min?: Maybe<UploadFileAggregatorMin>;
  max?: Maybe<UploadFileAggregatorMax>;
};

export type UploadFileAggregatorSum = {
  __typename?: 'UploadFileAggregatorSum';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorAvg = {
  __typename?: 'UploadFileAggregatorAvg';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMin = {
  __typename?: 'UploadFileAggregatorMin';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMax = {
  __typename?: 'UploadFileAggregatorMax';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type DeleteFilePayload = {
  __typename?: 'deleteFilePayload';
  file?: Maybe<UploadFile>;
};

export type UsersPermissionsRoleConnection = {
  __typename?: 'UsersPermissionsRoleConnection';
  values?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  groupBy?: Maybe<UsersPermissionsRoleGroupBy>;
  aggregate?: Maybe<UsersPermissionsRoleAggregator>;
};

export type UsersPermissionsRoleGroupBy = {
  __typename?: 'UsersPermissionsRoleGroupBy';
  id?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionId>>>;
  name?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionName>>>;
  description?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionDescription>>>;
  type?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionType>>>;
};

export type UsersPermissionsRoleConnectionId = {
  __typename?: 'UsersPermissionsRoleConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionName = {
  __typename?: 'UsersPermissionsRoleConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionDescription = {
  __typename?: 'UsersPermissionsRoleConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionType = {
  __typename?: 'UsersPermissionsRoleConnectionType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleAggregator = {
  __typename?: 'UsersPermissionsRoleAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateRolePayload = {
  __typename?: 'createRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type UpdateRolePayload = {
  __typename?: 'updateRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type DeleteRolePayload = {
  __typename?: 'deleteRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type UsersPermissionsUserConnection = {
  __typename?: 'UsersPermissionsUserConnection';
  values?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  groupBy?: Maybe<UsersPermissionsUserGroupBy>;
  aggregate?: Maybe<UsersPermissionsUserAggregator>;
};

export type UsersPermissionsUserGroupBy = {
  __typename?: 'UsersPermissionsUserGroupBy';
  id?: Maybe<Array<Maybe<UsersPermissionsUserConnectionId>>>;
  created_at?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUpdated_At>>>;
  username?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUsername>>>;
  email?: Maybe<Array<Maybe<UsersPermissionsUserConnectionEmail>>>;
  provider?: Maybe<Array<Maybe<UsersPermissionsUserConnectionProvider>>>;
  confirmed?: Maybe<Array<Maybe<UsersPermissionsUserConnectionConfirmed>>>;
  blocked?: Maybe<Array<Maybe<UsersPermissionsUserConnectionBlocked>>>;
  role?: Maybe<Array<Maybe<UsersPermissionsUserConnectionRole>>>;
  tele?: Maybe<Array<Maybe<UsersPermissionsUserConnectionTele>>>;
  customer?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCustomer>>>;
  initialDiscount?: Maybe<Array<Maybe<UsersPermissionsUserConnectionInitialDiscount>>>;
};

export type UsersPermissionsUserConnectionId = {
  __typename?: 'UsersPermissionsUserConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCreated_At = {
  __typename?: 'UsersPermissionsUserConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUpdated_At = {
  __typename?: 'UsersPermissionsUserConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUsername = {
  __typename?: 'UsersPermissionsUserConnectionUsername';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionEmail = {
  __typename?: 'UsersPermissionsUserConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionProvider = {
  __typename?: 'UsersPermissionsUserConnectionProvider';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionConfirmed = {
  __typename?: 'UsersPermissionsUserConnectionConfirmed';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionBlocked = {
  __typename?: 'UsersPermissionsUserConnectionBlocked';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionRole = {
  __typename?: 'UsersPermissionsUserConnectionRole';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionTele = {
  __typename?: 'UsersPermissionsUserConnectionTele';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCustomer = {
  __typename?: 'UsersPermissionsUserConnectionCustomer';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionInitialDiscount = {
  __typename?: 'UsersPermissionsUserConnectionInitialDiscount';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserAggregator = {
  __typename?: 'UsersPermissionsUserAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateUserPayload = {
  __typename?: 'createUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type UpdateUserPayload = {
  __typename?: 'updateUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type DeleteUserPayload = {
  __typename?: 'deleteUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createBillingdetail?: Maybe<CreateBillingdetailPayload>;
  updateBillingdetail?: Maybe<UpdateBillingdetailPayload>;
  deleteBillingdetail?: Maybe<DeleteBillingdetailPayload>;
  createBrand?: Maybe<CreateBrandPayload>;
  updateBrand?: Maybe<UpdateBrandPayload>;
  deleteBrand?: Maybe<DeleteBrandPayload>;
  createCart?: Maybe<CreateCartPayload>;
  updateCart?: Maybe<UpdateCartPayload>;
  deleteCart?: Maybe<DeleteCartPayload>;
  createCatTypeTag?: Maybe<CreateCatTypeTagPayload>;
  updateCatTypeTag?: Maybe<UpdateCatTypeTagPayload>;
  deleteCatTypeTag?: Maybe<DeleteCatTypeTagPayload>;
  createCategory?: Maybe<CreateCategoryPayload>;
  updateCategory?: Maybe<UpdateCategoryPayload>;
  deleteCategory?: Maybe<DeleteCategoryPayload>;
  createCity?: Maybe<CreateCityPayload>;
  updateCity?: Maybe<UpdateCityPayload>;
  deleteCity?: Maybe<DeleteCityPayload>;
  createColorCat?: Maybe<CreateColorCatPayload>;
  updateColorCat?: Maybe<UpdateColorCatPayload>;
  deleteColorCat?: Maybe<DeleteColorCatPayload>;
  createColorImage?: Maybe<CreateColorImagePayload>;
  updateColorImage?: Maybe<UpdateColorImagePayload>;
  deleteColorImage?: Maybe<DeleteColorImagePayload>;
  createColor?: Maybe<CreateColorPayload>;
  updateColor?: Maybe<UpdateColorPayload>;
  deleteColor?: Maybe<DeleteColorPayload>;
  createContact?: Maybe<CreateContactPayload>;
  updateContact?: Maybe<UpdateContactPayload>;
  deleteContact?: Maybe<DeleteContactPayload>;
  createCustomer?: Maybe<CreateCustomerPayload>;
  updateCustomer?: Maybe<UpdateCustomerPayload>;
  deleteCustomer?: Maybe<DeleteCustomerPayload>;
  createDistrict?: Maybe<CreateDistrictPayload>;
  updateDistrict?: Maybe<UpdateDistrictPayload>;
  deleteDistrict?: Maybe<DeleteDistrictPayload>;
  createHitCount?: Maybe<CreateHitCountPayload>;
  updateHitCount?: Maybe<UpdateHitCountPayload>;
  deleteHitCount?: Maybe<DeleteHitCountPayload>;
  createLog?: Maybe<CreateLogPayload>;
  updateLog?: Maybe<UpdateLogPayload>;
  deleteLog?: Maybe<DeleteLogPayload>;
  createMaterial?: Maybe<CreateMaterialPayload>;
  updateMaterial?: Maybe<UpdateMaterialPayload>;
  deleteMaterial?: Maybe<DeleteMaterialPayload>;
  createMisc?: Maybe<CreateMiscPayload>;
  updateMisc?: Maybe<UpdateMiscPayload>;
  deleteMisc?: Maybe<DeleteMiscPayload>;
  createNewsletter?: Maybe<CreateNewsletterPayload>;
  updateNewsletter?: Maybe<UpdateNewsletterPayload>;
  deleteNewsletter?: Maybe<DeleteNewsletterPayload>;
  createNotifystock?: Maybe<CreateNotifystockPayload>;
  updateNotifystock?: Maybe<UpdateNotifystockPayload>;
  deleteNotifystock?: Maybe<DeleteNotifystockPayload>;
  createOrderd?: Maybe<CreateOrderdPayload>;
  updateOrderd?: Maybe<UpdateOrderdPayload>;
  deleteOrderd?: Maybe<DeleteOrderdPayload>;
  createOrderh?: Maybe<CreateOrderhPayload>;
  updateOrderh?: Maybe<UpdateOrderhPayload>;
  deleteOrderh?: Maybe<DeleteOrderhPayload>;
  createOrderhistory?: Maybe<CreateOrderhistoryPayload>;
  updateOrderhistory?: Maybe<UpdateOrderhistoryPayload>;
  deleteOrderhistory?: Maybe<DeleteOrderhistoryPayload>;
  createPaymentselection?: Maybe<CreatePaymentselectionPayload>;
  updatePaymentselection?: Maybe<UpdatePaymentselectionPayload>;
  deletePaymentselection?: Maybe<DeletePaymentselectionPayload>;
  createProduct?: Maybe<CreateProductPayload>;
  updateProduct?: Maybe<UpdateProductPayload>;
  deleteProduct?: Maybe<DeleteProductPayload>;
  createProductimage?: Maybe<CreateProductimagePayload>;
  updateProductimage?: Maybe<UpdateProductimagePayload>;
  deleteProductimage?: Maybe<DeleteProductimagePayload>;
  createProvince?: Maybe<CreateProvincePayload>;
  updateProvince?: Maybe<UpdateProvincePayload>;
  deleteProvince?: Maybe<DeleteProvincePayload>;
  createReturnorderd?: Maybe<CreateReturnorderdPayload>;
  updateReturnorderd?: Maybe<UpdateReturnorderdPayload>;
  deleteReturnorderd?: Maybe<DeleteReturnorderdPayload>;
  createReturnorderh?: Maybe<CreateReturnorderhPayload>;
  updateReturnorderh?: Maybe<UpdateReturnorderhPayload>;
  deleteReturnorderh?: Maybe<DeleteReturnorderhPayload>;
  createReview?: Maybe<CreateReviewPayload>;
  updateReview?: Maybe<UpdateReviewPayload>;
  deleteReview?: Maybe<DeleteReviewPayload>;
  createShippingdetail?: Maybe<CreateShippingdetailPayload>;
  updateShippingdetail?: Maybe<UpdateShippingdetailPayload>;
  deleteShippingdetail?: Maybe<DeleteShippingdetailPayload>;
  createStatus?: Maybe<CreateStatusPayload>;
  updateStatus?: Maybe<UpdateStatusPayload>;
  deleteStatus?: Maybe<DeleteStatusPayload>;
  createStore?: Maybe<CreateStorePayload>;
  updateStore?: Maybe<UpdateStorePayload>;
  deleteStore?: Maybe<DeleteStorePayload>;
  createVoucher?: Maybe<CreateVoucherPayload>;
  updateVoucher?: Maybe<UpdateVoucherPayload>;
  deleteVoucher?: Maybe<DeleteVoucherPayload>;
  createVoucherhistory?: Maybe<CreateVoucherhistoryPayload>;
  updateVoucherhistory?: Maybe<UpdateVoucherhistoryPayload>;
  deleteVoucherhistory?: Maybe<DeleteVoucherhistoryPayload>;
  createWarranty?: Maybe<CreateWarrantyPayload>;
  updateWarranty?: Maybe<UpdateWarrantyPayload>;
  deleteWarranty?: Maybe<DeleteWarrantyPayload>;
  createWebContent?: Maybe<CreateWebContentPayload>;
  updateWebContent?: Maybe<UpdateWebContentPayload>;
  deleteWebContent?: Maybe<DeleteWebContentPayload>;
  createWishList?: Maybe<CreateWishListPayload>;
  updateWishList?: Maybe<UpdateWishListPayload>;
  deleteWishList?: Maybe<DeleteWishListPayload>;
  /** Delete one file */
  deleteFile?: Maybe<DeleteFilePayload>;
  /** Create a new role */
  createRole?: Maybe<CreateRolePayload>;
  /** Update an existing role */
  updateRole?: Maybe<UpdateRolePayload>;
  /** Delete an existing role */
  deleteRole?: Maybe<DeleteRolePayload>;
  /** Create a new user */
  createUser?: Maybe<CreateUserPayload>;
  /** Update an existing user */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Delete an existing user */
  deleteUser?: Maybe<DeleteUserPayload>;
  createGuestBilling: Scalars['ID'];
  reduceFromCart?: Maybe<Scalars['Boolean']>;
  addToCart?: Maybe<Scalars['Boolean']>;
  removeFromCart: DeletedItem;
  checkout: CheckoutResponse;
  checkoutGuest: CheckoutResponse;
  tempCheckout: TempCheckoutPayload;
  tempCheckoutGuest: TempCheckoutPayload;
  setPaidStatus: Scalars['Boolean'];
  updateProfile?: Maybe<Scalars['Boolean']>;
  updateDeliveryStatus: Scalars['Boolean'];
  alocateDeliveries: Scalars['Boolean'];
  createGuestPaymentselection: Scalars['ID'];
  createProductExtend?: Maybe<CreateProductPayload>;
  updateProductExtend?: Maybe<UpdateProductPayload>;
  createGuestShipping: Scalars['ID'];
  upload: UploadFile;
  multipleUpload: Array<Maybe<UploadFile>>;
  updateFileInfo: UploadFile;
  login: UsersPermissionsLoginPayload;
  register: UsersPermissionsLoginPayload;
  forgotPassword?: Maybe<UserPermissionsPasswordPayload>;
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  logout: Scalars['Boolean'];
};


export type MutationCreateBillingdetailArgs = {
  input?: Maybe<CreateBillingdetailInput>;
};


export type MutationUpdateBillingdetailArgs = {
  input?: Maybe<UpdateBillingdetailInput>;
};


export type MutationDeleteBillingdetailArgs = {
  input?: Maybe<DeleteBillingdetailInput>;
};


export type MutationCreateBrandArgs = {
  input?: Maybe<CreateBrandInput>;
};


export type MutationUpdateBrandArgs = {
  input?: Maybe<UpdateBrandInput>;
};


export type MutationDeleteBrandArgs = {
  input?: Maybe<DeleteBrandInput>;
};


export type MutationCreateCartArgs = {
  input?: Maybe<CreateCartInput>;
};


export type MutationUpdateCartArgs = {
  input?: Maybe<UpdateCartInput>;
};


export type MutationDeleteCartArgs = {
  input?: Maybe<DeleteCartInput>;
};


export type MutationCreateCatTypeTagArgs = {
  input?: Maybe<CreateCatTypeTagInput>;
};


export type MutationUpdateCatTypeTagArgs = {
  input?: Maybe<UpdateCatTypeTagInput>;
};


export type MutationDeleteCatTypeTagArgs = {
  input?: Maybe<DeleteCatTypeTagInput>;
};


export type MutationCreateCategoryArgs = {
  input?: Maybe<CreateCategoryInput>;
};


export type MutationUpdateCategoryArgs = {
  input?: Maybe<UpdateCategoryInput>;
};


export type MutationDeleteCategoryArgs = {
  input?: Maybe<DeleteCategoryInput>;
};


export type MutationCreateCityArgs = {
  input?: Maybe<CreateCityInput>;
};


export type MutationUpdateCityArgs = {
  input?: Maybe<UpdateCityInput>;
};


export type MutationDeleteCityArgs = {
  input?: Maybe<DeleteCityInput>;
};


export type MutationCreateColorCatArgs = {
  input?: Maybe<CreateColorCatInput>;
};


export type MutationUpdateColorCatArgs = {
  input?: Maybe<UpdateColorCatInput>;
};


export type MutationDeleteColorCatArgs = {
  input?: Maybe<DeleteColorCatInput>;
};


export type MutationCreateColorImageArgs = {
  input?: Maybe<CreateColorImageInput>;
};


export type MutationUpdateColorImageArgs = {
  input?: Maybe<UpdateColorImageInput>;
};


export type MutationDeleteColorImageArgs = {
  input?: Maybe<DeleteColorImageInput>;
};


export type MutationCreateColorArgs = {
  input?: Maybe<CreateColorInput>;
};


export type MutationUpdateColorArgs = {
  input?: Maybe<UpdateColorInput>;
};


export type MutationDeleteColorArgs = {
  input?: Maybe<DeleteColorInput>;
};


export type MutationCreateContactArgs = {
  input?: Maybe<CreateContactInput>;
};


export type MutationUpdateContactArgs = {
  input?: Maybe<UpdateContactInput>;
};


export type MutationDeleteContactArgs = {
  input?: Maybe<DeleteContactInput>;
};


export type MutationCreateCustomerArgs = {
  input?: Maybe<CreateCustomerInput>;
};


export type MutationUpdateCustomerArgs = {
  input?: Maybe<UpdateCustomerInput>;
};


export type MutationDeleteCustomerArgs = {
  input?: Maybe<DeleteCustomerInput>;
};


export type MutationCreateDistrictArgs = {
  input?: Maybe<CreateDistrictInput>;
};


export type MutationUpdateDistrictArgs = {
  input?: Maybe<UpdateDistrictInput>;
};


export type MutationDeleteDistrictArgs = {
  input?: Maybe<DeleteDistrictInput>;
};


export type MutationCreateHitCountArgs = {
  input?: Maybe<CreateHitCountInput>;
};


export type MutationUpdateHitCountArgs = {
  input?: Maybe<UpdateHitCountInput>;
};


export type MutationDeleteHitCountArgs = {
  input?: Maybe<DeleteHitCountInput>;
};


export type MutationCreateLogArgs = {
  input?: Maybe<CreateLogInput>;
};


export type MutationUpdateLogArgs = {
  input?: Maybe<UpdateLogInput>;
};


export type MutationDeleteLogArgs = {
  input?: Maybe<DeleteLogInput>;
};


export type MutationCreateMaterialArgs = {
  input?: Maybe<CreateMaterialInput>;
};


export type MutationUpdateMaterialArgs = {
  input?: Maybe<UpdateMaterialInput>;
};


export type MutationDeleteMaterialArgs = {
  input?: Maybe<DeleteMaterialInput>;
};


export type MutationCreateMiscArgs = {
  input?: Maybe<CreateMiscInput>;
};


export type MutationUpdateMiscArgs = {
  input?: Maybe<UpdateMiscInput>;
};


export type MutationDeleteMiscArgs = {
  input?: Maybe<DeleteMiscInput>;
};


export type MutationCreateNewsletterArgs = {
  input?: Maybe<CreateNewsletterInput>;
};


export type MutationUpdateNewsletterArgs = {
  input?: Maybe<UpdateNewsletterInput>;
};


export type MutationDeleteNewsletterArgs = {
  input?: Maybe<DeleteNewsletterInput>;
};


export type MutationCreateNotifystockArgs = {
  input?: Maybe<CreateNotifystockInput>;
};


export type MutationUpdateNotifystockArgs = {
  input?: Maybe<UpdateNotifystockInput>;
};


export type MutationDeleteNotifystockArgs = {
  input?: Maybe<DeleteNotifystockInput>;
};


export type MutationCreateOrderdArgs = {
  input?: Maybe<CreateOrderdInput>;
};


export type MutationUpdateOrderdArgs = {
  input?: Maybe<UpdateOrderdInput>;
};


export type MutationDeleteOrderdArgs = {
  input?: Maybe<DeleteOrderdInput>;
};


export type MutationCreateOrderhArgs = {
  input?: Maybe<CreateOrderhInput>;
};


export type MutationUpdateOrderhArgs = {
  input?: Maybe<UpdateOrderhInput>;
};


export type MutationDeleteOrderhArgs = {
  input?: Maybe<DeleteOrderhInput>;
};


export type MutationCreateOrderhistoryArgs = {
  input?: Maybe<CreateOrderhistoryInput>;
};


export type MutationUpdateOrderhistoryArgs = {
  input?: Maybe<UpdateOrderhistoryInput>;
};


export type MutationDeleteOrderhistoryArgs = {
  input?: Maybe<DeleteOrderhistoryInput>;
};


export type MutationCreatePaymentselectionArgs = {
  input?: Maybe<CreatePaymentselectionInput>;
};


export type MutationUpdatePaymentselectionArgs = {
  input?: Maybe<UpdatePaymentselectionInput>;
};


export type MutationDeletePaymentselectionArgs = {
  input?: Maybe<DeletePaymentselectionInput>;
};


export type MutationCreateProductArgs = {
  input?: Maybe<CreateProductInput>;
};


export type MutationUpdateProductArgs = {
  input?: Maybe<UpdateProductInput>;
};


export type MutationDeleteProductArgs = {
  input?: Maybe<DeleteProductInput>;
};


export type MutationCreateProductimageArgs = {
  input?: Maybe<CreateProductimageInput>;
};


export type MutationUpdateProductimageArgs = {
  input?: Maybe<UpdateProductimageInput>;
};


export type MutationDeleteProductimageArgs = {
  input?: Maybe<DeleteProductimageInput>;
};


export type MutationCreateProvinceArgs = {
  input?: Maybe<CreateProvinceInput>;
};


export type MutationUpdateProvinceArgs = {
  input?: Maybe<UpdateProvinceInput>;
};


export type MutationDeleteProvinceArgs = {
  input?: Maybe<DeleteProvinceInput>;
};


export type MutationCreateReturnorderdArgs = {
  input?: Maybe<CreateReturnorderdInput>;
};


export type MutationUpdateReturnorderdArgs = {
  input?: Maybe<UpdateReturnorderdInput>;
};


export type MutationDeleteReturnorderdArgs = {
  input?: Maybe<DeleteReturnorderdInput>;
};


export type MutationCreateReturnorderhArgs = {
  input?: Maybe<CreateReturnorderhInput>;
};


export type MutationUpdateReturnorderhArgs = {
  input?: Maybe<UpdateReturnorderhInput>;
};


export type MutationDeleteReturnorderhArgs = {
  input?: Maybe<DeleteReturnorderhInput>;
};


export type MutationCreateReviewArgs = {
  input?: Maybe<CreateReviewInput>;
};


export type MutationUpdateReviewArgs = {
  input?: Maybe<UpdateReviewInput>;
};


export type MutationDeleteReviewArgs = {
  input?: Maybe<DeleteReviewInput>;
};


export type MutationCreateShippingdetailArgs = {
  input?: Maybe<CreateShippingdetailInput>;
};


export type MutationUpdateShippingdetailArgs = {
  input?: Maybe<UpdateShippingdetailInput>;
};


export type MutationDeleteShippingdetailArgs = {
  input?: Maybe<DeleteShippingdetailInput>;
};


export type MutationCreateStatusArgs = {
  input?: Maybe<CreateStatusInput>;
};


export type MutationUpdateStatusArgs = {
  input?: Maybe<UpdateStatusInput>;
};


export type MutationDeleteStatusArgs = {
  input?: Maybe<DeleteStatusInput>;
};


export type MutationCreateStoreArgs = {
  input?: Maybe<CreateStoreInput>;
};


export type MutationUpdateStoreArgs = {
  input?: Maybe<UpdateStoreInput>;
};


export type MutationDeleteStoreArgs = {
  input?: Maybe<DeleteStoreInput>;
};


export type MutationCreateVoucherArgs = {
  input?: Maybe<CreateVoucherInput>;
};


export type MutationUpdateVoucherArgs = {
  input?: Maybe<UpdateVoucherInput>;
};


export type MutationDeleteVoucherArgs = {
  input?: Maybe<DeleteVoucherInput>;
};


export type MutationCreateVoucherhistoryArgs = {
  input?: Maybe<CreateVoucherhistoryInput>;
};


export type MutationUpdateVoucherhistoryArgs = {
  input?: Maybe<UpdateVoucherhistoryInput>;
};


export type MutationDeleteVoucherhistoryArgs = {
  input?: Maybe<DeleteVoucherhistoryInput>;
};


export type MutationCreateWarrantyArgs = {
  input?: Maybe<CreateWarrantyInput>;
};


export type MutationUpdateWarrantyArgs = {
  input?: Maybe<UpdateWarrantyInput>;
};


export type MutationDeleteWarrantyArgs = {
  input?: Maybe<DeleteWarrantyInput>;
};


export type MutationCreateWebContentArgs = {
  input?: Maybe<CreateWebContentInput>;
};


export type MutationUpdateWebContentArgs = {
  input?: Maybe<UpdateWebContentInput>;
};


export type MutationDeleteWebContentArgs = {
  input?: Maybe<DeleteWebContentInput>;
};


export type MutationCreateWishListArgs = {
  input?: Maybe<CreateWishListInput>;
};


export type MutationUpdateWishListArgs = {
  input?: Maybe<UpdateWishListInput>;
};


export type MutationDeleteWishListArgs = {
  input?: Maybe<DeleteWishListInput>;
};


export type MutationDeleteFileArgs = {
  input?: Maybe<DeleteFileInput>;
};


export type MutationCreateRoleArgs = {
  input?: Maybe<CreateRoleInput>;
};


export type MutationUpdateRoleArgs = {
  input?: Maybe<UpdateRoleInput>;
};


export type MutationDeleteRoleArgs = {
  input?: Maybe<DeleteRoleInput>;
};


export type MutationCreateUserArgs = {
  input?: Maybe<CreateUserInput>;
};


export type MutationUpdateUserArgs = {
  input?: Maybe<UpdateUserInput>;
};


export type MutationDeleteUserArgs = {
  input?: Maybe<DeleteUserInput>;
};


export type MutationCreateGuestBillingArgs = {
  input: CreateGuestBillingInput;
};


export type MutationReduceFromCartArgs = {
  id: Scalars['ID'];
};


export type MutationAddToCartArgs = {
  input?: Maybe<UpdateCartInput>;
};


export type MutationRemoveFromCartArgs = {
  cartId: Scalars['ID'];
};


export type MutationSetPaidStatusArgs = {
  code: Scalars['String'];
};


export type MutationUpdateProfileArgs = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  cityId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  country: Scalars['String'];
};


export type MutationUpdateDeliveryStatusArgs = {
  orderId: Scalars['String'];
  status: Scalars['String'];
  store?: Maybe<Scalars['ID']>;
};


export type MutationAlocateDeliveriesArgs = {
  deliveryPerson: Scalars['ID'];
  orderItems: Array<OrderItem>;
  orderh: Scalars['String'];
};


export type MutationCreateGuestPaymentselectionArgs = {
  input: CreateGuestPaymentselectionInput;
};


export type MutationCreateProductExtendArgs = {
  input?: Maybe<CreateProductInputExtend>;
};


export type MutationUpdateProductExtendArgs = {
  input?: Maybe<UpdateProductInputExtend>;
};


export type MutationCreateGuestShippingArgs = {
  input: CreateGuestShippingInput;
};


export type MutationUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  file: Scalars['Upload'];
};


export type MutationMultipleUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  files: Array<Maybe<Scalars['Upload']>>;
};


export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID'];
  info: FileInfoInput;
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  code: Scalars['String'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String'];
};

export type CreateBillingdetailInput = {
  data?: Maybe<BillingdetailInput>;
};

export type BillingdetailInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  address1: Scalars['String'];
  address2: Scalars['String'];
  email: Scalars['String'];
  tele1: Scalars['String'];
  tele2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['ID']>;
  orderh?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['ID']>;
  guestid?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateBillingdetailInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditBillingdetailInput>;
};

export type InputId = {
  id: Scalars['ID'];
};

export type EditBillingdetailInput = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  tele1?: Maybe<Scalars['String']>;
  tele2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['ID']>;
  orderh?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['ID']>;
  guestid?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteBillingdetailInput = {
  where?: Maybe<InputId>;
};

export type CreateBrandInput = {
  data?: Maybe<BrandInput>;
};

export type BrandInput = {
  brandName: Scalars['String'];
  inactive?: Maybe<Scalars['Boolean']>;
  products?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateBrandInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditBrandInput>;
};

export type EditBrandInput = {
  brandName?: Maybe<Scalars['String']>;
  inactive?: Maybe<Scalars['Boolean']>;
  products?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteBrandInput = {
  where?: Maybe<InputId>;
};

export type CreateCartInput = {
  data?: Maybe<CartInput>;
};

export type CartInput = {
  qty?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  product?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  tempId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['ID']>;
  discount?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateCartInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCartInput>;
};

export type EditCartInput = {
  qty?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  product?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  tempId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['ID']>;
  discount?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteCartInput = {
  where?: Maybe<InputId>;
};

export type CreateCatTypeTagInput = {
  data?: Maybe<CatTypeTagInput>;
};

export type CatTypeTagInput = {
  tagName?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateCatTypeTagInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCatTypeTagInput>;
};

export type EditCatTypeTagInput = {
  tagName?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteCatTypeTagInput = {
  where?: Maybe<InputId>;
};

export type CreateCategoryInput = {
  data?: Maybe<CategoryInput>;
};

export type CategoryInput = {
  categoryName: Scalars['String'];
  inactive?: Maybe<Scalars['Boolean']>;
  icon?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Maybe<Scalars['ID']>>>;
  image?: Maybe<Scalars['String']>;
  cat_type_tags?: Maybe<Array<Maybe<Scalars['ID']>>>;
  surcharge?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateCategoryInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCategoryInput>;
};

export type EditCategoryInput = {
  categoryName?: Maybe<Scalars['String']>;
  inactive?: Maybe<Scalars['Boolean']>;
  icon?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Maybe<Scalars['ID']>>>;
  image?: Maybe<Scalars['String']>;
  cat_type_tags?: Maybe<Array<Maybe<Scalars['ID']>>>;
  surcharge?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteCategoryInput = {
  where?: Maybe<InputId>;
};

export type CreateCityInput = {
  data?: Maybe<CityInput>;
};

export type CityInput = {
  cityName: Scalars['String'];
  district?: Maybe<Scalars['ID']>;
  postalCode: Scalars['String'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  customers?: Maybe<Array<Maybe<Scalars['ID']>>>;
  shippingdetails?: Maybe<Array<Maybe<Scalars['ID']>>>;
  billingdetails?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateCityInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCityInput>;
};

export type EditCityInput = {
  cityName?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['ID']>;
  postalCode?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  customers?: Maybe<Array<Maybe<Scalars['ID']>>>;
  shippingdetails?: Maybe<Array<Maybe<Scalars['ID']>>>;
  billingdetails?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteCityInput = {
  where?: Maybe<InputId>;
};

export type CreateColorCatInput = {
  data?: Maybe<ColorCatInput>;
};

export type ColorCatInput = {
  colorCode?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['ID']>;
  colorPrice?: Maybe<Scalars['Float']>;
  colorStock?: Maybe<Scalars['Int']>;
  product?: Maybe<Scalars['ID']>;
  color_images?: Maybe<Array<Maybe<Scalars['ID']>>>;
  img?: Maybe<Scalars['String']>;
  colorDiscount?: Maybe<Scalars['Float']>;
  material?: Maybe<Scalars['String']>;
  closure_type?: Maybe<Scalars['String']>;
  lockable?: Maybe<Scalars['String']>;
  laptop_com?: Maybe<Scalars['String']>;
  laptop_size?: Maybe<Scalars['String']>;
  warranty?: Maybe<Scalars['ID']>;
  p_length?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
  inActive?: Maybe<Scalars['Boolean']>;
  featured?: Maybe<Scalars['Boolean']>;
  included?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateColorCatInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditColorCatInput>;
};

export type EditColorCatInput = {
  colorCode?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['ID']>;
  colorPrice?: Maybe<Scalars['Float']>;
  colorStock?: Maybe<Scalars['Int']>;
  product?: Maybe<Scalars['ID']>;
  color_images?: Maybe<Array<Maybe<Scalars['ID']>>>;
  img?: Maybe<Scalars['String']>;
  colorDiscount?: Maybe<Scalars['Float']>;
  material?: Maybe<Scalars['String']>;
  closure_type?: Maybe<Scalars['String']>;
  lockable?: Maybe<Scalars['String']>;
  laptop_com?: Maybe<Scalars['String']>;
  laptop_size?: Maybe<Scalars['String']>;
  warranty?: Maybe<Scalars['ID']>;
  p_length?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
  inActive?: Maybe<Scalars['Boolean']>;
  featured?: Maybe<Scalars['Boolean']>;
  included?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteColorCatInput = {
  where?: Maybe<InputId>;
};

export type CreateColorImageInput = {
  data?: Maybe<ColorImageInput>;
};

export type ColorImageInput = {
  color_cat?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateColorImageInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditColorImageInput>;
};

export type EditColorImageInput = {
  color_cat?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteColorImageInput = {
  where?: Maybe<InputId>;
};

export type CreateColorInput = {
  data?: Maybe<ColorInput>;
};

export type ColorInput = {
  colorName?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Maybe<Scalars['ID']>>>;
  carts?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  colorHex?: Maybe<Scalars['String']>;
  isTwoTone?: Maybe<Scalars['Boolean']>;
  colorHex2?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateColorInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditColorInput>;
};

export type EditColorInput = {
  colorName?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Maybe<Scalars['ID']>>>;
  carts?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  colorHex?: Maybe<Scalars['String']>;
  isTwoTone?: Maybe<Scalars['Boolean']>;
  colorHex2?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteColorInput = {
  where?: Maybe<InputId>;
};

export type CreateContactInput = {
  data?: Maybe<ContactInput>;
};

export type ContactInput = {
  name: Scalars['String'];
  email: Scalars['String'];
  message: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateContactInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditContactInput>;
};

export type EditContactInput = {
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteContactInput = {
  where?: Maybe<InputId>;
};

export type CreateCustomerInput = {
  data?: Maybe<CustomerInput>;
};

export type CustomerInput = {
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['ID']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateCustomerInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCustomerInput>;
};

export type EditCustomerInput = {
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['ID']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteCustomerInput = {
  where?: Maybe<InputId>;
};

export type CreateDistrictInput = {
  data?: Maybe<DistrictInput>;
};

export type DistrictInput = {
  districtName: Scalars['String'];
  province?: Maybe<Scalars['ID']>;
  cities?: Maybe<Array<Maybe<Scalars['ID']>>>;
  deliveryCharge1?: Maybe<Scalars['Float']>;
  deliveryCharge2?: Maybe<Scalars['Float']>;
  deliveryCharge3?: Maybe<Scalars['Float']>;
  deliveryCharge4?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateDistrictInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditDistrictInput>;
};

export type EditDistrictInput = {
  districtName?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['ID']>;
  cities?: Maybe<Array<Maybe<Scalars['ID']>>>;
  deliveryCharge1?: Maybe<Scalars['Float']>;
  deliveryCharge2?: Maybe<Scalars['Float']>;
  deliveryCharge3?: Maybe<Scalars['Float']>;
  deliveryCharge4?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteDistrictInput = {
  where?: Maybe<InputId>;
};

export type CreateHitCountInput = {
  data?: Maybe<HitCountInput>;
};

export type HitCountInput = {
  hit_date?: Maybe<Scalars['Date']>;
  h_count?: Maybe<Scalars['Int']>;
  product?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateHitCountInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditHitCountInput>;
};

export type EditHitCountInput = {
  hit_date?: Maybe<Scalars['Date']>;
  h_count?: Maybe<Scalars['Int']>;
  product?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteHitCountInput = {
  where?: Maybe<InputId>;
};

export type CreateLogInput = {
  data?: Maybe<LogInput>;
};

export type LogInput = {
  desp?: Maybe<Scalars['String']>;
  funcName?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateLogInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditLogInput>;
};

export type EditLogInput = {
  desp?: Maybe<Scalars['String']>;
  funcName?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteLogInput = {
  where?: Maybe<InputId>;
};

export type CreateMaterialInput = {
  data?: Maybe<MaterialInput>;
};

export type MaterialInput = {
  name: Scalars['String'];
  products?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateMaterialInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditMaterialInput>;
};

export type EditMaterialInput = {
  name?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteMaterialInput = {
  where?: Maybe<InputId>;
};

export type CreateMiscInput = {
  data?: Maybe<MiscInput>;
};

export type MiscInput = {
  shouldOpenBanner?: Maybe<Scalars['Boolean']>;
  launchCode?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateMiscInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditMiscInput>;
};

export type EditMiscInput = {
  shouldOpenBanner?: Maybe<Scalars['Boolean']>;
  launchCode?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteMiscInput = {
  where?: Maybe<InputId>;
};

export type CreateNewsletterInput = {
  data?: Maybe<NewsletterInput>;
};

export type NewsletterInput = {
  email?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateNewsletterInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditNewsletterInput>;
};

export type EditNewsletterInput = {
  email?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteNewsletterInput = {
  where?: Maybe<InputId>;
};

export type CreateNotifystockInput = {
  data?: Maybe<NotifystockInput>;
};

export type NotifystockInput = {
  users_permissions_user?: Maybe<Scalars['ID']>;
  colorCode?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateNotifystockInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditNotifystockInput>;
};

export type EditNotifystockInput = {
  users_permissions_user?: Maybe<Scalars['ID']>;
  colorCode?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteNotifystockInput = {
  where?: Maybe<InputId>;
};

export type CreateOrderdInput = {
  data?: Maybe<OrderdInput>;
};

export type OrderdInput = {
  qty: Scalars['Float'];
  price: Scalars['Float'];
  product?: Maybe<Scalars['ID']>;
  orderh?: Maybe<Scalars['ID']>;
  color?: Maybe<Scalars['ID']>;
  deliveryPerson?: Maybe<Scalars['ID']>;
  status?: Maybe<Enum_Orderd_Status>;
  discount?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateOrderdInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditOrderdInput>;
};

export type EditOrderdInput = {
  qty?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  product?: Maybe<Scalars['ID']>;
  orderh?: Maybe<Scalars['ID']>;
  color?: Maybe<Scalars['ID']>;
  deliveryPerson?: Maybe<Scalars['ID']>;
  status?: Maybe<Enum_Orderd_Status>;
  discount?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteOrderdInput = {
  where?: Maybe<InputId>;
};

export type CreateOrderhInput = {
  data?: Maybe<OrderhInput>;
};

export type OrderhInput = {
  netAmt?: Maybe<Scalars['Float']>;
  orderCode: Scalars['String'];
  user?: Maybe<Scalars['ID']>;
  orderds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  status?: Maybe<Scalars['ID']>;
  billingdetails?: Maybe<Array<Maybe<Scalars['ID']>>>;
  shippingdetails?: Maybe<Array<Maybe<Scalars['ID']>>>;
  paymentselections?: Maybe<Array<Maybe<Scalars['ID']>>>;
  paymentId?: Maybe<Scalars['String']>;
  paidAmount?: Maybe<Scalars['Float']>;
  cardName?: Maybe<Scalars['String']>;
  cardExp?: Maybe<Scalars['Int']>;
  cardNo?: Maybe<Scalars['String']>;
  deliveryCost?: Maybe<Scalars['Float']>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  orderhistories?: Maybe<Array<Maybe<Scalars['ID']>>>;
  returned?: Maybe<Scalars['Boolean']>;
  voucher?: Maybe<Scalars['ID']>;
  specialDiscount?: Maybe<Scalars['Float']>;
  guestid?: Maybe<Scalars['String']>;
  surcharge?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateOrderhInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditOrderhInput>;
};

export type EditOrderhInput = {
  netAmt?: Maybe<Scalars['Float']>;
  orderCode?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['ID']>;
  orderds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  status?: Maybe<Scalars['ID']>;
  billingdetails?: Maybe<Array<Maybe<Scalars['ID']>>>;
  shippingdetails?: Maybe<Array<Maybe<Scalars['ID']>>>;
  paymentselections?: Maybe<Array<Maybe<Scalars['ID']>>>;
  paymentId?: Maybe<Scalars['String']>;
  paidAmount?: Maybe<Scalars['Float']>;
  cardName?: Maybe<Scalars['String']>;
  cardExp?: Maybe<Scalars['Int']>;
  cardNo?: Maybe<Scalars['String']>;
  deliveryCost?: Maybe<Scalars['Float']>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  orderhistories?: Maybe<Array<Maybe<Scalars['ID']>>>;
  returned?: Maybe<Scalars['Boolean']>;
  voucher?: Maybe<Scalars['ID']>;
  specialDiscount?: Maybe<Scalars['Float']>;
  guestid?: Maybe<Scalars['String']>;
  surcharge?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteOrderhInput = {
  where?: Maybe<InputId>;
};

export type CreateOrderhistoryInput = {
  data?: Maybe<OrderhistoryInput>;
};

export type OrderhistoryInput = {
  orderh?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateOrderhistoryInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditOrderhistoryInput>;
};

export type EditOrderhistoryInput = {
  orderh?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteOrderhistoryInput = {
  where?: Maybe<InputId>;
};

export type CreatePaymentselectionInput = {
  data?: Maybe<PaymentselectionInput>;
};

export type PaymentselectionInput = {
  method?: Maybe<Enum_Paymentselection_Method>;
  user?: Maybe<Scalars['ID']>;
  orderh?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['ID']>;
  deliveryMethod?: Maybe<Enum_Paymentselection_Deliverymethod>;
  senderName?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  guestid?: Maybe<Scalars['String']>;
  mintpayId?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdatePaymentselectionInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditPaymentselectionInput>;
};

export type EditPaymentselectionInput = {
  method?: Maybe<Enum_Paymentselection_Method>;
  user?: Maybe<Scalars['ID']>;
  orderh?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['ID']>;
  deliveryMethod?: Maybe<Enum_Paymentselection_Deliverymethod>;
  senderName?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  guestid?: Maybe<Scalars['String']>;
  mintpayId?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeletePaymentselectionInput = {
  where?: Maybe<InputId>;
};

export type CreateProductInput = {
  data?: Maybe<ProductInput>;
};

export type ProductInput = {
  productCode: Scalars['String'];
  serialNo: Scalars['String'];
  productName: Scalars['String'];
  price?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  brand?: Maybe<Scalars['ID']>;
  category?: Maybe<Scalars['ID']>;
  featuredItem?: Maybe<Scalars['Boolean']>;
  inactive?: Maybe<Scalars['Boolean']>;
  productDescription: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  carts?: Maybe<Array<Maybe<Scalars['ID']>>>;
  productimages?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  spec?: Maybe<Scalars['String']>;
  warranty?: Maybe<Scalars['ID']>;
  stock?: Maybe<Scalars['Float']>;
  store?: Maybe<Scalars['ID']>;
  colors?: Maybe<Array<Maybe<Scalars['ID']>>>;
  color_cats?: Maybe<Array<Maybe<Scalars['ID']>>>;
  wish_lists?: Maybe<Array<Maybe<Scalars['ID']>>>;
  hitCount?: Maybe<Scalars['Long']>;
  isVoucher?: Maybe<Scalars['Boolean']>;
  material?: Maybe<Scalars['ID']>;
  hit_counts?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateProductInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditProductInput>;
};

export type EditProductInput = {
  productCode?: Maybe<Scalars['String']>;
  serialNo?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  brand?: Maybe<Scalars['ID']>;
  category?: Maybe<Scalars['ID']>;
  featuredItem?: Maybe<Scalars['Boolean']>;
  inactive?: Maybe<Scalars['Boolean']>;
  productDescription?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  carts?: Maybe<Array<Maybe<Scalars['ID']>>>;
  productimages?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  spec?: Maybe<Scalars['String']>;
  warranty?: Maybe<Scalars['ID']>;
  stock?: Maybe<Scalars['Float']>;
  store?: Maybe<Scalars['ID']>;
  colors?: Maybe<Array<Maybe<Scalars['ID']>>>;
  color_cats?: Maybe<Array<Maybe<Scalars['ID']>>>;
  wish_lists?: Maybe<Array<Maybe<Scalars['ID']>>>;
  hitCount?: Maybe<Scalars['Long']>;
  isVoucher?: Maybe<Scalars['Boolean']>;
  material?: Maybe<Scalars['ID']>;
  hit_counts?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteProductInput = {
  where?: Maybe<InputId>;
};

export type CreateProductimageInput = {
  data?: Maybe<ProductimageInput>;
};

export type ProductimageInput = {
  image: Scalars['String'];
  product?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateProductimageInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditProductimageInput>;
};

export type EditProductimageInput = {
  image?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteProductimageInput = {
  where?: Maybe<InputId>;
};

export type CreateProvinceInput = {
  data?: Maybe<ProvinceInput>;
};

export type ProvinceInput = {
  provinceName: Scalars['String'];
  districts?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateProvinceInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditProvinceInput>;
};

export type EditProvinceInput = {
  provinceName?: Maybe<Scalars['String']>;
  districts?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteProvinceInput = {
  where?: Maybe<InputId>;
};

export type CreateReturnorderdInput = {
  data?: Maybe<ReturnorderdInput>;
};

export type ReturnorderdInput = {
  qty?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  product?: Maybe<Scalars['ID']>;
  color?: Maybe<Scalars['ID']>;
  returnorderh?: Maybe<Scalars['ID']>;
  discount?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateReturnorderdInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditReturnorderdInput>;
};

export type EditReturnorderdInput = {
  qty?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  product?: Maybe<Scalars['ID']>;
  color?: Maybe<Scalars['ID']>;
  returnorderh?: Maybe<Scalars['ID']>;
  discount?: Maybe<Scalars['Float']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteReturnorderdInput = {
  where?: Maybe<InputId>;
};

export type CreateReturnorderhInput = {
  data?: Maybe<ReturnorderhInput>;
};

export type ReturnorderhInput = {
  orderCode?: Maybe<Scalars['String']>;
  netAmt?: Maybe<Scalars['Float']>;
  user?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['ID']>;
  orderh?: Maybe<Scalars['ID']>;
  returnorderds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  reason?: Maybe<Enum_Returnorderh_Reason>;
  voucher?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateReturnorderhInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditReturnorderhInput>;
};

export type EditReturnorderhInput = {
  orderCode?: Maybe<Scalars['String']>;
  netAmt?: Maybe<Scalars['Float']>;
  user?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['ID']>;
  orderh?: Maybe<Scalars['ID']>;
  returnorderds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  reason?: Maybe<Enum_Returnorderh_Reason>;
  voucher?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteReturnorderhInput = {
  where?: Maybe<InputId>;
};

export type CreateReviewInput = {
  data?: Maybe<ReviewInput>;
};

export type ReviewInput = {
  review?: Maybe<Scalars['String']>;
  users_permissions_user?: Maybe<Scalars['ID']>;
  product?: Maybe<Scalars['ID']>;
  rating?: Maybe<Scalars['Int']>;
  orderh?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateReviewInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditReviewInput>;
};

export type EditReviewInput = {
  review?: Maybe<Scalars['String']>;
  users_permissions_user?: Maybe<Scalars['ID']>;
  product?: Maybe<Scalars['ID']>;
  rating?: Maybe<Scalars['Int']>;
  orderh?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteReviewInput = {
  where?: Maybe<InputId>;
};

export type CreateShippingdetailInput = {
  data?: Maybe<ShippingdetailInput>;
};

export type ShippingdetailInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  address1: Scalars['String'];
  address2: Scalars['String'];
  email: Scalars['String'];
  city?: Maybe<Scalars['ID']>;
  tele1: Scalars['String'];
  tele2?: Maybe<Scalars['String']>;
  useForPayments?: Maybe<Scalars['Boolean']>;
  orderh?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['ID']>;
  guestid?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateShippingdetailInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditShippingdetailInput>;
};

export type EditShippingdetailInput = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['ID']>;
  tele1?: Maybe<Scalars['String']>;
  tele2?: Maybe<Scalars['String']>;
  useForPayments?: Maybe<Scalars['Boolean']>;
  orderh?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['ID']>;
  guestid?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteShippingdetailInput = {
  where?: Maybe<InputId>;
};

export type CreateStatusInput = {
  data?: Maybe<StatusInput>;
};

export type StatusInput = {
  type?: Maybe<Scalars['String']>;
  billingdetails?: Maybe<Array<Maybe<Scalars['ID']>>>;
  paymentselections?: Maybe<Array<Maybe<Scalars['ID']>>>;
  shippingdetails?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderhs?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderhistories?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateStatusInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditStatusInput>;
};

export type EditStatusInput = {
  type?: Maybe<Scalars['String']>;
  billingdetails?: Maybe<Array<Maybe<Scalars['ID']>>>;
  paymentselections?: Maybe<Array<Maybe<Scalars['ID']>>>;
  shippingdetails?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderhs?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderhistories?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteStatusInput = {
  where?: Maybe<InputId>;
};

export type CreateStoreInput = {
  data?: Maybe<StoreInput>;
};

export type StoreInput = {
  storeName: Scalars['String'];
  products?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateStoreInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditStoreInput>;
};

export type EditStoreInput = {
  storeName?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteStoreInput = {
  where?: Maybe<InputId>;
};

export type CreateVoucherInput = {
  data?: Maybe<VoucherInput>;
};

export type VoucherInput = {
  code?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  orderh?: Maybe<Scalars['ID']>;
  returnorderh?: Maybe<Scalars['ID']>;
  price?: Maybe<Scalars['Float']>;
  orderd?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  validMonth?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  isPercentage?: Maybe<Scalars['Boolean']>;
  voucherhistories?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateVoucherInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditVoucherInput>;
};

export type EditVoucherInput = {
  code?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  orderh?: Maybe<Scalars['ID']>;
  returnorderh?: Maybe<Scalars['ID']>;
  price?: Maybe<Scalars['Float']>;
  orderd?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  validMonth?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  isPercentage?: Maybe<Scalars['Boolean']>;
  voucherhistories?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteVoucherInput = {
  where?: Maybe<InputId>;
};

export type CreateVoucherhistoryInput = {
  data?: Maybe<VoucherhistoryInput>;
};

export type VoucherhistoryInput = {
  desp?: Maybe<Scalars['String']>;
  users_permissions_user?: Maybe<Scalars['ID']>;
  voucher?: Maybe<Scalars['ID']>;
  data?: Maybe<Scalars['JSON']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateVoucherhistoryInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditVoucherhistoryInput>;
};

export type EditVoucherhistoryInput = {
  desp?: Maybe<Scalars['String']>;
  users_permissions_user?: Maybe<Scalars['ID']>;
  voucher?: Maybe<Scalars['ID']>;
  data?: Maybe<Scalars['JSON']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteVoucherhistoryInput = {
  where?: Maybe<InputId>;
};

export type CreateWarrantyInput = {
  data?: Maybe<WarrantyInput>;
};

export type WarrantyInput = {
  warranty?: Maybe<Scalars['String']>;
  inactive?: Maybe<Scalars['Boolean']>;
  products?: Maybe<Array<Maybe<Scalars['ID']>>>;
  color_cats?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateWarrantyInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditWarrantyInput>;
};

export type EditWarrantyInput = {
  warranty?: Maybe<Scalars['String']>;
  inactive?: Maybe<Scalars['Boolean']>;
  products?: Maybe<Array<Maybe<Scalars['ID']>>>;
  color_cats?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteWarrantyInput = {
  where?: Maybe<InputId>;
};

export type CreateWebContentInput = {
  data?: Maybe<WebContentInput>;
};

export type WebContentInput = {
  title?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  desp?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
  isLeft?: Maybe<Scalars['Boolean']>;
  mobileImage?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  mobileColor?: Maybe<Scalars['String']>;
  imageOnly?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateWebContentInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditWebContentInput>;
};

export type EditWebContentInput = {
  title?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  desp?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
  isLeft?: Maybe<Scalars['Boolean']>;
  mobileImage?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  mobileColor?: Maybe<Scalars['String']>;
  imageOnly?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteWebContentInput = {
  where?: Maybe<InputId>;
};

export type CreateWishListInput = {
  data?: Maybe<WishListInput>;
};

export type WishListInput = {
  user?: Maybe<Scalars['ID']>;
  product?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateWishListInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditWishListInput>;
};

export type EditWishListInput = {
  user?: Maybe<Scalars['ID']>;
  product?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteWishListInput = {
  where?: Maybe<InputId>;
};

export type DeleteFileInput = {
  where?: Maybe<InputId>;
};

export type CreateRoleInput = {
  data?: Maybe<RoleInput>;
};

export type RoleInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateRoleInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditRoleInput>;
};

export type EditRoleInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteRoleInput = {
  where?: Maybe<InputId>;
};

export type CreateUserInput = {
  data?: Maybe<UserInput>;
};

export type UserInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  tele?: Maybe<Scalars['String']>;
  carts?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderhs?: Maybe<Array<Maybe<Scalars['ID']>>>;
  customer?: Maybe<Scalars['ID']>;
  shippingdetails?: Maybe<Array<Maybe<Scalars['ID']>>>;
  billingdetails?: Maybe<Array<Maybe<Scalars['ID']>>>;
  paymentselections?: Maybe<Array<Maybe<Scalars['ID']>>>;
  wish_lists?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  initialDiscount?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateUserInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditUserInput>;
};

export type EditUserInput = {
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  tele?: Maybe<Scalars['String']>;
  carts?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderhs?: Maybe<Array<Maybe<Scalars['ID']>>>;
  customer?: Maybe<Scalars['ID']>;
  shippingdetails?: Maybe<Array<Maybe<Scalars['ID']>>>;
  billingdetails?: Maybe<Array<Maybe<Scalars['ID']>>>;
  paymentselections?: Maybe<Array<Maybe<Scalars['ID']>>>;
  wish_lists?: Maybe<Array<Maybe<Scalars['ID']>>>;
  orderds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  initialDiscount?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteUserInput = {
  where?: Maybe<InputId>;
};

export type CreateGuestBillingInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  tele1: Scalars['String'];
  tele2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
};

export type OrderItem = {
  id: Scalars['ID'];
  itemName: Scalars['String'];
  selected: Scalars['Boolean'];
};

export type CreateGuestPaymentselectionInput = {
  method: Scalars['String'];
  deliveryMethod: Scalars['String'];
  senderName?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
};

export type CreateProductInputExtend = {
  data?: Maybe<ProductInputExtend>;
};

export type ProductInputExtend = {
  productCode: Scalars['String'];
  serialNo: Scalars['String'];
  productName: Scalars['String'];
  material: Scalars['ID'];
  brand?: Maybe<Scalars['ID']>;
  warranty?: Maybe<Scalars['ID']>;
  category?: Maybe<Scalars['ID']>;
  featuredItem?: Maybe<Scalars['Boolean']>;
  inactive?: Maybe<Scalars['Boolean']>;
  isVoucher?: Maybe<Scalars['Boolean']>;
  productDescription: Scalars['String'];
  spec?: Maybe<Scalars['String']>;
  productimages?: Maybe<Array<Maybe<ProductimageInput>>>;
  store?: Maybe<Scalars['ID']>;
  color_cats?: Maybe<Array<Maybe<ColorCat1>>>;
};

export type ColorCat1 = {
  id?: Maybe<Scalars['String']>;
  colorCode?: Maybe<Scalars['String']>;
  color?: Maybe<ColName>;
  colorPrice?: Maybe<Scalars['Float']>;
  colorDiscount?: Maybe<Scalars['Float']>;
  colorStock?: Maybe<Scalars['Float']>;
  img?: Maybe<Scalars['String']>;
  color_images?: Maybe<Array<Maybe<ColImg>>>;
  warranty?: Maybe<Warranties>;
  material?: Maybe<Scalars['String']>;
  closure_type?: Maybe<Scalars['String']>;
  lockable?: Maybe<Scalars['String']>;
  laptop_com?: Maybe<Scalars['String']>;
  laptop_size?: Maybe<Scalars['String']>;
  p_length?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
  inActive?: Maybe<Scalars['Boolean']>;
  featured?: Maybe<Scalars['Boolean']>;
  included?: Maybe<Scalars['String']>;
};

export type ColName = {
  id?: Maybe<Scalars['String']>;
  colorName?: Maybe<Scalars['String']>;
};

export type ColImg = {
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
};

export type Warranties = {
  id?: Maybe<Scalars['String']>;
  warranty?: Maybe<Scalars['String']>;
};

export type UpdateProductInputExtend = {
  where?: Maybe<InputId>;
  data?: Maybe<ProductInputExtend>;
};

export type CreateGuestShippingInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  tele1: Scalars['String'];
  tele2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  useForPayments: Scalars['Boolean'];
};


export type FileInfoInput = {
  name?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  reCaptcha: Scalars['String'];
};

export type UsersPermissionsRegisterInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  reCaptcha: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type AdminUser = {
  __typename?: 'AdminUser';
  id: Scalars['ID'];
  username?: Maybe<Scalars['String']>;
  firstname: Scalars['String'];
  lastname: Scalars['String'];
};

export enum CacheControlScope {
  Public = 'PUBLIC',
  Private = 'PRIVATE'
}

export type FileInput = {
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};


export type EditFileInput = {
  name?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash?: Maybe<Scalars['String']>;
  ext?: Maybe<Scalars['String']>;
  mime?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  previewUrl?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};


export const AlocateDeliveriesDocument = gql`
    mutation AlocateDeliveries($deliveryPerson: ID!, $orderItems: [OrderItem!]!, $orderh: String!) {
  alocateDeliveries(deliveryPerson: $deliveryPerson, orderItems: $orderItems, orderh: $orderh)
}
    `;
export type AlocateDeliveriesMutationFn = Apollo.MutationFunction<AlocateDeliveriesMutation, AlocateDeliveriesMutationVariables>;

/**
 * __useAlocateDeliveriesMutation__
 *
 * To run a mutation, you first call `useAlocateDeliveriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlocateDeliveriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alocateDeliveriesMutation, { data, loading, error }] = useAlocateDeliveriesMutation({
 *   variables: {
 *      deliveryPerson: // value for 'deliveryPerson'
 *      orderItems: // value for 'orderItems'
 *      orderh: // value for 'orderh'
 *   },
 * });
 */
export function useAlocateDeliveriesMutation(baseOptions?: Apollo.MutationHookOptions<AlocateDeliveriesMutation, AlocateDeliveriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AlocateDeliveriesMutation, AlocateDeliveriesMutationVariables>(AlocateDeliveriesDocument, options);
      }
export type AlocateDeliveriesMutationHookResult = ReturnType<typeof useAlocateDeliveriesMutation>;
export type AlocateDeliveriesMutationResult = Apollo.MutationResult<AlocateDeliveriesMutation>;
export type AlocateDeliveriesMutationOptions = Apollo.BaseMutationOptions<AlocateDeliveriesMutation, AlocateDeliveriesMutationVariables>;
export const UpdateDeliveryPersonDocument = gql`
    mutation UpdateDeliveryPerson($input: updateUserInput) {
  updateUser(input: $input) {
    user {
      id
    }
  }
}
    `;
export type UpdateDeliveryPersonMutationFn = Apollo.MutationFunction<UpdateDeliveryPersonMutation, UpdateDeliveryPersonMutationVariables>;

/**
 * __useUpdateDeliveryPersonMutation__
 *
 * To run a mutation, you first call `useUpdateDeliveryPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliveryPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliveryPersonMutation, { data, loading, error }] = useUpdateDeliveryPersonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDeliveryPersonMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeliveryPersonMutation, UpdateDeliveryPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeliveryPersonMutation, UpdateDeliveryPersonMutationVariables>(UpdateDeliveryPersonDocument, options);
      }
export type UpdateDeliveryPersonMutationHookResult = ReturnType<typeof useUpdateDeliveryPersonMutation>;
export type UpdateDeliveryPersonMutationResult = Apollo.MutationResult<UpdateDeliveryPersonMutation>;
export type UpdateDeliveryPersonMutationOptions = Apollo.BaseMutationOptions<UpdateDeliveryPersonMutation, UpdateDeliveryPersonMutationVariables>;
export const UpdateDeliveryStatusDocument = gql`
    mutation UpdateDeliveryStatus($orderId: String!, $status: String!, $store: ID) {
  updateDeliveryStatus(orderId: $orderId, status: $status, store: $store)
}
    `;
export type UpdateDeliveryStatusMutationFn = Apollo.MutationFunction<UpdateDeliveryStatusMutation, UpdateDeliveryStatusMutationVariables>;

/**
 * __useUpdateDeliveryStatusMutation__
 *
 * To run a mutation, you first call `useUpdateDeliveryStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliveryStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliveryStatusMutation, { data, loading, error }] = useUpdateDeliveryStatusMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      status: // value for 'status'
 *      store: // value for 'store'
 *   },
 * });
 */
export function useUpdateDeliveryStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeliveryStatusMutation, UpdateDeliveryStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeliveryStatusMutation, UpdateDeliveryStatusMutationVariables>(UpdateDeliveryStatusDocument, options);
      }
export type UpdateDeliveryStatusMutationHookResult = ReturnType<typeof useUpdateDeliveryStatusMutation>;
export type UpdateDeliveryStatusMutationResult = Apollo.MutationResult<UpdateDeliveryStatusMutation>;
export type UpdateDeliveryStatusMutationOptions = Apollo.BaseMutationOptions<UpdateDeliveryStatusMutation, UpdateDeliveryStatusMutationVariables>;
export const DeliveryPersonOrdersDocument = gql`
    query DeliveryPersonOrders {
  deliveryPersonOrders {
    id
    orderCode
    statusId
    status
  }
}
    `;

/**
 * __useDeliveryPersonOrdersQuery__
 *
 * To run a query within a React component, call `useDeliveryPersonOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryPersonOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryPersonOrdersQuery({
 *   variables: {
 *   },
 * });
 */
export function useDeliveryPersonOrdersQuery(baseOptions?: Apollo.QueryHookOptions<DeliveryPersonOrdersQuery, DeliveryPersonOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliveryPersonOrdersQuery, DeliveryPersonOrdersQueryVariables>(DeliveryPersonOrdersDocument, options);
      }
export function useDeliveryPersonOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliveryPersonOrdersQuery, DeliveryPersonOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliveryPersonOrdersQuery, DeliveryPersonOrdersQueryVariables>(DeliveryPersonOrdersDocument, options);
        }
export type DeliveryPersonOrdersQueryHookResult = ReturnType<typeof useDeliveryPersonOrdersQuery>;
export type DeliveryPersonOrdersLazyQueryHookResult = ReturnType<typeof useDeliveryPersonOrdersLazyQuery>;
export type DeliveryPersonOrdersQueryResult = Apollo.QueryResult<DeliveryPersonOrdersQuery, DeliveryPersonOrdersQueryVariables>;
export const DeliveryUsersDocument = gql`
    query DeliveryUsers($sort: String, $limit: Int, $start: Int, $where: JSON) {
  usersConnection(start: $start, limit: $limit, sort: $sort, where: $where) {
    aggregate {
      totalCount
    }
    values {
      id
      username
      tele
    }
  }
}
    `;

/**
 * __useDeliveryUsersQuery__
 *
 * To run a query within a React component, call `useDeliveryUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryUsersQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeliveryUsersQuery(baseOptions?: Apollo.QueryHookOptions<DeliveryUsersQuery, DeliveryUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliveryUsersQuery, DeliveryUsersQueryVariables>(DeliveryUsersDocument, options);
      }
export function useDeliveryUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliveryUsersQuery, DeliveryUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliveryUsersQuery, DeliveryUsersQueryVariables>(DeliveryUsersDocument, options);
        }
export type DeliveryUsersQueryHookResult = ReturnType<typeof useDeliveryUsersQuery>;
export type DeliveryUsersLazyQueryHookResult = ReturnType<typeof useDeliveryUsersLazyQuery>;
export type DeliveryUsersQueryResult = Apollo.QueryResult<DeliveryUsersQuery, DeliveryUsersQueryVariables>;
export const OrderItemsDocument = gql`
    query OrderItems($sort: String, $limit: Int, $start: Int, $where: JSON) {
  orderds(sort: $sort, limit: $limit, start: $start, where: $where) {
    id
    qty
    price
    color {
      id
      colorName
    }
    product {
      id
      productName
      color_cats {
        id
        color {
          id
          colorName
        }
      }
      category {
        categoryName
      }
    }
    deliveryPerson {
      id
      username
    }
  }
}
    `;

/**
 * __useOrderItemsQuery__
 *
 * To run a query within a React component, call `useOrderItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderItemsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOrderItemsQuery(baseOptions?: Apollo.QueryHookOptions<OrderItemsQuery, OrderItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderItemsQuery, OrderItemsQueryVariables>(OrderItemsDocument, options);
      }
export function useOrderItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderItemsQuery, OrderItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderItemsQuery, OrderItemsQueryVariables>(OrderItemsDocument, options);
        }
export type OrderItemsQueryHookResult = ReturnType<typeof useOrderItemsQuery>;
export type OrderItemsLazyQueryHookResult = ReturnType<typeof useOrderItemsLazyQuery>;
export type OrderItemsQueryResult = Apollo.QueryResult<OrderItemsQuery, OrderItemsQueryVariables>;
export const OrderDocument = gql`
    query Order($id: ID!) {
  orderh(id: $id) {
    id
    created_at
    netAmt
    orderCode
    paidAmount
    user {
      id
      email
    }
    status {
      id
      type
    }
    cardName
    orderds {
      id
      qty
      price
      color {
        id
        colorName
      }
      product {
        productName
        color_cats {
          id
          colorCode
          color {
            id
            colorName
          }
        }
      }
      deliveryPerson {
        id
        username
      }
      status
      orderd_package_items {
        id
        product {
          productName
        }
        color {
          id
          colorName
        }
      }
    }
    shippingdetails {
      id
      firstName
      lastName
      address1
      address2
      email
      city {
        id
        cityName
      }
      tele1
      tele2
    }
    billingdetails {
      id
      firstName
      lastName
      address1
      address2
      email
      city {
        id
        cityName
      }
      tele1
      tele2
    }
    paymentselections {
      id
      method
      deliveryMethod
      senderName
      note
    }
  }
}
    `;

/**
 * __useOrderQuery__
 *
 * To run a query within a React component, call `useOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderQuery(baseOptions: Apollo.QueryHookOptions<OrderQuery, OrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
      }
export function useOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderQuery, OrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
        }
export type OrderQueryHookResult = ReturnType<typeof useOrderQuery>;
export type OrderLazyQueryHookResult = ReturnType<typeof useOrderLazyQuery>;
export type OrderQueryResult = Apollo.QueryResult<OrderQuery, OrderQueryVariables>;
export const StoresDocument = gql`
    query Stores($sort: String, $limit: Int, $start: Int, $where: JSON) {
  stores(start: $start, limit: $limit, sort: $sort, where: $where) {
    id
    storeName
  }
}
    `;

/**
 * __useStoresQuery__
 *
 * To run a query within a React component, call `useStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoresQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useStoresQuery(baseOptions?: Apollo.QueryHookOptions<StoresQuery, StoresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoresQuery, StoresQueryVariables>(StoresDocument, options);
      }
export function useStoresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoresQuery, StoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoresQuery, StoresQueryVariables>(StoresDocument, options);
        }
export type StoresQueryHookResult = ReturnType<typeof useStoresQuery>;
export type StoresLazyQueryHookResult = ReturnType<typeof useStoresLazyQuery>;
export type StoresQueryResult = Apollo.QueryResult<StoresQuery, StoresQueryVariables>;
export type AlocateDeliveriesMutationVariables = Exact<{
  deliveryPerson: Scalars['ID'];
  orderItems: Array<OrderItem> | OrderItem;
  orderh: Scalars['String'];
}>;


export type AlocateDeliveriesMutation = { __typename?: 'Mutation', alocateDeliveries: boolean };

export type UpdateDeliveryPersonMutationVariables = Exact<{
  input?: Maybe<UpdateUserInput>;
}>;


export type UpdateDeliveryPersonMutation = { __typename?: 'Mutation', updateUser?: Maybe<{ __typename?: 'updateUserPayload', user?: Maybe<{ __typename?: 'UsersPermissionsUser', id: string }> }> };

export type UpdateDeliveryStatusMutationVariables = Exact<{
  orderId: Scalars['String'];
  status: Scalars['String'];
  store?: Maybe<Scalars['ID']>;
}>;


export type UpdateDeliveryStatusMutation = { __typename?: 'Mutation', updateDeliveryStatus: boolean };

export type DeliveryPersonOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type DeliveryPersonOrdersQuery = { __typename?: 'Query', deliveryPersonOrders: Array<Maybe<{ __typename?: 'DeliveryOrder', id: string, orderCode: string, statusId: number, status: string }>> };

export type DeliveryUsersQueryVariables = Exact<{
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type DeliveryUsersQuery = { __typename?: 'Query', usersConnection?: Maybe<{ __typename?: 'UsersPermissionsUserConnection', aggregate?: Maybe<{ __typename?: 'UsersPermissionsUserAggregator', totalCount?: Maybe<number> }>, values?: Maybe<Array<Maybe<{ __typename?: 'UsersPermissionsUser', id: string, username: string, tele?: Maybe<string> }>>> }> };

export type OrderItemsQueryVariables = Exact<{
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type OrderItemsQuery = { __typename?: 'Query', orderds?: Maybe<Array<Maybe<{ __typename?: 'Orderd', id: string, qty: number, price: number, color?: Maybe<{ __typename?: 'Color', id: string, colorName?: Maybe<string> }>, product?: Maybe<{ __typename?: 'Product', id: string, productName: string, color_cats?: Maybe<Array<Maybe<{ __typename?: 'ColorCat', id: string, color?: Maybe<{ __typename?: 'Color', id: string, colorName?: Maybe<string> }> }>>>, category?: Maybe<{ __typename?: 'Category', categoryName: string }> }>, deliveryPerson?: Maybe<{ __typename?: 'UsersPermissionsUser', id: string, username: string }> }>>> };

export type OrderQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OrderQuery = { __typename?: 'Query', orderh?: Maybe<{ __typename?: 'Orderh', id: string, created_at: any, netAmt: number, orderCode: string, cardName?: Maybe<string>, user?: Maybe<{ __typename?: 'UsersPermissionsUser', id: string, email: string }>, status?: Maybe<{ __typename?: 'Status', id: string, type?: Maybe<string> }>, orderds?: Maybe<Array<Maybe<{ __typename?: 'Orderd', id: string, qty: number, price: number, status?: Maybe<Enum_Orderd_Status>, color?: Maybe<{ __typename?: 'Color', id: string, colorName?: Maybe<string> }>, product?: Maybe<{ __typename?: 'Product', productName: string, color_cats?: Maybe<Array<Maybe<{ __typename?: 'ColorCat', id: string, colorCode?: Maybe<string>, color?: Maybe<{ __typename?: 'Color', id: string, colorName?: Maybe<string> }> }>>> }>, deliveryPerson?: Maybe<{ __typename?: 'UsersPermissionsUser', id: string, username: string }>, orderd_package_items?: Maybe<Array<Maybe<{ __typename?: 'OrderdPackageItem', id: string, product?: Maybe<{ __typename?: 'Product', productName: string }>, color?: Maybe<{ __typename?: 'Color', id: string, colorName?: Maybe<string> }> }>>> }>>>, shippingdetails?: Maybe<Array<Maybe<{ __typename?: 'Shippingdetail', id: string, firstName: string, lastName: string, address1: string, address2: string, email: string, tele1: string, tele2?: Maybe<string>, city?: Maybe<{ __typename?: 'City', id: string, cityName: string }> }>>>, billingdetails?: Maybe<Array<Maybe<{ __typename?: 'Billingdetail', id: string, firstName: string, lastName: string, address1: string, address2: string, email: string, tele1: string, tele2?: Maybe<string>, city?: Maybe<{ __typename?: 'City', id: string, cityName: string }> }>>>, paymentselections?: Maybe<Array<Maybe<{ __typename?: 'Paymentselection', id: string, method?: Maybe<Enum_Paymentselection_Method>, deliveryMethod?: Maybe<Enum_Paymentselection_Deliverymethod>, senderName?: Maybe<string>, note?: Maybe<string> }>>> }> };

export type StoresQueryVariables = Exact<{
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type StoresQuery = { __typename?: 'Query', stores?: Maybe<Array<Maybe<{ __typename?: 'Store', id: string, storeName: string }>>> };
